import type { Dict } from '../types';

export const fr: Dict = {
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in Open Design.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening Open Design so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open Open Design",
  'invite.open.opening': "Opening Open Design…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have Open Design installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download Open Design",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "Cet espace de travail n'a plus de sièges disponibles. Ajoutez des sièges pour inviter vos collègues.",
  "workspaceInvite.seatsExhaustedAction": "Voir les sièges et l'offre",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "Cet e-mail est déjà membre de l'équipe ou a une invitation en attente.",
  "workspaceInvite.errorNoSession": "Connectez-vous à votre compte Vela avant d'inviter des membres.",
  "workspaceInvite.errorNoWorkspace": "Il n'y a pas encore d'espace d'équipe où inviter des membres.",
  "workspaceInvite.errorUnreachable": "L'invitation n'a pas pu être envoyée. Veuillez réessayer plus tard.",
  'chat.amrCard.switchTitle': 'Échec de l\'appel du modèle — cette exécution est en pause',
  'chat.amrCard.switchBody': 'Passez au service de modèles Open Design Cloud officiel d\'Open Design Cloud — aucune clé API à configurer. Après connexion, autorisation et recharge, cette exécution sera relancée automatiquement.',
  'chat.amrCard.chipOfficial': 'Hébergement officiel',
  'chat.amrCard.chipNoKey': 'Sans clé API',
  'chat.amrCard.chipAutoRetry': 'Reprise automatique après connexion',
  'chat.amrCard.switchCta': 'Passer à Open Design Cloud et relancer',
  'chat.amrError.authMessage': 'Votre compte Open Design Cloud n\'est pas encore autorisé. Autorisez-le et cette exécution sera relancée automatiquement.',
  'chat.amrError.balanceMessage': 'Votre solde Open Design Cloud est épuisé. Rechargez pour poursuivre cette exécution.',
  'chat.amrError.authorizeCta': 'Autoriser et relancer',
  'chat.amrError.rechargeCta': 'Recharger',
  'chat.amrBalanceGate.title': 'Mettez à niveau pour continuer à créer',
  'chat.amrBalanceGate.message': 'Crédits insuffisants ({balance} restant). Passez à une offre supérieure ou rechargez, et la tâche pourra démarrer aussitôt.',
  'chat.amrBalanceGate.benefitsTitle': 'Ce que vous offre Open Design Cloud',
  'chat.amrBalanceGate.benefit1': 'Sans clé API — un large choix de modèles',
  'chat.amrBalanceGate.benefit2': 'Agent de design SOTA intégré, zéro configuration',
  'chat.amrBalanceGate.benefit3': 'Service officiel, fiable',
  'chat.amrBalanceGate.benefit4': 'En constante évolution : déploiement 1 clic, multimodal, équipes, etc.',
  'chat.amrBalanceGate.laterCta': 'Pas maintenant',
  'chat.amrBalanceGate.plansCta': 'Mettre à niveau',
  'chat.amrBalanceGate.signedOutTitle': 'Connectez-vous pour commencer à créer',
  'chat.amrBalanceGate.signedOutMessage': 'Vous utilisez l’agent Open Design Cloud — connectez-vous et cette tâche pourra démarrer aussitôt.',
  'chat.amrBalanceGate.signInCta': 'Se connecter',
  'chat.amrBalanceGate.watchingWallet': 'Nous continuerons automatiquement dès que votre solde sera mis à jour.',
  'chat.amrLowBalance.title': 'Crédits bientôt épuisés',
  'chat.amrLowBalance.message': 'Il ne reste que {balance} — probablement pas assez pour terminer cette tâche. Rechargez ou passez à une offre supérieure d’abord.',
  'chat.amrLowBalance.rechargeCta': 'Recharger',
  'chat.amrLowBalance.proceedCta': 'Lancer quand même',
  'chat.amrLowBalance.dontRemind': 'Ne plus demander',
  'chat.amrArtifactUpgrade.title': 'Continuez à affiner avec des modèles plus puissants',
  'chat.amrArtifactUpgrade.message': 'Débloquez des modèles avancés, plus de tâches en parallèle et plus de crédits mensuels.',
  'chat.amrArtifactUpgrade.benefit1': 'Plus de modèles avancés, dont Fable 5 et GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Jusqu’à 10 fois plus de tâches en parallèle',
  'chat.amrArtifactUpgrade.benefit3': 'Jusqu’à 300 fois plus de crédits mensuels',
  'chat.amrArtifactUpgrade.benefit4': 'File prioritaire aux heures de pointe pour générer plus vite',
  'chat.amrArtifactUpgrade.promoBanner': 'Offre limitée : jusqu’à 67 % de réduction sur les abonnements',
  'chat.amrArtifactUpgrade.countdownLabel': 'Fin de l’offre dans',
  'chat.amrArtifactUpgrade.plansCta': 'Passez à l’offre supérieure, jusqu’à 67 % de réduction',
  'chat.amrArtifactUpgrade.homePlansCta': 'Économisez 67 %',
  'chat.amrArtifactUpgrade.laterCta': 'Continuer avec Free et envoyer',
  'chat.amrArtifactUpgrade.homeTitle': 'Votre création est prête. Allez plus loin avec la prochaine idée.',
  'chat.amrArtifactUpgrade.homeMessage': 'Passez à l’offre supérieure pour des modèles plus puissants, plus de tâches et plus de crédits.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'Voir la création',
  'chat.antigravityError.launchTerminalCta': 'Se connecter via le terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Changer de modèle dans le terminal',
  'chat.connectionDropped': 'La connexion au service de modèle a été interrompue avant la fin de la réponse — généralement un réseau ou un proxy instable. Veuillez réessayer.',
  'chat.runError.title.authRequired': 'Autorisation requise',
  'chat.runError.title.balance': 'Solde insuffisant',
  'chat.runError.title.connectionDropped': 'Connexion interrompue',
  'chat.runError.title.signInRequired': 'Connexion requise',
  'chat.runError.title.rateLimited': 'Limite d’utilisation atteinte',
  'chat.runError.title.generic': 'Échec de la tâche',
  'chat.runError.title.artifactMissing': 'Aucun livrable généré',
  'chat.runError.signInMessage.amr': 'L\'agent Open Design Cloud n\'est pas encore connecté — connectez-vous pour l\'utiliser.',
  'chat.runError.signInMessage.other': '{agent} n\'est pas connecté. Vérifiez son état de connexion en local. Nous recommandons l\'agent Open Design Cloud — plus stable et plus économique.',
  'chat.runError.agentFallback': 'l\'agent',
  'chat.runError.sourceLabel': 'Détails de l’erreur',
  'chat.runError.sourceExpandAria': 'Afficher la source de l’erreur',
  'chat.runError.sourceCollapseAria': 'Masquer la source de l’erreur',
  'chat.runError.title.cliMissing': 'Agent non installé',
  'chat.runError.title.promptTooLarge': 'Entrée trop longue',
  'chat.runError.title.modelUnavailable': 'Modèle indisponible',
  'chat.runError.title.upstreamUnavailable': 'Service temporairement indisponible',
  'chat.runError.title.toolLoop': 'Bloqué dans une boucle',
  'chat.runError.title.outputInvalid': 'Sortie du modèle invalide',
  'chat.runError.title.runtimeConfig': 'Erreur de configuration',
  'chat.runError.cliMissingMessage': 'L’outil en ligne de commande de {agent} est introuvable. Installez-le et assurez-vous qu’il figure dans le PATH, puis réessayez.',
  'chat.runError.promptTooLargeMessage': 'Ce tour a dépassé la limite de contexte du modèle. Raccourcissez votre message, retirez des pièces jointes ou démarrez une nouvelle conversation, puis réessayez.',
  'chat.runError.modelUnavailableMessage': 'Le modèle sélectionné est indisponible ou inexistant. Passez à un autre modèle dans les Paramètres, puis réessayez.',
  'chat.runError.rateLimitedMessage': 'Vous avez atteint la limite d’utilisation du service de modèle. Patientez un instant et réessayez, ou changez de modèle ou de service.',
  'chat.runError.upstreamUnavailableMessage': 'Le service de modèle est temporairement indisponible, généralement en raison d’une instabilité en amont ou d’un problème réseau/proxy. Réessayez dans un instant.',
  'chat.runError.toolLoopMessage': '{agent} a répété la même action sans progresser et a été arrêté. Vérifiez le fichier ou la commande cible, puis réessayez.',
  'chat.runError.outputInvalidMessage': 'Le modèle a produit une sortie invalide et ce tour a été interrompu. Réessayer suffit généralement.',
  'chat.runError.runtimeConfigMessage': 'La configuration d’exécution de l’agent sélectionné est invalide, l’exécution n’a donc pas pu démarrer. Mettez à jour vers la dernière version ou contactez le support.',
  'chat.runError.title.quotaExhausted': "Quota épuisé",
  'chat.runError.title.timedOut': "Délai dépassé",
  'chat.runError.title.emptyOutput': "Aucune sortie",
  'chat.runError.title.sessionExpired': "Session expirée",
  'chat.runError.title.gitBashMissing': "Git Bash manquant",
  'chat.runError.title.cpuUnsupported': "Processeur non pris en charge",
  'chat.runError.quotaExhaustedMessage': "Le quota ou la limite de facturation de votre service de modèle est épuisé ; réessayer ne changera rien. Rechargez chez votre fournisseur ou passez à un autre modèle ou service.",
  'chat.runError.workspaceCreditsMessage': "Votre espace de travail n'a plus de crédits. Ajoutez des crédits (ou demandez au propriétaire de l'espace de recharger), ou passez à un autre modèle ou service.",
  'chat.runError.timedOutMessage': "Cette exécution a été trop longue et a été arrêtée. Réessayez, ou réduisez la tâche puis relancez.",
  'chat.runError.inactivityTimeoutMessage': "L'agent est resté silencieux trop longtemps et a été arrêté pour dépassement de délai. Réessayer suffit généralement à le relancer.",
  'chat.runError.emptyOutputMessage': "L'agent s'est terminé sans produire de sortie. C'est généralement temporaire, réessayez.",
  'chat.runError.sessionExpiredMessage': "La session reprise avait expiré. Elle a été réinitialisée : réessayez pour démarrer une nouvelle exécution.",
  'chat.runError.gitBashMissingMessage': "Git Bash est requis pour exécuter cet agent sous Windows, mais il est introuvable. Installez Git pour Windows, puis réessayez.",
  'chat.runError.cpuUnsupportedMessage': "L'environnement d'exécution de cet agent nécessite un jeu d'instructions CPU (AVX2) dont cet appareil ne dispose pas, il ne peut donc pas démarrer. Mettez à jour Open Design vers la dernière version, qui inclut un environnement d'exécution compatible.",
  'common.cancel': 'Annuler',
  'chat.selectFromLibrary': 'Importer depuis la bibliothèque',
  'chat.importFigma': 'Importer depuis Figma',
  'chat.plus.group.files': 'Fichiers',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Autre',
  'chat.plus.attachFiles': 'Joindre des fichiers',
  'chat.plus.referenceProject': 'Référencer un autre projet',
  'chat.plus.linkLocalCode': 'Lier du code local',
  'chat.plus.uploadFig': 'Importer un fichier .fig',
  'chat.plus.learnHow': 'En savoir plus',
  'chat.plus.designSystem': 'Système de design',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'Aucun skill disponible',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Référencer un autre projet',
  'chat.referenceProject.search': 'Rechercher des projets…',
  'chat.referenceProject.empty': 'Aucun projet ne correspond à « {query} »',
  'chat.referenceProject.emptyAll': 'Aucun autre projet pour le moment',
  'chat.referenceProject.loadFailed': 'Impossible de charger les projets. Vérifiez que le daemon fonctionne, puis réessayez.',
  'chat.referenceProject.confirm': 'Référencer le projet',
  'chat.contextPrompt.referenceProject': 'Utilise le projet Open Design « {name} » comme contexte de référence. Son chemin local est : {path}. Avant de concevoir ou modifier quoi que ce soit, cherche et lis ce dossier lorsque c’est utile.',
  'chat.contextPrompt.localCode': 'Utilise le dossier de code local « {name} » comme référence de code. Son chemin absolu est : {path}. Lis les fichiers pertinents lorsque c’est utile et reste cohérent avec l’implémentation existante.',
  'chat.figmaHelp.title': 'Comment télécharger un fichier .fig',
  'chat.figmaHelp.intro': 'Depuis l’app web ou desktop de Figma :',
  'chat.figmaHelp.step1': 'Ouvrez le fichier dans Figma.',
  'chat.figmaHelp.step2': 'Allez dans File → Save local copy… (web : menu principal → File).',
  'chat.figmaHelp.step3': 'Figma télécharge un fichier .fig. Déposez-le dans le composeur ou importez-le.',
  'chat.figmaHelp.note': 'Le fichier .fig est analysé localement et n’est pas téléversé vers Figma.',
  'designFiles.library.label': 'Importer depuis la bibliothèque',
  'designFiles.library.title': 'Importer depuis la bibliothèque',
  'libraryPicker.title': 'Importer depuis la bibliothèque',
  'libraryPicker.searchPlaceholder': 'Rechercher dans la bibliothèque…',
  'libraryPicker.empty': 'Aucune ressource dans votre bibliothèque',
  'libraryPicker.allKinds': 'Tous',
  'libraryPicker.add': 'Importer',
  'libraryPicker.loading': 'Chargement…',
  'common.save': 'Enregistrer',
  'common.close': 'Fermer',
  'common.clear': 'Effacer',
  'common.delete': 'Supprimer',
  'common.rename': 'Renommer',
  'common.edit': 'Modifier',
  'common.preview': 'Aperçu',
  'common.share': 'Partager',
  'common.search': 'Rechercher',
  'common.searchEllipsis': 'Rechercher…',
  'common.loading': 'Chargement…',
  'common.all': 'Tout',
  'common.none': 'Aucun',
  'common.default': 'Par défaut',
  'common.installed': 'installé',
  'common.notInstalled': 'non installé',
  'common.active': 'actif',
  'common.inactive': 'inactif',
  'common.offline': 'hors ligne',
  'common.selected': 'sélectionné',
  'common.create': 'Créer',
  'common.openPreview': 'Ouvrir l\'aperçu',
  'common.exitFullscreen': 'Quitter le plein écran',
  'common.fullscreen': 'Plein écran',
  'common.openInNewTab': 'Ouvrir dans un nouvel onglet',
  'common.exportPdf': 'Exporter en PDF',
  'common.exportZip': 'Télécharger en .zip',
  'common.exportHtml': 'Exporter en HTML autonome',
  'common.exportImage': 'Exporter en image',
  'common.exportImageFailed': 'Échec de la capture d\'image. Veuillez réessayer ou utiliser l\'outil de capture d\'écran de votre navigateur.',
  'common.justNow': 'à l\'instant',
  'common.minutesAgo': 'il y a {n} min',
  'common.hoursAgo': 'il y a {n} h',
  'common.daysAgo': 'il y a {n} j',
  'common.weeksAgo': 'il y a {n} sem.',
  'common.now': 'maintenant',
  'common.minutesShort': '{n} min',
  'common.hoursShort': '{n} h',
  'common.daysShort': '{n} j',
  'common.untitled': 'Sans titre',
  'designBrowser.savePageBrief': 'Enregistrer le brief de page',
  'designBrowser.viewport.desktop': 'Bureau',
  'designBrowser.viewport.desktopTitle': 'Utiliser toute la taille de l\'onglet',
  'designBrowser.viewport.tablet': 'Tablette',
  'designBrowser.viewport.tabletTitle': 'Aperçu à 820 px de large',
  'designBrowser.viewport.mobile': 'Mobile',
  'designBrowser.viewport.mobileTitle': 'Aperçu à 390 px de large',
  'designBrowser.menu': 'Menu du navigateur',
  'designBrowser.copyScreenshot': 'Copier la capture d’écran',
  'designBrowser.hardReload': 'Rechargement forcé',
  'designBrowser.copyUrl': 'Copier l’URL',
  'designBrowser.openExternal': 'Ouvrir en externe',
  'designBrowser.downloadPage': 'Télécharger la page',
  'designBrowser.downloadPageBusy': 'Téléchargement de la page…',
  'designBrowser.clearHistory': 'Effacer l’historique',
  'designBrowser.clearCookies': 'Effacer les cookies',
  'designBrowser.clearAllData': 'Effacer toutes les données du navigateur',
  'designBrowser.status.noUrlToCopy': 'Aucune URL à copier.',
  'designBrowser.status.urlCopied': 'URL copiée.',
  'designBrowser.status.openHttpFirst': 'Ouvrez d’abord une page http ou https.',
  'designBrowser.status.openBeforeScreenshot': 'Ouvrez une page avant de prendre une capture d’écran.',
  'designBrowser.status.screenshotSaved': 'Capture d’écran enregistrée.',
  'designBrowser.addImageToChatButton': 'Ajouter au chat',
  'designBrowser.status.imageAddedToChat': 'Image ajoutée au chat.',
  'designBrowser.status.screenshotFailed': 'Échec de la capture d’écran.',
  'designBrowser.status.openBeforeBrief': 'Ouvrez une page avant d’enregistrer un brief.',
  'designBrowser.status.briefSaveFailed': 'Échec de l’enregistrement du brief de page.',
  'designBrowser.status.openBeforeDownload': 'Ouvrez une page avant d’enregistrer un instantané.',
  'designBrowser.status.pageSnapshotStarted': 'Enregistrement de l’instantané de page…',
  'designBrowser.status.pageSnapshotUnsupported': 'Cette page ne peut pas être archivée.',
  'designBrowser.status.pageSnapshotFailed': 'Échec de l’enregistrement de l’instantané de page.',
  'designBrowser.status.pageSnapshotSaved': 'Instantané de page enregistré (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'Voir les fichiers de design',
  'designBrowser.status.downloadAssistHint': 'Lorsque la page est prête, cliquez sur Télécharger la page. Revenez au chat une fois l’enregistrement terminé.',
  'designBrowser.status.desktopDataUnavailable': 'Les données du navigateur desktop ne sont pas disponibles ici.',
  'designBrowser.status.browserDataCleared': 'Données du navigateur effacées.',
  'designBrowser.status.browserDataClearFailed': 'Échec de l’effacement des données du navigateur.',
  'designBrowser.status.historyCleared': 'Historique effacé.',
  'plugins.availableDetails.provenance': 'Provenance',
  'plugins.availableDetails.provenanceLine': 'depuis {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'depuis {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Installer',
  'plugins.availableDetails.version': 'Version',
  'plugins.availableDetails.pluginVersion': 'Version du plugin',
  'plugins.availableDetails.copyInstallCommand': 'Copier la commande d’installation',
  'plugins.availableDetails.copied': 'Copié',
  'plugins.availableDetails.deprecatedPrefix': 'Déprécié : {message}',
  'plugins.availableDetails.deprecatedFallback': 'Cette version a été marquée comme dépréciée.',
  'plugins.availableDetails.yanked': 'Retiré.',
  'plugins.availableDetails.yankedWithReason': 'Retiré : {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (dépréciée)',
  'plugins.availableDetails.versionYankedSuffix': ' (retirée)',
  'plugins.availableDetails.ref': 'Réf.',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Autorisations',
  'plugins.availableDetails.capabilitySummary': 'Résumé des capacités',
  'plugins.actions.copyInstallCommand': 'Copier la commande d’installation',
  'plugins.actions.copyPluginId': 'Copier l’ID du plugin',
  'plugins.actions.copyReadmeBadge': 'Copier le badge README',
  'plugins.actions.openSourceGithub': 'Ouvrir la source sur GitHub',
  'plugins.actions.openSource': 'Ouvrir la source',
  'plugins.actions.openHomepage': 'Ouvrir la page d’accueil',
  'plugins.actions.openMarketplace': 'Ouvrir dans la marketplace',
  'app.brand': 'Open Design',
  'app.brandPill': 'Aperçu de recherche',
  'app.brandSubtitle': 'par Nexu Labs',
  'app.welcomeLoading': 'Chargement de l\'espace de travail…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Bienvenue sur Open Design',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Commencer par un brief',
  'settings.onboardingCreateBody': 'Décrivez le site, l’app, le deck, l’image ou la vidéo que vous voulez. Open Design créera un projet et gardera le travail modifiable.',
  'settings.onboardingMemoryTitle': 'Enregistrer le contexte de travail',
  'settings.onboardingMemoryBody': 'Ajoutez vos préférences, les faits du projet et les règles récurrentes afin que les prochaines discussions reprennent le bon contexte.',
  'settings.onboardingMemoryCalloutTitle': 'Enregistré dans votre Mémoire',
  'settings.onboardingMemoryCalloutBody': 'Ces réponses alimentent votre profil de Mémoire. Open Design le réutilise pour chaque tâche — et continue d’apprendre au fil de votre travail.',
  'settings.onboardingMemoryBenefitIntent': 'Comprend ce que vous voulez à partir d’une demande courte',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Évite les questions de configuration répétées',
  'settings.onboardingMemoryBenefitPersonalized': 'Adapte les résultats à votre rôle, votre audience et vos goûts',
  'settings.onboardingSystemsTitle': 'Importer votre système de design',
  'settings.onboardingSystemsBody': 'Choisissez ou créez un système de marque pour que les générations respectent les couleurs, la typographie et le langage produit réels.',
  'settings.onboardingExecutionTitle': 'Choisir le mode de génération',
  'settings.onboardingExecutionBody': 'CLI officielle avec configuration en un clic et valeurs prêtes à l’emploi. Utilisez une seule clé pour choisir parmi de nombreux modèles avec une meilleure tarification.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Recommandé officiellement',
  'settings.onboardingAmrCloudBenefitReady': 'Sans déploiement',
  'settings.onboardingAmrCloudBenefitModels': 'Prend en charge Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Bientôt',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Image et vidéo',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills à grande échelle',
  'settings.onboardingAmrCloudUpcomingRouting': 'Routage intelligent',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'Autoriser Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorisé',
  'settings.onboardingStepConnect': 'Connexion',
  'settings.onboardingStepDesignSystem': 'Créer un système de design',
  'settings.onboardingStepProfile': 'À propos de vous',
  'settings.onboardingStepNewsletter': 'Restez informé',
  'settings.onboardingNewsletterTitle': 'Restez au courant',
  'settings.onboardingNewsletterBody': 'Recevez les nouveautés produit, les nouveaux modèles, les nouveaux systèmes de design et les réalisations des ambassadeurs par e-mail. Facultatif — vous pouvez ignorer cette étape.',
  'settings.onboardingConnectTitle': 'Choisir un runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Se connecter à Open Design',
  'settings.onboardingCloudBody': 'Connectez-vous et créez immédiatement avec l’IA cloud, sans configuration complexe.',
  'settings.onboardingCloudSignIn': 'Se connecter à Open Design',
  'settings.onboardingCloudContinue': 'Continuer (connecté)',
  'settings.onboardingCloudAlternative': 'Utiliser une CLI locale ou votre propre clé API',
  'settings.onboardingCloudRights': 'Tous droits réservés.',
  'settings.onboardingCloudOr': 'ou',
  'settings.onboardingGateTooltipNoRuntime': 'Les étapes suivantes tournent sur IA — choisissez un runtime pour continuer.',
  'settings.onboardingGateTooltipAmr': 'Les étapes suivantes tournent sur IA — connectez-vous à Open Design Cloud pour continuer.',
  'settings.onboardingGateTooltipLocal': 'Les étapes suivantes tournent sur IA — sélectionnez une CLI locale disponible pour continuer.',
  'settings.onboardingGateTooltipByok': 'Les étapes suivantes tournent sur IA — ajoutez et testez votre clé de modèle pour continuer.',
  'settings.onboardingRecommended': 'Recommandé',
  'settings.onboardingAmrCloudOfficialBadge': 'Officiel',
  'settings.onboardingLocalTitle': 'Agent de code local',
  'settings.onboardingLocalBody': 'Utilisez une CLI installée comme Claude Code, Codex, Cursor, Gemini ou OpenCode.',
  'settings.onboardingLocalAction': 'Ouvrir les paramètres CLI',
  'settings.onboardingCliScanHint': 'Cela prend généralement 5 à 10 secondes.',
  'settings.onboardingByokTitle': 'Utiliser votre propre clé',
  'settings.onboardingByokBody': 'Utilisez vos propres identifiants de fournisseur de modèles.',
  'settings.onboardingByokAction': 'Ouvrir les paramètres BYOK',
  'settings.onboardingDesignTitle': 'Système de design',
  'settings.onboardingDesignBody': 'Générez une fois, réutilisez partout.',
  'settings.onboardingDesignIntroGenerateTitle': 'Générer depuis l’existant',
  'settings.onboardingDesignIntroGenerateBody': 'Importez votre système de design depuis GitHub, des dépôts de code locaux, des fichiers Figma, des images ou d’autres contenus.',
  'settings.onboardingDesignIntroReuseTitle': 'Réutiliser dans les prochains travaux',
  'settings.onboardingDesignIntroReuseBody': 'Les futurs prototypes, présentations et autres contenus pourront réutiliser vos polices, espacements, style de logo et tonalité de couleur.',
  'settings.onboardingDesignIntroSkipTitle': 'Optionnel pour l’instant',
  'settings.onboardingDesignIntroSkipBody': 'Ignorez cette étape si vous voulez commencer sans générer de système de design.',
  'settings.onboardingGithubTitle': 'Importer depuis GitHub',
  'settings.onboardingGithubBody': 'Utiliser un dépôt front-end.',
  'settings.onboardingUploadTitle': 'Importer des fichiers locaux',
  'settings.onboardingUploadBody': 'Ajoutez des fichiers de projet, des captures d’écran, du CSS, de la documentation ou des ressources.',
  'settings.onboardingPromptTitle': 'Générer depuis un prompt',
  'settings.onboardingPromptBody': 'Décrivez le produit ou la marque.',
  'settings.onboardingProfileTitle': 'À propos de vous',
  'settings.onboardingProfileBody': 'Informations facultatives pour de meilleurs réglages par défaut.',
  'settings.onboardingRoleLabel': 'Votre rôle',
  'settings.onboardingOrgSizeLabel': 'Taille de l\'organisation',
  'settings.onboardingUseCaseLabel': 'Cas d\'usage',
  'settings.onboardingSourceLabel': 'Comment avez-vous entendu parler de nous ?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Recherche (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 Outil d\'IA (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Ami ou collègue',
  'settings.onboardingSourceCommunity': '💬 Discord / communauté',
  'settings.onboardingSourceEmail': '✉️ E-mail / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / article',
  'settings.onboardingSourceOther': '✨ Autre',
  'settings.onboardingSourceOtherPlaceholder': 'Précisez où (facultatif)',
  'settings.onboardingSelectPlaceholder': 'Sélectionnez une option',
  'settings.onboardingSelectMultiplePlaceholder': 'Sélectionnez une ou plusieurs options',
  'settings.onboardingOrgSolo': 'Solo / personnel (1)',
  'settings.onboardingOrgTeam': 'Petite équipe (2-10)',
  'settings.onboardingOrgStartup': 'Startup / PME (11-50)',
  'settings.onboardingOrgGrowth': 'Entreprise en croissance (51-200)',
  'settings.onboardingOrgMidMarket': 'Marché intermédiaire (201-1000)',
  'settings.onboardingOrgEnterprise': 'Grande entreprise (1000+)',
  'settings.onboardingRolePm': '📋 Chef de produit',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Ingénieur',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Agence marketing',
  'settings.onboardingRoleGrowth': '📈 Croissance',
  'settings.onboardingRoleOps': '⚙️ Opérations',
  'settings.onboardingRoleFounder': '🚀 Fondateur / dirigeant',
  'settings.onboardingRoleStudent': '🎓 Étudiant / enseignant',
  'settings.onboardingRoleOther': '✨ Autre',
  'settings.onboardingUseProduct': '🎨 Design produit',
  'settings.onboardingUseDesignSystem': '🧩 Système de design',
  'settings.onboardingUsePrototype': '📱 Prototype / interface d\'application',
  'settings.onboardingUseLanding': '🌐 Pages de destination',
  'settings.onboardingUseAds': '📣 Publicités / contenu social',
  'settings.onboardingUseDashboard': '📊 Tableaux de bord / outils internes',
  'settings.onboardingUseDeck': '🖥️ Présentation / diaporama',
  'settings.onboardingUseMarketing': '📈 Marketing / croissance',
  'settings.onboardingUseEngineering': '🤝 Transfert vers l\'ingénierie',
  'settings.onboardingUseAgency': '💼 Agence / travail client',
  'settings.onboardingBack': 'Retour',
  'settings.onboardingContinue': 'Continuer',
  'settings.onboardingFinish': 'Terminer la configuration',
  'settings.kicker': 'Paramètres',
  'settings.title': 'Modèles et fournisseurs',
  'settings.subtitle': 'Choisissez entre CLI local et BYOK.',
  'settings.general': 'Général',
  'settings.generalHint': 'Langue, apparence, notifications, emplacements de projet, confidentialité et détails de l’app.',
  'settings.modeAria': 'Mode d\'exécution',
  'settings.protocolAria': 'Protocole d\'API',
  'settings.modeDaemon': 'CLI local',
  'settings.modeDaemonHelp': 'Exécuter via un agent CLI sur votre machine',
  'settings.modeDaemonOffline': 'Le daemon n\'est pas en cours d\'exécution',
  'settings.modeDaemonOfflineMeta': 'daemon hors ligne',
  'settings.modeDaemonInstalledMeta': '{count} installé(s)',
  'settings.modeApi': 'Fournisseur API',
  'settings.cloudCalloutTitle': 'Use Open Design Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'Fournisseurs d’API',
  'settings.byokNoFileToolsNotice': 'BYOK ne peut pas lire, écrire ni modifier les fichiers du projet. Utilisez la CLI locale quand vous avez besoin de changements de code.',
  'settings.byokDraftNotice': 'Remplissez les champs obligatoires pour enregistrer ce fournisseur. Votre configuration actuelle restera active.',
  'settings.codeAgent': 'Agent de code',
  'settings.codeAgentHint': 'Choisissez la CLI par laquelle les générations seront routées.',
  'settings.rescan': '↻ Réanalyser',
  'settings.rescanTitle': 'Réanalyser le PATH',
  'settings.rescanRunning': 'Analyse...',
  'settings.rescanSuccess': 'Analyse terminée. {count} disponible(s).',
  'settings.designSystemRenameFailed': 'Le renommage a échoué. Vérifiez le daemon et réessayez.',
  'settings.rescanFailed': 'L’analyse a échoué. Vérifiez le daemon et réessayez.',
  'settings.test': 'Tester',
  'settings.testTitle': 'Envoie un tout petit message de test pour vérifier la connexion',
  'settings.testRunning': 'Test de la connexion…',
  'settings.byokReadyToTest': 'Prêt à tester',
  'settings.testCancel': 'Annuler',
  'settings.testRetry': 'Relancer le test',
  'settings.required': 'requis',
  'settings.testMissingFields': 'Renseignez {fields} pour tester la connexion.',
  'settings.testSuccessApi': 'Connecté. Répondu en {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} a répondu en {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Échec de l’authentification. Vérifiez votre clé API.',
  'settings.testForbidden': 'Accès interdit. Vérifiez le compte, la région ou l’organisation.',
  'settings.testNotFoundModel': 'Modèle \'{model}\' introuvable sur ce point d’accès.',
  'settings.testInvalidModelId': 'L’id de modèle \'{model}\' est invalide. Les ids personnalisés doivent commencer par une lettre ou un chiffre et ne contenir aucun espace.',
  'settings.testInvalidBaseUrl': 'L’URL de base est invalide ou inaccessible.',
  'settings.testRateLimited': 'Le fournisseur a limité le test. La configuration semble valide.',
  'settings.testUpstream': 'Le fournisseur a renvoyé {status}. Réessayez dans un instant.',
  'settings.testTimeout': 'Le test a expiré après {ms} ms.',
  'settings.testAgentMissing': '{agentName} n’est pas installé ou pas dans le PATH.',
  'settings.testAgentSpawn': 'Impossible de démarrer {agentName} : {detail}.',
  'settings.testUnknown': 'Échec du test : {detail}',
  'settings.agentInstall.install': 'Installer',
  'settings.agentInstall.docs': 'Documentation',
  'settings.agentInstall.pathHint': 'Si vous avez installé une CLI avec npm ou Homebrew et qu\'elle apparaît toujours comme non installée, vérifiez que le dossier bin de l\'outil est dans le PATH hérité par le daemon Open Design (le Terminal et les applications graphiques peuvent différer sur macOS). Voir QUICKSTART.md (section "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Ouvrez Installer ou Documentation pour l\'agent souhaité.',
  'settings.agentInstall.stepAuth': 'Authentifiez-vous avec la CLI du fournisseur (connexion ou ajout des identifiants API) avant de revenir dans Open Design.',
  'settings.agentInstall.stepRescan': 'Cliquez sur Réanalyser dans cette section.',
  'settings.agentInstall.stepSelect': 'Sélectionnez la carte de l\'agent une fois qu\'elle apparaît comme installée.',
  'settings.noAgentsDetected': 'Aucun agent détecté pour l’instant. Installez Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen, GitHub Copilot CLI, Qoder CLI, Hermes, Kimi CLI, Pi, Kiro CLI, Kilo, Mistral Vibe CLI ou DeepSeek TUI, puis cliquez sur Réanalyser.',
  'settings.agentInstalledGroup': 'Vos CLI ({count})',
  'settings.agentInstallGroup': 'Disponibles à installer ({count})',
  'settings.agentAuthRequired': 'Authentification requise',
  'settings.agentAuthUnknown': 'Statut d’authentification inconnu',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'Autoriser',
  'settings.amrBenefitOfficial': 'Officiel',
  'settings.amrBenefitLowerPrice': 'Coût réduit',
  'settings.amrBenefitManyModels': 'Nombreux modèles',
  'settings.amrPromoBonus': 'Bonus limité : +100 %',
  'settings.amrSignInToContinue': 'Connectez-vous pour continuer',
  'settings.amrSignIn': 'Se connecter',
  'settings.amrSignedIn': 'Connecté',
  'settings.amrWalletBalance': 'Solde du portefeuille',
  'settings.amrWalletUnavailable': 'Solde temporairement indisponible',
  'settings.amrWalletUpdatedAt': 'Mis à jour {time}',
  'settings.amrWalletCached': 'en cache',
  'settings.amrWalletRefresh': 'Actualiser',
  'settings.amrWalletRefreshTitle': 'Actualiser le solde du portefeuille Open Design Cloud',
  'settings.amrNotSignedIn': 'Non connecté',
  'settings.amrSigningIn': 'Connexion…',
  'settings.amrActivationHint': 'La page de connexion ne s\'est pas ouverte ? Appuyez sur le bouton ci-dessous pour la rouvrir.',
  'settings.amrActivationBrowserFailed': 'Impossible d’ouvrir le navigateur automatiquement. Ouvrez la page de connexion ci-dessous pour continuer.',
  'settings.amrActivationOpen': 'Ouvrir la page de connexion',
  'settings.amrCancelSignIn': 'Annuler la connexion',
  'settings.amrAccountStatus': 'Statut du compte Open Design Cloud',
  'settings.amrConsole': 'Gérer',
  'settings.amrBalance': 'Quota',
  'settings.amrPlan': 'Forfait',
  'settings.amrUpgrade': 'Mettre à niveau',
  'settings.amrModelUpgradeHint': 'Mettre à niveau pour l’utiliser',
  'settings.amrLoginErrorCompact': 'Échec de la connexion Open Design Cloud.',
  'settings.advanced': 'Avancé',
  'settings.amrLogin': 'Se connecter',
  'settings.amrLogout': 'Se déconnecter',
  'settings.amrLoggingIn': 'Connexion…',
  'settings.amrLoggingOut': 'Déconnexion…',
  'settings.amrLoggedInAs': 'Connecté avec {email}',
  'settings.amrLoggedInWithPlan': 'Connecté avec {email} · {plan}',
  'settings.amrLoggedInPill': 'Connecté',
  'settings.amrNotLoggedIn': 'Non connecté',
  'settings.apiSection': 'API Anthropic',
  'settings.quickFillProvider': 'Remplissage rapide du fournisseur',
  'settings.providerPreset': 'Préréglage du fournisseur',
  'settings.protocolGroupProtocols': 'Protocoles',
  'settings.protocolGroupGateways': 'Passerelles',
  'settings.customProvider': 'Fournisseur personnalisé',
  'settings.apiKey': 'Clé API',
  'settings.apiKeyGetLink': 'Obtenir la clé ↗',
  'settings.showKey': 'Afficher la clé',
  'settings.hideKey': 'Masquer la clé',
  'settings.show': 'Afficher',
  'settings.hide': 'Masquer',
  'settings.model': 'Modèle',
  'settings.apiKeyInvalid': 'Clé API invalide.',
  'settings.apiKeyCleaned': 'Les espaces superflus ont été supprimés de la clé API.',
  'settings.modelsLoadedFromAccount': '✓ {count} modèles chargés depuis votre compte.',
  'settings.modelsLoadedCount': '✓ {count} modèles chargés.',
  'settings.modelSourceAccount': 'Depuis votre compte',
  'settings.modelSourceSuggested': 'Suggéré',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Coût bas',
  'modelCost.halfToOne': 'Coût moyen',
  'modelCost.oneToFour': 'Coût élevé',
  'modelCost.overFour': 'Coût maximal',
  'settings.fetchModels': 'Récupérer les modèles',
  'settings.fetchModelsTitle': 'Récupérer les modèles disponibles auprès de ce fournisseur',
  'settings.fetchModelsRunning': 'Récupération des modèles…',
  'settings.fetchModelsMissingFields': 'Renseignez {fields} pour récupérer les modèles.',
  'settings.fetchModelsInvalidBaseUrl': 'Saisissez une URL de base valide pour récupérer les modèles.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI utilise des noms de déploiement ; la découverte de modèles n’est donc pas disponible ici.',
  'settings.fetchModelsUnsupportedOllama': 'La découverte des modèles Ollama Cloud n’est pas encore disponible. Choisissez ou saisissez un modèle.',
  'settings.fetchModelsSuccess': 'Modèles récupérés : {count}.',
  'settings.fetchModelsEmpty': 'Aucun modèle de texte compatible n’a été renvoyé.',
  'settings.fetchModelsUnsupported': 'La découverte de modèles n’est pas disponible pour ce protocole.',
  'settings.fetchModelsFailed': 'Impossible de récupérer les modèles : {detail}',
  'settings.suggestedModelsHint': 'Ce sont des modèles suggérés pour ce protocole. Votre fournisseur peut prendre en charge d\'autres modèles.',
  'settings.baseUrl': 'URL de base',
  'settings.baseUrlInvalid': 'Utilisez une URL publique http:// ou https://.',
  'settings.baseUrlCustomize': 'Personnaliser l’URL',
  'settings.baseUrlDefaultHint': 'Modifiez ceci uniquement si vous utilisez un proxy ou une passerelle compatible.',
  'settings.azureBaseUrlPlaceholder': 'Collez l’URL de l’endpoint Azure',
  'settings.azureBaseUrlHint': 'Trouvez-la dans le portail Azure → votre ressource → Endpoint.',
  'settings.azureDeploymentModel': 'Nom du déploiement',
  'settings.azureCustomDeploymentName': 'Nom de déploiement personnalisé',
  'settings.azureDeploymentModelHint': 'Pour Azure OpenAI, ce champ est utilisé comme nom du déploiement dans /openai/deployments/<model>. Saisissez le nom du déploiement créé dans Azure.',
  'settings.azureModelFetchHint': 'Pour Azure OpenAI, saisissez le nom du déploiement créé dans Azure. La découverte automatique des déploiements n’est pas disponible depuis ce point d’accès BYOK.',
  'settings.apiVersion': 'Version API',
  'settings.byokImageModel': 'Modèle de génération d\'images',
  'settings.byokVideoModel': 'Modèle de génération de vidéo',
  'settings.byokVideoI2vHint': 'Modèle image-vers-vidéo : une image de référence est requise (sinon la dernière image du projet est utilisée automatiquement)',
  'settings.byokSpeechModel': 'Modèle de synthèse vocale',
  'settings.byokSpeechVoice': 'Voix',
  'settings.byokModelDefaultOption': 'Par défaut',
  'settings.maxTokens': 'Tokens max (optionnel)',
  'settings.maxTokensHint': 'Longueur maximale de la réponse. Laissez vide pour utiliser la valeur par défaut du modèle.',
  'settings.apiHint': 'Stockée localement sur cet appareil.',
  'settings.skipForNow': 'Passer pour l\'instant',
  'settings.getStarted': 'Commencer',
  'settings.envConfigure': 'Modèles et fournisseurs',
  'settings.localCli': 'CLI local',
  'settings.anthropicApi': 'API Anthropic',
  'settings.noAgentSelected': 'aucun agent sélectionné',
  'settings.language': 'Langue',
  'settings.languageHint': 'Changer la langue de l\'interface. Enregistré dans ce navigateur.',
  'settings.agentModelHead': 'Modèle pour :',
  'settings.modelPicker': 'Modèle',
  'settings.modelSourceLive': 'En direct depuis la CLI',
  'settings.modelUsesCliDefault': 'Réglage par défaut de la CLI',
  'settings.modelSourceFallback': 'Liste intégrée',
  'settings.reasoningPicker': 'Effort de raisonnement',
  'settings.serviceTierPicker': 'Niveau de service',
  'settings.modelPickerHint': 'Par défaut utilise la configuration propre de la CLI. Personnalisé… vous permet de saisir n’importe quel identifiant de modèle.',
  'settings.modelPickerLiveHint': 'Les modèles ont été actualisés depuis la CLI installée. Par défaut utilise toujours la configuration propre de la CLI.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Les modèles ont été actualisés depuis la CLI installée.',
  'settings.modelPickerFallbackHint': 'Valeurs par défaut intégrées affichées. Cliquez sur Réanalyser pour récupérer les modèles en direct depuis la CLI.',
  'settings.cliEnvTitle': 'Avancé : proxy et chemins personnalisés',
  'settings.cliEnvHint': 'Utilisez ces champs pour remplacer l’environnement de la CLI sélectionnée : clés API, base URLs de proxy, homes personnalisés ou chemins de binaires non standard. Sans base URL, la CLI utilise son endpoint par défaut. Les secrets restent dans la configuration locale de l’app et seule la CLI sélectionnée les voit.',
  'settings.cliEnvClaudeConfigDir': 'Dossier de configuration Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'URL de base du proxy Claude',
  'settings.cliEnvClaudeApiKey': 'Clé API Claude CLI',
  'settings.cliEnvCodexHome': 'Dossier d’accueil Codex',
  'settings.cliEnvCodexBin': 'Chemin de l’exécutable Codex',
  'settings.cliEnvCodexBaseUrl': 'URL de base du proxy Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'Clé API Codex/OpenAI CLI',
  'settings.modelCustom': 'Personnalisé (saisir ci-dessous)…',
  'settings.modelCustomLabel': 'Identifiant du modèle personnalisé',
  'settings.modelCustomPlaceholder': 'ex. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Fournisseurs de médias',
  'settings.mediaProvidersHint': 'Clés API pour la génération d’images, de vidéos et d’audio.',
  'settings.mcpServerTitle': 'Open Design MCP',
  'settings.mcpServerHint': 'Exposez Open Design comme serveur MCP pour votre agent de code.',
  'settings.externalMcpTitle': 'MCP externe',
  'settings.externalMcpHint': 'Ajoutez des outils MCP depuis des services externes (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'Clé API',
  'settings.mediaProviderBaseUrl': 'URL de base',
  'settings.mediaProviderConfigured': 'Configuré',
  'settings.mediaProviderUnset': 'Non défini',
  'settings.mediaProviderClear': 'Effacer',
  'settings.mediaProviderClearConfirm': 'Effacer les paramètres enregistrés pour {name} ? Vous devrez les saisir à nouveau pour utiliser {name}.',
  'settings.mediaProviderPlaceholder': 'Coller la clé API',
  'settings.mediaProviderBaseUrlPlaceholder': 'Remplacer l\'URL de base par défaut',
  'settings.mediaProviderReload': 'Recharger depuis le daemon',
  'settings.mediaProviderReloadError': 'Impossible de recharger les paramètres des fournisseurs de médias depuis le daemon local.',
  'settings.mediaProviderReloadSuccess': 'Paramètres des fournisseurs de médias rechargés depuis le daemon local.',
  'settings.mediaProviderLoadError': 'Impossible de charger les paramètres des fournisseurs de médias depuis le daemon local. Utilisation temporaire des paramètres enregistrés dans le navigateur.',
  'settings.mediaProviderComingSoonHint': 'Nous suivons ces fournisseurs pour la feuille de route ; le daemon ne fournit pas encore de client, il n\'y a donc rien à configurer.',
  'settings.privacy': 'Confidentialité',
  'settings.privacyHint': 'Données partagées avec l’équipe Open Design',
  'settings.privacyConsentKicker': 'Aidez-nous à améliorer Open Design',
  'settings.privacyConsentLead': 'Partager des données d’utilisation nous aide à comprendre comment Open Design se comporte dans de vrais flux de travail, afin d’améliorer en priorité ce qui compte le plus pour votre expérience.',
  'settings.privacyConsentFooter': 'Vous pouvez modifier ces options à tout moment dans Paramètres → Confidentialité.',
  'settings.privacyConsentShare': 'Partager',
  'settings.privacyConsentDecline': 'Ne pas partager',
  'settings.privacyConsentAccept': 'J’ai compris',
  'settings.privacyConsentBannerFooter': 'Le partage de données est activé par défaut. Vous pouvez le désactiver à tout moment dans Paramètres → Confidentialité.',
  'settings.privacyConsentPolicyLink': 'Lire la politique de confidentialité',
  'settings.privacyMetrics': 'Mesures anonymes',
  'settings.privacyMetricsHint': 'Nombre d’exécutions, usage des tokens, taux d’erreur et durée comme métriques d’usage de base.',
  'settings.privacyContent': 'Contenu de conversation et d’outils',
  'settings.privacyContentHint': 'Après suppression des secrets et autres informations sensibles, nous utilisons les prompts, réponses de l’assistant, entrées/sorties d’outils et le contexte nécessaire à la revue qualité.',
  'settings.privacyInstallationId': 'ID anonyme',
  'settings.privacyOptedOut': 'désactivé',
  'settings.privacyDataDeletion': 'Supprimer mes données',
  'settings.privacyDataDeletionHint': 'Renouvelle votre ID anonyme et arrête l’envoi. Les traces existantes expirent selon notre politique de conservation.',
  'settings.about': 'À propos',
  'settings.aboutHint': 'Version et informations d\'exécution',
  'settings.appVersion': 'Version',
  'settings.appChannel': 'Canal',
  'settings.appRuntime': 'Environnement',
  'settings.appPlatform': 'Plateforme',
  'settings.appArchitecture': 'Architecture',
  'settings.runtimePackaged': 'Application empaquetée',
  'settings.runtimeDevelopment': 'Développement',
  'settings.versionUnavailable': 'Les informations de version sont indisponibles lorsque le daemon est hors ligne.',
  "settings.allowSilentUpdates": "Autoriser l’installation auto des futures mises à jour in-app",
  "settings.allowSilentUpdatesDesc": "Lorsqu’une mise à jour in-app est prête, l’installer automatiquement au prochain démarrage. N’applique pas la mise à jour à la session en cours. Les mises à jour par installateur demandent toujours confirmation.",
  'settings.installLatest': 'Installer la dernière version',
  'settings.alreadyLatest': 'Vous utilisez la dernière version',
  'settings.updateCheck': 'Rechercher des mises à jour',
  'settings.updateNow': 'Mettre à jour',
  'settings.updateRecheck': 'Vérifier à nouveau',
  'settings.updateRetry': 'Réessayer',
  'settings.updateViewReleases': 'Notes de version',
  'settings.updateActionFailed': 'Impossible de terminer l’action de mise à jour.',
  'settings.updateQuitFailed': 'L’installateur est ouvert, mais Open Design n’a pas pu se fermer automatiquement.',
  'settings.updateStatusNotChecked': 'Pas encore vérifié',
  'settings.updateStatusDevelopment': 'Les builds de développement ne prennent pas en charge les mises à jour dans l’app.',
  'settings.updateStatusUnsupported': 'Cet environnement ne prend pas en charge les mises à jour dans l’app.',
  'settings.updateStatusChecking': 'Recherche de mises à jour...',
  'settings.updateStatusUpToDate': 'Vous utilisez déjà la dernière version.',
  'settings.updateStatusAvailable': 'Version {version} trouvée. Préparation du téléchargement.',
  'settings.updateStatusAvailableUnknown': 'Nouvelle version trouvée. Préparation du téléchargement.',
  'settings.updateStatusDownloading': 'Téléchargement de la mise à jour...',
  'settings.updateStatusDownloadingPercent': 'Téléchargement de la mise à jour {percent} %.',
  'settings.updateStatusReady': 'La version {version} est prête à installer.',
  'settings.updateStatusReadyUnknown': 'La mise à jour est prête à installer.',
  'settings.updateStatusInstalling': 'Installation de la mise à jour...',
  'settings.updateStatusFailed': 'Échec de la vérification. Réessayez.',
  'settings.mcpTitle': 'Serveur MCP',
  'settings.mcpHint': 'Permet à un agent de code dans un autre dépôt (Claude Code, Cursor, VS Code, Antigravity, Zed, Windsurf) de lire vos projets Open Design. Utilisez-le pour intégrer un design dans votre app sans exporter d’abord un zip.',
  'settings.mcpDaemonError': 'Impossible de joindre le daemon local pour résoudre les chemins d’installation ({error}). Vérifiez qu’Open Design fonctionne, puis rouvrez ce panneau.',
  'settings.mcpBuildDaemon': 'Construisez d’abord le daemon.',
  'settings.mcpNodeMissing': 'Le binaire Node est introuvable.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js est introuvable. Exécutez `pnpm --filter @open-design/daemon build`, puis actualisez.',
  'settings.mcpMethodCli': 'Commande CLI',
  'settings.mcpInstructionCli': 'Exécutez ceci dans votre terminal.',
  'settings.mcpMethodToml': 'Configuration TOML',
  'settings.mcpInstructionCodex': 'Ajoutez cette table à {path}. La même configuration est partagée entre la CLI Codex et l’extension Codex IDE.',
  'settings.mcpMethodOneClick': 'Installation en un clic',
  'settings.mcpInstructionCursor': 'Cliquez sur « Installer dans Cursor » pour installer avec une boîte de validation, ou fusionnez ce JSON dans {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Installer dans Cursor',
  'settings.mcpMethodJson': 'Configuration JSON',
  'settings.mcpInstructionKiro': 'Ouvrez {path} et fusionnez ce JSON. Pour une configuration au niveau du workspace, utilisez .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Ouvrez la palette de commandes ({shortcut}), lancez "MCP: Open User Configuration", puis fusionnez ce JSON. Copilot Chat doit être en mode Agent pour afficher les outils.',
  'settings.mcpInstructionAntigravity': 'Dans Antigravity : panneau Agent, menu "..." → MCP Servers → Manage MCP Servers → View raw config. Fusionnez ce JSON.',
  'settings.mcpInstructionZed': 'Ouvrez les réglages Zed ({shortcut}) et fusionnez ceci dans l’objet racine. Zed utilise "context_servers", pas "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Ouvrez {path} (ou utilisez l’icône MCPs dans Cascade → Configure), puis fusionnez :',
  'settings.mcpCopyAria': 'Copier l’extrait de configuration MCP',
  'settings.mcpResolvingFailed': '# échec de résolution des chemins, voir l’erreur ci-dessus',
  'settings.mcpLoadingPaths': '# chargement des chemins d’installation depuis le daemon local…',
  'settings.mcpCopied': 'Copié',
  'settings.mcpCopy': 'Copier',
  'settings.mcpCursorApproval': 'Cursor affiche une boîte de validation avant d’écrire la configuration.',
  'settings.mcpCodexOneClickInstall': 'Installer dans Codex',
  'settings.mcpCodexOneClickUninstall': 'Retirer de Codex',
  'settings.mcpCodexOneClickUnavailable': 'CLI Codex introuvable dans le PATH — installez Codex ou collez l’extrait manuellement.',
  'settings.mcpCodexInstallSuccess': 'Installé. Redémarrez Codex pour charger le nouveau serveur.',
  'settings.mcpCodexUninstallSuccess': 'Retiré de Codex.',
  'settings.mcpCodexBusy': 'Traitement…',
  'settings.mcpCodexInstallError': 'Échec de l’opération : {error}',
  'settings.mcpRestartNote': 'Redémarrez votre client pour charger le nouveau serveur.',
  'settings.mcpRestartDetail': 'La plupart des éditeurs ne chargent les serveurs MCP qu’au démarrage. Dans Cursor / VS Code / Antigravity / Windsurf, vous pouvez lancer `Developer: Reload Window` depuis la palette de commandes au lieu de tout redémarrer. Zed et Claude Code nécessitent de quitter puis rouvrir.',
  'settings.mcpCapabilitiesTitle': 'Ce que votre agent peut faire',
  'settings.mcpCapabilityRead': 'Lire ou rechercher n’importe quel fichier dans un projet (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Récupérer un bundle de design en un seul appel : le fichier d’entrée plus chaque variable CSS, composant et police référencé.',
  'settings.mcpCapabilityDefault': 'Utiliser par défaut le projet et le fichier ouverts dans Open Design, afin que vous puissiez dire « intègre ce design dans mon application » sans repréciser quel design.',
  'settings.mcpRunningNote': 'Open Design doit être lancé pour que les appels d’outils MCP réussissent. Si vous avez démarré votre agent de code avant d’ouvrir Open Design, redémarrez l’agent pour qu’il puisse joindre le daemon actif.',
  'entry.tabDesigns': 'Designs',
  'entry.tabTemplates': 'Modèles',
  'entry.tabDesignSystems': 'Systèmes de design',
  'entry.tabConnectors': 'Connecteurs',
  'entry.openSettingsTitle': 'Paramètres',
  'entry.openSettingsAria': 'Ouvrir les paramètres',
  'entry.discordLabel': 'Rejoindre Discord',
  'entry.discordAria': 'Rejoindre le Discord d’Open Design',
  'entry.discordAriaWithOnline': 'Rejoindre le Discord d’Open Design - {online}',
  'entry.discordOnlineLabel': '{count} en ligne',
  'entry.mailAria': 'Envoyer un e-mail à Open Design',
  'entry.accountSettings': 'Paramètres',
  'chat.collapsePane': 'Réduire le panneau de conversation',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Suivre @OpenDesignHQ sur X',
  'entry.followThreadsLabel': 'Suivre Open Design sur Threads',
  'entry.youtubeLabel': 'Open Design sur YouTube',
  'entry.followInstagramLabel': 'Suivre @opendesign.ai sur Instagram',
  'entry.followLinkedinLabel': 'Suivre Open Design sur LinkedIn',
  'entry.followXiaohongshuLabel': 'Suivre Open Design sur Xiaohongshu',
  'entry.resizeAria': 'Redimensionner la barre latérale',
  'entry.loadingWorkspace': 'Chargement de l\'espace de travail…',
  'entry.useEverywhereTitle': 'Utiliser partout',
  'entry.useEverywhereAria': 'Ouvrir le guide « Utiliser partout » (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Équipes',
  'workspaceSwitcher.team': 'Team',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "Projets personnels",
  "workspaceSwitcher.allProjectsTooltip": "Projets d'équipe",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingFamilyCreator": "Creator",
  "entry.upgradeTitle": "Upgrade plan",
  "entry.upgradeCreditsExhaustedTitle": "Credits exhausted",
  "entry.upgradeAutoRechargeTitle": "Auto recharge",
  "entry.upgradeDialogAria": "Upgrade plan",
  "entry.upgradeSubtitle": "Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeCreditsExhaustedSubtitle": "You need more credits to continue. Upgrade to a higher plan to increase your quota immediately. The charge is prorated for the current billing cycle.",
  "entry.upgradeAutoRechargeMemberSubtitle": "Enable a separate allowance for {member}. Saving this setting will not charge immediately; credits refill only when this member falls below the threshold.",
  "entry.upgradeAutoRechargeTeamSubtitle": "Enable an allowance for all teammates. Saving this setting will not charge immediately; team credits refill only when the balance falls below the threshold.",
  "entry.upgradeScopeLabel": "Scope",
  "entry.upgradeScopeMember": "{member} · single-member allowance",
  "entry.upgradeScopeTeam": "All teammates · shared allowance",
  "entry.upgradePaymentHint": "Uses the subscription payment method by default. You can manage it anytime.",
  "entry.upgradeManagePayment": "Manage payment method",
  "entry.upgradeMonthlyLimit": "Monthly limit",
  "entry.upgradeLimitCustom": "",
  "entry.upgradeLimitUnlimited": "∞ unlimited (no monthly cap)",
  "entry.upgradeBillingCycleAria": "Billing cycle",
  "entry.upgradeAnnual": "Annual",
  "entry.upgradeAnnualSave": "Save 20%",
  "entry.upgradeMonthly": "Monthly",
  "entry.upgradePlanPlus": "Personal Plus",
  "entry.upgradePlanPlusDesc": "Basic token allowance · SOTA models",
  "entry.upgradePlanPro": "Personal Pro",
  "entry.upgradePlanProDesc": "3x token allowance · top multimodal models",
  "entry.upgradePlanMax": "Personal Max",
  "entry.upgradePlanMaxDesc": "10x token allowance · top multimodal models",
  "entry.upgradePlanTeam": "Teams",
  "entry.upgradePlanTeamDesc": "Collaboration · shared assets · role permissions",
  "entry.upgradePriceUnitMonth": "/mo",
  "entry.upgradePriceUnitSeat": "/seat/mo",
  "entry.upgradeProrateAnnualPrefix": "Annual billing saves 20%; ",
  "entry.upgradeProrateMonthlyPrefix": "Monthly billing; ",
  "entry.upgradeProrateSuffix": "upgrades are prorated for the current billing cycle and take effect immediately.",
  "entry.upgradeBack": "Back",
  "entry.upgradeAutoRechargeSaved": "Auto recharge settings saved",
  "entry.upgradeConfirm": "Confirm payment and upgrade",
  "entry.creditsAria": "{tier} · credits remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} credits remaining",
  "entry.creditsGrantTip": "Teams credits are granted by subscription allowance. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Credits remaining",
  "entry.credits": "Quota",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more credits?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot add credits yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help on GitHub",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Se déconnecter",
  "signOut.confirmMessage": "Voulez-vous vraiment vous déconnecter ?",
  "signOut.confirmAction": "Se déconnecter",
  "entry.navRecents": "Accueil",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace pour les équipes — dites-nous ce dont votre équipe a besoin',
  'entry.workspaceTeamsAria': 'Ouvrir la page Workspace pour les équipes',
  'entry.navExpand': 'Afficher la barre latérale',
  'entry.navCollapse': 'Masquer la barre latérale',
  'entry.navNewProject': 'Nouveau projet',
  'entry.navHome': 'Accueil',
  'entry.navProjects': 'Projets',
  'entry.navTasks': 'Automatisations',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Systèmes de design',
  'entry.navBrands': 'Kit de marque',
  'entry.navIntegrations': 'Intégrations',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'Projets personnels',
  'entry.navAllProjects': "Projets d'équipe",
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "Open Design Cloud",
  "entry.cloudCalloutBody": "Connectez-vous pour utiliser Open Design Cloud et collaborer dans le cloud",
  "entry.cloudCalloutDismissAria": "Fermer la note Open Design Cloud",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'Open Design updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'workspaceTabs.project': 'Projet',
  'workspaceTabs.pluginDetails': 'Détails du plugin',
  'workspaceTabs.marketplace': 'Place de marché',
  'homeHero.title': 'Qu’allez-vous concevoir aujourd’hui avec votre agent ?',
  'homeHero.startWithTemplate': 'Commencer avec un modèle…',
  'homeHero.startBlankProject': 'démarrer un projet vierge',
  'homeHero.templatePicker.label': 'Type de création',
  'homeHero.templatePicker.searchPlaceholder': 'Rechercher des modèles',
  'homeHero.templatePicker.projectTypes': 'Types de projet',
  'homeHero.templatesScrollHint': 'Faites défiler vers le haut pour explorer plus de modèles',
  'homeHero.templatesCollapse': 'Réduire les modèles',
  'homeHero.subtitlePrefix': 'L’alternative à code source disponible à Claude Design.',
  'homeHero.placeholder': 'Décrivez ce que vous voulez générer…',
  'homeHero.placeholderActive': 'Modifiez la requête d’exemple ou écrivez la vôtre…',
  'homeHero.carousel.hint': 'Joignez un fichier, liez votre design system ou décrivez ce que vous voulez créer',
  'homeHero.carousel.onePageBrief': 'Rédiger un brief de projet d’une page',
  'homeHero.carousel.notesToDeck': 'Transformer mes notes en présentation',
  'homeHero.carousel.signupFlow': 'Maquetter un parcours d’inscription',
  'homeHero.carousel.improveBrief': 'Améliorer un brief de projet existant',
  'homeHero.carousel.loadingAnimation': 'Créer une animation de chargement',
  'homeHero.carousel.teamUpdateSlides': 'Concevoir des diapositives pour un point d’équipe',
  'homeHero.carousel.ordersDashboard': 'Prototyper un tableau de bord de suivi des commandes',
  'homeHero.carousel.productDetail': 'Mettre en page une fiche produit',
  'homeHero.carousel.caseStudy': 'Esquisser une étude de cas',
  'homeHero.carousel.landingIntro': 'Concevoir une courte intro pour une page d’accueil',
  'homeHero.carousel.pitchDeck': 'Créer un pitch deck pour un nouveau produit',
  'homeHero.carousel.appIdea': 'Décrire une idée d’application',
  'homeHero.carousel.landingLayout': 'Esquisser la mise en page d’une landing page',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Ajouter du contexte',
  'homeHero.addPlugin': 'Ajouter un plugin',
  'homeHero.addConnectors': 'Ajouter des connecteurs',
  'homeHero.addMcp': 'Ajouter un serveur MCP',
  'homeHero.noPlugins': 'Aucun plugin installé',
  'homeHero.noMcp': 'Aucun serveur MCP',
  'homeHero.noConnectors': 'Aucun connecteur connecté',
  'homeHero.applying': 'Application…',
  'homeHero.pluginTitle': 'Plugin : {title}',
  'homeHero.pluginPrefix': 'Plugin : {title}',
  'homeHero.skillPrefix': 'Skill : {title}',
  'homeHero.removePlugin': 'Retirer le plugin',
  'homeHero.removePluginAria': 'Retirer le plugin {title}',
  'homeHero.clearActivePlugin': 'Effacer le plugin actif',
  'homeHero.clearActiveSkill': 'Effacer le Skill actif',
  'homeHero.contextItemsResolved': '{n} éléments de contexte résolus',
  'homeHero.removeFile': 'Retirer le fichier',
  'homeHero.contextSearchResults': 'Résultats de recherche de contexte',
  'homeHero.contextSurfaces': 'Surfaces de contexte',
  'homeHero.loadingContext': 'Chargement du contexte…',
  'homeHero.noResults': 'Aucun résultat pour « {query} ».',
  'homeHero.searchPrompt': 'Rechercher des fichiers, plugins, Skills, serveurs MCP et connecteurs.',
  'homeHero.parameters': '{n} paramètres',
  'homeHero.details': 'Détails',
  'homeHero.toRun': 'pour lancer',
  'homeHero.forNewLine': 'pour passer à la ligne',
  'homeHero.run': 'Lancer',
  'homeHero.typeSomethingToRun': 'Saisissez quelque chose à lancer',
  'homeHero.promptExamples': 'Exemples de prompts',
  'homeHero.footer.designSystem': 'Style',
  'homeHero.footer.autoDesignSystem': 'Auto',
  'homeHero.footer.autoDesignSystemSummary': 'Associe automatiquement le système de design et le style visuel les plus adaptés au prompt actuel.',
  'homeHero.footer.ratio': 'Ratio',
  'homeHero.footer.duration': 'Durée',
  'homeHero.footer.resolution': 'Résolution',
  'homeHero.footer.speakerNotes': 'Notes',
  'homeHero.footer.noSpeakerNotes': 'Sans notes',
  'homeHero.footer.availableCount': '{n} disponibles',
  'homeHero.footer.noMatches': 'Aucun résultat',
  'homeHero.moreShortcuts': 'Plus',
  'homeHero.railAria': 'Choisir une catégorie de projet ou un raccourci de démarrage',
  'homeHero.subTypeAria': 'Choisir un sous-type',
  'homeHero.subTypeMore': 'Plus',
  'homeHero.confirmReplaceTitle': 'Remplacer le prompt actuel ?',
  'homeHero.confirmReplaceBody': 'Utiliser {title} remplacera le texte actuellement dans le champ.',
  'homeHero.confirmReplace': 'Remplacer',
  'homeHero.chip.prototype': 'UI Mockup',
  'homeHero.chip.webClone': 'Clone de site web',
  'homeHero.chip.liveArtifact': 'Artefact dynamique',
  'homeHero.chip.deck': 'Présentation',
  'homeHero.chip.image': 'Image',
  'homeHero.chip.video': 'Vidéo',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'Expérience WebGL',
  'homeHero.chip.webglDesc': 'Shaders, 3D & visuels GPU génératifs',
  'homeHero.chip.worker': 'Visualiseur Worker',
  'homeHero.chip.workerDesc': 'Simulations hors thread, particules & data viz',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Créer un kit de marque',
  'homeHero.chip.createPlugin': 'Créer un plugin',
  'homeHero.chip.figma': 'Depuis Figma',
  'homeHero.chip.folder': 'Depuis un dossier',
  'homeHero.chip.template': 'Depuis un modèle',
  'homeHero.chip.liveArtifactHint': 'Créer un artefact HTML/CSS/JS interactif que vous pouvez prévisualiser en direct.',
  'homeHero.chip.hyperframesHint': 'Créer du motion design basé sur HTML : sous-titres, visuels réactifs à l’audio, transitions de scènes.',
  'homeHero.chip.createBrandKitHint': 'Extrayez un kit de marque depuis un site web, puis appliquez-le dans n’importe quel chat.',
  'homeHero.chip.createPluginHint': 'Créer un plugin Open Design réutilisable et l’ajouter à Mes plugins.',
  'homeHero.chip.figmaHint': 'Migrer une frame Figma vers le système de design actif.',
  'homeHero.chip.folderHint': 'Importer un dossier local existant et continuer à l’éditer.',
  'homeHero.chip.templateHint': 'Commencer depuis un modèle intégré.',
  'homeHero.chip.wireframe': 'Maquette filaire',
  'homeHero.chip.mobile': 'App mobile',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Maquettes d’app interactives',
  'homeHero.chip.webCloneDesc': 'Reproduction de site fidèle à la source',
  'homeHero.chip.wireframeDesc': 'Écrans et parcours basse fidélité',
  'homeHero.chip.mobileDesc': 'Écrans iOS et Android',
  'homeHero.chip.deckDesc': 'Présentations et pitch decks',
  'homeHero.chip.documentDesc': 'CV, rapports et PDF',
  'homeHero.chip.imageDesc': 'Affiches, visuels et art',
  'homeHero.chip.videoDesc': 'Clips, reels et promos',
  'homeHero.chip.audioDesc': 'Voix off, musique et effets sonores',
  'homeHero.chip.hyperframesDesc': 'Graphismes animés et boucles',
  'homeHero.chip.liveArtifactDesc': 'Tableaux de bord live avec données',
  'homeHero.chip.createBrandKitDesc': 'Extraire un système de design de marque',
  'homeHero.chip.prototypeNext': 'Ouvrir un chat qui crée un prototype web cliquable haute fidélité à affiner étape par étape.',
  'homeHero.chip.webCloneNext': 'Ouvrir un chat qui demande une URL cible, reconstruit le site et audite le clone.',
  'homeHero.chip.wireframeNext': 'Ouvrir un chat qui esquisse des écrans et parcours basse fidélité pour valider d’abord la structure.',
  'homeHero.chip.mobileNext': 'Ouvrir un chat qui met en page des écrans mobiles pour iOS et Android.',
  'homeHero.chip.deckNext': 'Ouvrir un chat qui crée une présentation que vous pouvez présenter et exporter.',
  'homeHero.chip.documentNext': 'Ouvrir un chat qui rédige un document soigné — CV, rapport ou PDF.',
  'homeHero.chip.imageNext': 'Ouvrir un chat qui génère des images fidèles à la marque et itérables.',
  'homeHero.chip.videoNext': 'Ouvrir un chat qui produit une courte vidéo à affiner.',
  'homeHero.chip.audioNext': 'Ouvrir un chat qui crée une voix off, de la musique ou des effets sonores.',
  'homeHero.chip.webClonePromptSeed': 'URL du site à cloner : ',
  'homeWorkingDir.trigger': 'Choisir le dossier de travail',
  'homeWorkingDir.triggerShort': 'Dossier de travail',
  'homeWorkingDir.pick': 'Choisir un dossier',
  'homeWorkingDir.replace': 'Changer de dossier de travail',
  'homeWorkingDir.recent': 'Dossiers récents',
  'homeWorkingDir.recentEmpty': 'Aucun dossier récent',
  'homeWorkingDir.clear': 'Retirer le dossier de travail',
  'homeWorkingDir.hint': 'Autoriser l’agent à lire ce dossier local (sans l’importer dans les fichiers de design)',
  'homeWorkingDir.missing': 'Ce dossier de travail n’existe plus — choisissez-en un autre',
  'homeWorkingDir.applyFailed': 'Impossible de définir le dossier de travail — le dossier n’existe peut-être plus',
  'workingDirPicker.title': 'Dossier',
  'workingDirPicker.homeTitle': 'Enregistré dans le stockage local — cliquez pour choisir un dossier',
  'workingDirPicker.processing': 'Traitement…',
  'workingDirPicker.select': 'Stockage local',
  'workingDirPicker.clearAria': 'Effacer le dossier de travail',
  'workingDirPicker.replaceFailed': 'Impossible de remplacer le dossier de travail',
  'workingDirPicker.unavailable': 'Le sélecteur de dossier n’est pas disponible dans cette build. Lancez l’app desktop pour choisir un dossier.',
  'workingDirPicker.openUnavailable': 'Ouvrez ce projet dans l’app desktop pour afficher le dossier.',
  'workingDirPicker.openFailed': 'Impossible d’afficher ce dossier',
  'workingDirPicker.showInFileManager': 'Afficher dans le gestionnaire de fichiers',
  'workingDirPicker.replace': 'Choisir un dossier…',
  'workingDirPicker.recent': 'Dossiers récents',
  'workingDirPicker.defaultLabel': 'Stockage local',
  'handoff.toTarget': 'Transférer vers {target}',
  'handoff.openInTarget': 'Ouvrir dans {target}',
  'handoff.openAction': 'Ouvrir',
  'handoff.menuTitle': 'Ouvrir avec quel logiciel ?',
  'handoff.action': 'Transférer',
  'handoff.fallbackTitle': 'Aucun éditeur trouvé dans $PATH - ouverture dans {target}',
  'handoff.chooseTargetAria': 'Choisir la cible du transfert',
  'handoff.optionsAria': 'Options de transmission',
  'handoff.editorSection': 'Ouvrir avec un logiciel',
  'handoff.cliSection': 'Copier pour la CLI',
  'handoff.clickOpen': 'Cliquer pour ouvrir',
  'handoff.framework': 'Stack cible',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript, HTML et CSS sans framework',
  'handoff.amrWebsite': 'Ouvrir le site Open Design Cloud',
  'handoff.copyPrompt': 'Copier le prompt',
  'handoff.copyPromptForTarget': 'Copier le prompt pour {target}',
  'handoff.copied': 'Copié',
  'handoff.projectPathUnavailable': 'Le chemin du projet est encore en cours de chargement. Réessayez dans un instant.',
  'handoff.copyFailed': 'L’écriture dans le presse-papiers a été bloquée. Réessayez dans un instant.',
  'handoff.promptIntro': 'Continuez à partir de ce dossier de projet Open Design local :',
  'handoff.promptTarget': 'Cible',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Vous reprenez la main dans {cli}. Suivez ces étapes :',
  'handoff.promptReadFiles': 'Entrez dans ce répertoire ou lisez-le d’abord. Priorisez DESIGN.md, README, le HTML/CSS/JS existant, les assets et package.json s’ils sont présents.',
  'handoff.promptKeepDesign': 'Préservez le design visuel actuel, la mise en page, les interactions et les assets. Ne vous arrêtez pas à un plan.',
  'handoff.promptProduceCode': 'Générez ou modifiez du code {framework} réel et exécutable. Si le projet a déjà une stack plus claire, signalez le conflit et gardez un résultat exécutable.',
  'handoff.promptVerify': 'Terminez en me donnant les commandes d’exécution, de prévisualisation et de vérification.',
  'handoff.promptCommandHint': 'Pour démarrer depuis le répertoire du projet, utilisez :',
  'handoff.promptProject': 'Projet',
  'handoff.promptProjectId': 'ID du projet',
  'handoff.notInstalled': 'Non détecté',
  'handoff.notDetectedTitle': '{target} - non détecté dans $PATH',
  'designSystemPicker.select': 'Choisir un système de design',
  'designSystemPicker.loading': 'Chargement des systèmes de design…',
  'designSystemPicker.searchPlaceholder': 'Rechercher des systèmes de design (titre / catégorie / résumé)',
  'designSystemPicker.searchCompactPlaceholder': 'Rechercher des systèmes de design',
  'designSystemPicker.noneTitle': 'Aucun système de design',
  'designSystemPicker.noneSummary': 'Laisser le modèle choisir librement',
  'designSystemPicker.empty': 'Aucun système de design correspondant',
  'designSystemPicker.openPreview': 'Ouvrir l’aperçu',
  'designSystemPicker.loadingPreview': 'Chargement de l’aperçu…',
  'designSystemPicker.noPreview': 'Aucune page d’aperçu. Ouvrez Systèmes de design pour voir l’aperçu complet.',
  'designSystemPicker.previewHint': 'Survolez un système de design pour le prévisualiser',
  'designSystemPicker.fullscreenAria': 'Aperçu plein écran de {title}',
  'designSystemPicker.closeFullscreen': 'Fermer l’aperçu plein écran',
  'designSystemPicker.closeEsc': 'Fermer (Esc)',
  'designSystemPicker.previewFrameTitle': 'Aperçu de {title}',
  'designSystemPicker.fullscreenFrameTitle': 'Aperçu plein écran de {title}',
  'recentProjects.title': 'Projets récents',
  'recentProjects.viewAll': 'Tout voir',
  'recentProjects.empty': 'Aucun projet pour l’instant — saisissez un prompt pour en créer un.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Effacer les filtres',
  'pluginsHome.title': 'Communauté',
  'pluginsHome.subtitle': 'Workflows Open Design prêts à l’emploi, intégrés à ce runtime. Choisissez-en un pour charger un prompt de départ, ou parcourez le registre pour en trouver d’autres.',
  'pluginsHome.browseRegistry': 'Parcourir le registre',
  'pluginsHome.count': '{filtered} sur {total}',
  'pluginsHome.loadingCatalog': 'Chargement du catalogue…',
  'pluginsHome.emptyCatalog': 'Le catalogue est vide. Les plugins intégrés sont fournis avec Open Design et devraient apparaître ici automatiquement — essayez de redémarrer le daemon si cela persiste.',
  'pluginsHome.emptyFiltered': 'Aucun plugin ne correspond aux filtres actuels.',
  'pluginsHome.clearFilters': 'Effacer les filtres',
  'pluginsHome.modeAria': 'Mode du plugin',
  'pluginsHome.featured': 'Enregistrés',
  'pluginsHome.totalInCatalog': '{n} dans le catalogue',
  'pluginsHome.categoryFilterAria': 'Filtre de catégorie',
  'pluginsHome.subcategoryFilterAria': 'Filtre de sous-catégorie {label}',
  'pluginsHome.allCategory': 'Tous les {label}',
  'pluginsHome.searchPlaceholder': 'Rechercher des plugins…',
  'pluginsHome.searchAria': 'Rechercher des plugins',
  'pluginsHome.clearSearch': 'Effacer la recherche',
  'pluginsHome.sortAria': 'Ordre de tri',
  'pluginsHome.sortHot': 'Tendances',
  'pluginsHome.sortNewest': 'Les plus récents',
  'pluginsHome.facet.import': 'Importer',
  'pluginsHome.facet.create': 'Créer',
  'pluginsHome.facet.export': 'Exporter',
  'pluginsHome.facet.share': 'Partager',
  'pluginsHome.facet.deploy': 'Déployer',
  'pluginsHome.facet.refine': 'Affiner',
  'pluginsHome.facet.extend': 'Étendre',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Code / dossier',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Capture d’écran',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Diapositives',
  'pluginsHome.facet.publicLink': 'Lien public',
  'pluginsHome.facet.githubPr': 'PR GitHub',
  'pluginsHome.facet.githubGist': 'Gist GitHub',
  'pluginsHome.subfacet.business-dashboards': 'Tableaux de bord',
  'pluginsHome.subfacet.app-prototypes': 'Applis',
  'pluginsHome.subfacet.landing-marketing': 'Pages d’atterrissage / marketing',
  'pluginsHome.subfacet.developer-tools': 'Outils développeur',
  'pluginsHome.subfacet.docs-reports': 'Docs / rapports',
  'pluginsHome.subfacet.brand-design': 'Marque / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / business',
  'pluginsHome.subfacet.course-training': 'Cours / formation',
  'pluginsHome.subfacet.reports-briefings': 'Rapports / synthèses',
  'pluginsHome.subfacet.product-sales': 'Produit / ventes',
  'pluginsHome.subfacet.engineering-talks': 'Présentations techniques',
  'pluginsHome.subfacet.creative-decks': 'Présentations créatives',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / maquettes de produit',
  'pluginsHome.subfacet.brand-visuals': 'Marque / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / contenu',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portrait',
  'pluginsHome.subfacet.illustration-style': 'Illustration / style',
  'pluginsHome.subfacet.motion-effects': 'Motion / effets',
  'pluginsHome.subfacet.social-short-form': 'Social / formats courts',
  'pluginsHome.subfacet.marketing-product': 'Marketing / produit',
  'pluginsHome.subfacet.data-explainers': 'Données / explications',
  'pluginsHome.subfacet.cinematic-story': 'Cinématique / récit',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Parcourez les workflows installés, découvrez les entrées du registre, gérez les sources et préparez les plugins pour une distribution d’équipe.',
  'pluginsView.importPlugin': 'Importer un plugin',
  'pluginsView.agentContext': 'Contexte agent',
  'pluginsView.summaryAria': 'Résumé des plugins',
  'pluginsView.areasAria': 'Zones des plugins',
  'pluginsView.loading': 'Chargement des plugins…',
  'pluginsView.tab.installed': 'Installés',
  'pluginsView.tab.available': 'Disponibles',
  'pluginsView.tab.sources': 'Sources',
  'pluginsView.tab.team': 'Équipe',
  'pluginsView.tabHint.installed': 'Vos plugins',
  'pluginsView.tabHint.available': 'Depuis les sources',
  'pluginsView.tabHint.sources': 'Catalogues',
  'pluginsView.tabHint.team': 'Entreprise',
  'pluginsView.installedTitle': 'Plugins installés',
  'pluginsView.installedSubtitle': 'Plugins que vous avez importés ou installés depuis des sources de marketplace.',
  'pluginsView.installedEmpty': 'Aucun plugin utilisateur installé pour l’instant. Utilisez Créer / Importer ou installez une entrée disponible.',
  'pluginsView.availableTitle': 'Disponibles depuis les sources',
  'pluginsView.availableSubtitle': 'Entrées de catalogue découvertes depuis les marketplaces configurées.',
  'pluginsView.availableFiltersAria': 'Filtres des plugins disponibles',
  'pluginsView.searchAvailableAria': 'Rechercher des plugins disponibles',
  'pluginsView.searchAvailablePlaceholder': 'Rechercher des plugins disponibles',
  'pluginsView.clearAvailableSearch': 'Effacer la recherche de plugins disponibles',
  'pluginsView.source': 'Source',
  'pluginsView.availableEmptyInstalled': 'Aucune entrée disponible pour l’instant. Les entrées installées sont retirées de Disponibles ; désinstallez-en une pour la rendre de nouveau disponible.',
  'pluginsView.availableEmptyFiltered': 'Aucune entrée disponible ne correspond à vos filtres.',
  'pluginsView.availableEmptyNoSources': 'Aucune entrée disponible pour l’instant. Ajoutez une source dans l’onglet Sources.',
  'pluginsView.installing': 'Installation…',
  'pluginsView.installWaiting': 'En attente…',
  'pluginsView.installQueuedHint': 'Un autre plugin est en cours d’installation. Les installations s’exécutent une par une — ce bouton sera disponible à la fin.',
  'pluginsView.install': 'Installer',
  'pluginsView.sourcesTitle': 'Sources du registre',
  'pluginsView.sourcesSubtitle': 'Catalogues de marketplaces qui alimentent les plugins disponibles.',
  'pluginsView.sourceUrl': 'URL de la source',
  'pluginsView.defaultTrust': 'Confiance par défaut',
  'pluginsView.trust.restricted': 'Restreinte',
  'pluginsView.trust.trusted': 'Fiable',
  'pluginsView.trust.official': 'Officielle',
  'pluginsView.adding': 'Ajout…',
  'pluginsView.addSource': 'Ajouter une source',
  'pluginsView.sourcesEmpty': 'Aucune source de registre configurée pour l’instant.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catalogue v{version}',
  'pluginsView.trustFor': 'Confiance pour {name}',
  'pluginsView.refreshing': 'Actualisation…',
  'pluginsView.removing': 'Suppression…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to Open Design.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "Open Design official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. Open Design will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from Open Design official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Synchroniser avec l'équipe",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "La dernière version de « {title} » a été synchronisée avec l'équipe.",
  "pluginsView.syncUnavailable": "Impossible de synchroniser « {title} » pour le moment. Vérifiez que vous êtes dans un espace de travail d'équipe.",
  "pluginsView.syncFailed": "Échec de la synchronisation de « {title} » avec l'équipe. Réessayez plus tard.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Marketplaces privées d’équipe',
  'pluginsView.teamBody': 'Cette zone est réservée aux catalogues entreprise et équipe, aux politiques de confiance privées et aux contrôles partagés du cycle de vie des plugins.',
  'pluginCard.details': 'Détails',
  'pluginCard.use': 'Utiliser',
  'pluginCard.useWithQuery': 'Utiliser avec une requête',
  'pluginCard.applying': 'Application…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remixage…',
  'pluginCard.duplicateFailed': 'Impossible de remixer ce modele.',
  'pluginCard.saved': 'Enregistré',
  'pluginCard.publish': 'Publier',
  'pluginCard.contribute': 'Contribuer',
  'pluginCard.starting': 'Démarrage…',
  'pluginCard.detailsAria': 'Voir les détails de {title}',
  'pluginCard.chooseUseAria': 'Choisir comment utiliser {title}',
  'pluginCard.useOptionsAria': 'Options d’utilisation pour {title}',
  'pluginCard.duplicateAria': 'Remixer {title} dans un nouveau projet',
  'pluginCard.saveAria': 'Enregistrer {title}',
  'pluginCard.savedAria': '{title} est enregistré',
  'pluginCard.shareAria': 'Partager {title}',
  'pluginCard.publishAria': 'Publier {title} comme dépôt GitHub',
  'pluginCard.publishTitle': 'Publier le plugin comme dépôt GitHub',
  'pluginCard.contributeAria': 'Soumettre {title} à Open Design',
  'pluginCard.contributeTitle': 'Soumettre le plugin à Open Design via une pull request',
  'skillPluginCandidate.createForMe': 'Créer un plugin/modèle',
  'skillPluginCandidate.contributeToMain': 'Contribuer à open-design',
  'skillPluginCandidate.repoDescription': 'Ce dépôt semble pouvoir fonctionner comme plugin.',
  'integrations.kicker': 'Intégration',
  'integrations.lede': 'Connectez des systèmes externes, ajoutez des outils MCP à votre boucle agent et utilisez Open Design depuis d’autres IDE, scripts et automatisations.',
  'integrations.agentReady': 'Prêt pour les agents',
  'integrations.areasAria': 'Zones d’intégration',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Outils externes',
  'integrations.tabHint.connectors': 'Comptes et API',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Intégrations de Skills',
  'integrations.skillsBody': 'La gestion des intégrations au niveau des Skills est en cours de reprise depuis une autre branche. Cet onglet est réservé afin que MCP, les connecteurs et la future configuration des Skills vivent dans la même route Intégrations.',
  'mcpClient.title': 'Serveurs MCP externes',
  'mcpClient.subtitle': 'Outils tiers pour votre agent de code.',
  'mcpClient.addServer': 'Ajouter un serveur',
  'mcpClient.emptyTitle': 'Aucun serveur MCP configuré.',
  'mcpClient.emptyBody': 'Cliquez sur « Ajouter un serveur » pour commencer — choisissez un modèle (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) ou configurez un serveur stdio / HTTP personnalisé.',
  'mcpClient.saveChanges': 'Enregistrer les modifications',
  'mcpClient.storedAt': 'Stocké dans',
  'mcpClient.daemonError': 'Impossible de joindre le daemon local. Vérifiez qu’Open Design est lancé, puis rouvrez ce panneau.',
  'mcpClient.saveFailed': 'Échec de l’enregistrement. Vérifiez que le daemon est lancé, puis réessayez.',
  'useEverywhere.modalAria': 'Utiliser Open Design partout',
  'useEverywhere.modalTitle': 'Utiliser Open Design partout',
  'useEverywhere.modalSubtitle': 'Ajoutez Open Design à n’importe quel IDE, agent ou script — CLI, HTTP, MCP et Skills. Utilisez « Copier le guide pour un agent » puis collez-le dans Claude Code, Codex, Cursor, openclaw ou hermes pour tout configurer.',
  'useEverywhere.closeAria': 'Fermer Utiliser partout',
  'useEverywhere.closeTitle': 'Fermer (Échap)',
  'useEverywhere.tabsAria': 'Surfaces d’intégration',
  'useEverywhere.footStrong': 'Transfert en un clic.',
  'useEverywhere.footBody': 'Copie un guide Markdown structuré que votre agent peut exécuter immédiatement — installer, vérifier et utiliser.',
  'useEverywhere.configureMcp': 'Configurer le serveur MCP',
  'useEverywhere.copyGuide': 'Copier le guide pour un agent',
  'useEverywhere.copy': 'Copier',
  'useEverywhere.copied': 'Copié',
  'useEverywhere.copyFailed': 'Échec de la copie',
  'useEverywhere.copySnippetAria': 'Copier l’extrait : {label}',
  'useEverywhere.section.overview.tab': 'Vue d’ensemble',
  'useEverywhere.section.overview.heading': 'Open Design fonctionne partout où votre agent fonctionne',
  'useEverywhere.section.overview.intro': 'Open Design est plus qu’une fenêtre : c’est un daemon local privilégié (`od`) plus un registre de Skills, systèmes de design et Atoms. Une fois lancé sur votre machine, tout agent de code (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes ou votre propre script) peut piloter des générations, inspecter les projets et produire des artefacts de design via quatre surfaces interchangeables.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` pour scripts sans interface, CI et automatisation shell.',
  'useEverywhere.section.overview.bullet2': 'Serveur MCP — expose Open Design comme serveur Model Context Protocol afin que tout agent compatible MCP puisse lister les Skills, lancer des scénarios et lire les artefacts.',
  'useEverywhere.section.overview.bullet3': 'API HTTP — endpoints REST + SSE `http://127.0.0.1:7456/api/*` ; la même surface que celle utilisée par l’UI web.',
  'useEverywhere.section.overview.bullet4': 'Skills — packs `SKILL.md` prêts à déposer (compatibles Claude) que les agents avec chargement natif des Skills peuvent utiliser directement ; les autres agents y accèdent via Open Design.',
  'useEverywhere.section.overview.bullet5': 'Artefacts standards — amorcez de vrais projets HTML depuis les Skills, les plugins par défaut intégrés et les exemples de plugins communautaires avant le démarrage du daemon.',
  'useEverywhere.section.overview.snippet1': 'Démarrer le daemon (et l’UI web) localement',
  'useEverywhere.section.overview.snippet2': 'Confirmer qu’il est joignable',
  'useEverywhere.section.overview.snippet3': 'Ingérer les artefacts standards avant le démarrage',
  'useEverywhere.section.overview.footer': 'Par défaut, le daemon écrit dans `./.od/` (local au projet). Définissez `OD_DATA_DIR=~/.open-design` pour partager les données entre projets.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Piloter Open Design depuis n’importe quel shell',
  'useEverywhere.section.cli.intro': 'Le binaire `od` est fourni avec le daemon et c’est le même binaire qu’utilisent Claude Code / Codex lorsqu’ils lancent une génération. La plupart des sous-commandes sont de fins clients qui POSTent vers le daemon local ; elles fonctionnent donc de la même façon, que vous l’ayez lancé via `pnpm tools-dev` ou comme app packagée.',
  'useEverywhere.section.cli.bullet1': '`od` (sans argument) — démarre le daemon et ouvre l’UI web.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produit des octets image / vidéo / audio via le protocole média unifié.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — démarre une exécution de projet depuis un prompt + un Skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — installe et applique des plugins communautaires.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — inspecte ce qui est disponible localement.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — vérifie la santé du daemon et détecte les CLI d’agents dans votre PATH.',
  'useEverywhere.section.cli.snippet1': 'Générer une image (délègue au fournisseur média configuré)',
  'useEverywhere.section.cli.snippet2': 'Lancer un plugin de scénario en mode sans interface et streamer les événements en lignes JSON',
  'useEverywhere.section.cli.snippet3': 'Inventorier les Skills et systèmes de design disponibles localement',
  'useEverywhere.section.cli.snippet4': 'Vérifier les artefacts amorcés via la CLI',
  'useEverywhere.section.cli.snippet5': 'Vérifier l’environnement + les agents détectés (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Toutes les sous-commandes acceptent `--daemon-url http://127.0.0.1:<port>` pour cibler un daemon en cours d’exécution précis — utile avec une deuxième instance sandboxée pour les tests.',
  'useEverywhere.section.mcp.tab': 'Serveur MCP',
  'useEverywhere.section.mcp.heading': 'Exposer Open Design comme serveur MCP à tout agent de code',
  'useEverywhere.section.mcp.intro': 'Open Design fournit un serveur Model Context Protocol (`od mcp`) qui permet à tout client compatible MCP — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — de découvrir les outils Open Design (lister les Skills, générer des aperçus, générer des médias, lancer des plugins) sans exécuter manuellement de commandes shell. Le daemon publie un extrait d’installation prêt à coller via `GET /api/mcp/install-info` pour chaque grand client.',
  'useEverywhere.section.mcp.bullet1': 'Transport stdio — aucun port supplémentaire, le client lance directement `od mcp`.',
  'useEverywhere.section.mcp.bullet2': 'Découvre automatiquement l’URL du daemon actif via le socket IPC local quand il est lancé comme sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Retombe sur `--daemon-url http://127.0.0.1:<port>` pour les installations simples afin que le processus MCP trouve toujours un daemon en cours d’exécution.',
  'useEverywhere.section.mcp.bullet4': 'Fixe `OD_DATA_DIR` pour que le processus MCP lancé écrive au même endroit que le daemon déjà actif (évite EPERM dans les bundles macOS packagés).',
  'useEverywhere.section.mcp.snippet1': 'Configuration générique de client MCP (fonctionne dans Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Ou : demander au daemon l’extrait adapté à votre installation',
  'useEverywhere.section.mcp.snippet3': 'Variante MCP pour artefacts dynamiques (lire et actualiser des dashboards)',
  'useEverywhere.section.mcp.footer': 'Dans l’app Open Design, ouvrez Paramètres → Intégrations pour copier une commande d’installation propre au client (Cursor, Claude Code, Antigravity, VS Code) au lieu d’éditer du JSON à la main.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'La même surface REST + SSE que l’UI web',
  'useEverywhere.section.http.intro': 'Le daemon local expose une API HTTP sur `http://127.0.0.1:7456` (port configurable). Tous les endpoints appelés par l’UI web peuvent aussi être utilisés par vos scripts. Les endpoints de streaming (tours de chat, exécutions de projet) émettent des Server-Sent Events avec les types de contrat de `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — disponibilité du daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` et `GET /api/design-systems` — registres disponibles.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` et `POST /api/projects` — lister et créer des projets (POST renvoie le projet + la première conversation).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — flux SSE des événements de l’agent pour une conversation.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — associe un plugin installé et renvoie sa requête d’exemple rendue + ses inputs.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLI d’agents de code détectées dans votre PATH.',
  'useEverywhere.section.http.snippet1': 'Lister les Skills installés (l’agent les utilisera comme modèles)',
  'useEverywhere.section.http.snippet2': 'Créer un projet depuis un prompt (flux complet côté serveur)',
  'useEverywhere.section.http.snippet3': 'Suivre une exécution agent (SSE — trames event/data)',
  'useEverywhere.section.http.footer': 'Les types TypeScript purs pour chaque requête/réponse vivent dans `@open-design/contracts` — importez-les dans votre script pour profiter de l’autocomplétion sans générateur.',
  'useEverywhere.section.skills.tab': 'Skills et mode sans interface',
  'useEverywhere.section.skills.heading': 'Skills prêts à déposer pour les agents compatibles et les flux Open Design sans interface',
  'useEverywhere.section.skills.intro': 'Un Skill est un dossier avec un `SKILL.md` compatible Claude (front matter YAML + corps). Open Design étend ce format avec l’espace de noms `od:` (`mode`, `preview`, `design_system`, `inputs`, …) afin que le même artefact puisse être utilisé dans Open Design et, quand l’agent le prend en charge, par chargement natif des Skills. Les autres agents passent par l’injection de prompt Open Design. La découverte suit une chaîne de priorité pour que les projets puissent remplacer leurs propres Skills.',
  'useEverywhere.section.skills.bullet1': 'Découverte : `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (le projet gagne).',
  'useEverywhere.section.skills.bullet2': 'Créez un lien symbolique vers un Skill dans plusieurs projets pour le partager sans copie.',
  'useEverywhere.section.skills.bullet3': 'Chaque Skill peut déclarer des connecteurs, atoms, exigences de système de design et un exemple `preview` pour la galerie.',
  'useEverywhere.section.skills.bullet4': 'Mode sans interface : avec `od` dans le PATH, `od skills list` passe par le daemon local ; pour lancer un Skill, créez un projet avec `od project create --skill <id>`, puis démarrez une exécution avec `od run start --project <id>`.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` exerce la même forme d’artefact avec les exemples de plugins par défaut et communautaires, puis stocke les projets `index.html` obtenus comme données de test réutilisables.',
  'useEverywhere.section.skills.snippet1': 'SKILL.md minimal (front matter compatible Claude + extras Open Design)',
  'useEverywhere.section.skills.snippet2': 'Créer un lien symbolique vers un Skill partagé dans un projet (style cc-switch)',
  'useEverywhere.section.skills.snippet3': 'Mode sans interface : lister les Skills que le daemon voit maintenant',
  'useEverywhere.section.skills.snippet4': 'Lot de fixtures d’artefacts sans interface',
  'useEverywhere.section.skills.footer': 'Spec : `docs/skills-protocol.md` et `docs/agent-adapters.md` couvrent toute la surface des adaptateurs (Claude Code, Codex, Cursor, agents compatibles MCP, fallback API BYOK) et les stratégies d’injection de Skills par adaptateur.',
  'tasks.kicker': 'Espace d’automatisation',
  'tasks.comingSoon': 'Bientôt disponible',
  'tasks.lede': 'Les automatisations transforment les prompts en travail durable : Orbit les exécute, les routines les conservent, les planifications décident quand elles se déclenchent, et les artefacts dynamiques montrent ce qui a changé.',
  'tasks.newAutomation': 'Nouvelle automatisation',
  'tasks.previewNote': 'Surface d’aperçu uniquement. Les paramètres Orbit sont disponibles aujourd’hui ; les routines, planifications et connexions aux artefacts dynamiques arriveront avec la fusion des branches backend.',
  'tasks.primitivesAria': 'Primitives d’automatisation',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Un runtime persistant pour les travaux agent longs ou récurrents.',
  'tasks.primitive.orbit.enabled': 'Résumé quotidien activé',
  'tasks.primitive.orbit.manualOnly': 'Manuel uniquement',
  'tasks.primitive.routines.title': 'Routines',
  'tasks.primitive.routines.body': 'Définitions de tâches durables qui survivent après la fin d’un chat.',
  'tasks.primitive.routines.meta': 'Shell produit prêt',
  'tasks.primitive.schedules.title': 'Planifications',
  'tasks.primitive.schedules.body': 'Déclencheurs temporels ou événementiels qui décident quand une routine doit s’exécuter.',
  'tasks.primitive.schedules.meta': 'Branche en attente',
  'tasks.primitive.liveArtifacts.title': 'Artefacts dynamiques',
  'tasks.primitive.liveArtifacts.body': 'Rapports et notes qui continuent de se mettre à jour pendant qu’un agent travaille.',
  'tasks.primitive.liveArtifacts.meta': 'Modèle d’aperçu',
  'tasks.listAria': 'Liste des automatisations',
  'tasks.routinesAndRuns': '{n} routines et exécutions',
  'tasks.filtersAria': 'Filtres des automatisations',
  'tasks.filter.scheduled': 'Planifiées',
  'tasks.filter.running': 'En cours',
  'tasks.filter.done': 'Terminées',
  'tasks.configurationAria': 'Configuration de l’automatisation',
  'tasks.slot.trigger': 'Déclencheur',
  'tasks.slot.pattern': 'Motif',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Sortie',
  'tasks.liveArtifact': 'Artefact dynamique',
  'tasks.viewProgress': 'Voir la progression',
  'tasks.pause': 'Suspendre',
  'tasks.runNow': 'Lancer maintenant',
  'tasks.openArtifact': 'Ouvrir l’artefact',
  'tasks.status.dailyAt': 'Quotidien · {time}',
  'tasks.status.pausedManual': 'Suspendu · manuel uniquement',
  'tasks.sample.orbit.title': 'Résumé quotidien Orbit des connecteurs',
  'tasks.sample.orbit.metaEnabled': 'Le digest des connecteurs est planifié',
  'tasks.sample.orbit.metaDisabled': 'Ouvrez les paramètres Orbit pour l’activer',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · artefact dynamique',
  'tasks.sample.orbit.previewDisabled': 'Aucune exécution planifiée',
  'tasks.sample.orbit.triggerEnabled': 'Planification · chaque jour à {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuel · lancer à la demande',
  'tasks.sample.orbit.pattern': 'Routine · digest des connecteurs',
  'tasks.sample.orbit.runtime': 'Orbit · planifié par le daemon',
  'tasks.sample.orbit.output': 'Artefact dynamique · rapport actualisable',
  'tasks.sample.orbit.artifactMetaEnabled': 'S’actualise après chaque exécution',
  'tasks.sample.orbit.artifactMetaDisabled': 'En attente de planification',
  'tasks.sample.orbit.body1': '# Résumé quotidien de l’activité Orbit',
  'tasks.sample.orbit.body2': 'Connecteurs vérifiés · réussites, ignorés et échecs',
  'tasks.sample.orbit.body3': 'Les temps forts deviennent un artefact dynamique actualisable.',
  'tasks.sample.mcp.title': 'Recherche sur les alternatives MCP',
  'tasks.sample.mcp.status': 'En cours dans Orbit · 2 h 14 min',
  'tasks.sample.mcp.meta': '14 / 30 sources traitées',
  'tasks.sample.mcp.preview': 'research_notes.md · en direct',
  'tasks.sample.mcp.trigger': 'Manuel · ponctuel',
  'tasks.sample.mcp.pattern': 'Prompt de recherche approfondie',
  'tasks.sample.mcp.runtime': 'Distant · persistant',
  'tasks.sample.mcp.output': 'Rapport dynamique · mise à jour auto',
  'tasks.sample.mcp.artifactMeta': 'Mis à jour il y a 12 s',
  'tasks.sample.mcp.body1': '# Alternatives MCP - constats intermédiaires',
  'tasks.sample.mcp.body2': '14 sources examinées · 3 candidats présélectionnés',
  'tasks.sample.mcp.body3': '## Présélection',
  'tasks.sample.mcp.body4': '- Schémas d’appels d’outils via JSON-RPC...',
  'tasks.sample.mcp.body5': '- Protocoles d’agents basés sur gRPC...',
  'tasks.sample.weekly.title': 'Digest hebdomadaire d’équipe',
  'tasks.sample.weekly.status': 'Prochain : lun. 9:00',
  'tasks.sample.weekly.meta': 'Met à jour le doc hebdo de l’équipe',
  'tasks.sample.weekly.preview': 'team_weekly.md · prochain artefact',
  'tasks.sample.weekly.trigger': 'Planification · hebdomadaire',
  'tasks.sample.weekly.pattern': 'Routine · digest d’équipe',
  'tasks.sample.weekly.runtime': 'Distant · récurrent',
  'tasks.sample.weekly.output': 'Artefact dynamique · Markdown',
  'tasks.sample.weekly.artifactMeta': 'Dernière mise à jour il y a 4 j',
  'tasks.sample.weekly.body1': '# Hebdo équipe',
  'tasks.sample.weekly.body2': '## En cours',
  'tasks.sample.weekly.body3': '- Passe d’intégration du système de design',
  'tasks.sample.weekly.body4': '- Revue qualité des connecteurs',
  'tasks.sample.weekly.body5': '## Risques',
  'tasks.sample.pr.title': 'Rappel de revue PR',
  'tasks.sample.pr.status': 'Sur nouvelle PR · déclenché il y a 23 min',
  'tasks.sample.pr.meta': 'Envoie un DM Slack',
  'tasks.sample.pr.preview': 'Dernière livraison réussie',
  'tasks.sample.pr.trigger': 'Événement · nouvelle PR',
  'tasks.sample.pr.pattern': 'Routine · alerte',
  'tasks.sample.pr.runtime': 'Local · exécution rapide',
  'tasks.sample.pr.output': 'Message · DM Slack',
  'tasks.sample.pr.artifactMeta': 'Dernier déclenchement il y a 23 min',
  'tasks.sample.pr.body1': 'PR #184 ouverte pour revue',
  'tasks.sample.pr.body2': 'Relecteurs associés : design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Livraison : DM Slack envoyé',
  'tasks.sample.meeting.title': 'Préparation de réunion',
  'tasks.sample.meeting.status': 'Demain · 10:00',
  'tasks.sample.meeting.meta': 'Ponctuel · envoie un résumé',
  'tasks.sample.meeting.preview': 'meeting_brief.md · en file',
  'tasks.sample.meeting.trigger': 'Planification · ponctuelle',
  'tasks.sample.meeting.pattern': 'Prompt de briefing',
  'tasks.sample.meeting.runtime': 'Distant · borné',
  'tasks.sample.meeting.output': 'Artefact + message',
  'tasks.sample.meeting.artifactMeta': 'En file pour génération',
  'tasks.sample.meeting.body1': '# Brief de réunion',
  'tasks.sample.meeting.body2': 'Source de l’agenda : événement calendrier + docs liés',
  'tasks.sample.meeting.body3': 'La sortie inclura décisions, blocages et questions.',
  'tasks.sample.candidate.title': 'Suivi des candidats',
  'tasks.sample.candidate.status': 'Échec · attention requise',
  'tasks.sample.candidate.meta': 'Authentification expirée',
  'tasks.sample.candidate.preview': 'Reconnectez Greenhouse pour reprendre',
  'tasks.sample.candidate.trigger': 'Planification · quotidienne',
  'tasks.sample.candidate.pattern': 'Routine · synchronisation candidats',
  'tasks.sample.candidate.runtime': 'Distant · récurrent',
  'tasks.sample.candidate.output': 'Artefact dynamique · tableau',
  'tasks.sample.candidate.artifactMeta': 'Suspendu jusqu’à restauration de l’authentification',
  'tasks.sample.candidate.body1': '# Pipeline candidats',
  'tasks.sample.candidate.body2': 'Dernière synchronisation réussie : il y a 2 j',
  'tasks.sample.candidate.body3': 'Action requise : reconnecter le compte source.',
  'routines.title': 'Automatisations',
  'routines.subtitle': 'Automatisations planifiées qui s’exécutent sans surveillance.',
  'routines.newAutomation': 'Nouvelle automatisation',
  'routines.loading': 'Chargement…',
  'routines.empty': 'Aucune automatisation pour l’instant.',
  'routines.emptyHint': 'Cliquez sur Nouvelle automatisation pour planifier une exécution agent sans surveillance.',
  'routines.runHistoryLoading': 'Chargement des exécutions…',
  'routines.runHistoryEmpty': 'Aucune exécution pour l’instant.',
  'routines.fieldName': 'Nom',
  'routines.fieldNamePlaceholder': 'Briefing du matin',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Récupère l’activité GitHub + Linear d’hier et résume ce qui a changé.',
  'routines.fieldSchedule': 'Planification',
  'routines.fieldMinute': 'Minute de chaque heure',
  'routines.fieldTime': 'Heure',
  'routines.fieldTimezone': 'Fuseau horaire',
  'routines.fieldsetProject': 'Projet',
  'routines.kind.hourly': 'Horaire',
  'routines.kind.daily': 'Quotidienne',
  'routines.kind.weekdays': 'Jours ouvrés',
  'routines.kind.weekly': 'Hebdomadaire',
  'routines.weekday.short.0': 'Dim',
  'routines.weekday.short.1': 'Lun',
  'routines.weekday.short.2': 'Mar',
  'routines.weekday.short.3': 'Mer',
  'routines.weekday.short.4': 'Jeu',
  'routines.weekday.short.5': 'Ven',
  'routines.weekday.short.6': 'Sam',
  'routines.weekday.long.0': 'dimanche',
  'routines.weekday.long.1': 'lundi',
  'routines.weekday.long.2': 'mardi',
  'routines.weekday.long.3': 'mercredi',
  'routines.weekday.long.4': 'jeudi',
  'routines.weekday.long.5': 'vendredi',
  'routines.weekday.long.6': 'samedi',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'S’exécute toutes les heures à :{minute}',
  'routines.describe.daily': 'S’exécute chaque jour à {time} {tz}',
  'routines.describe.weekdays': 'S’exécute du lun. au ven. à {time} {tz}',
  'routines.describe.weekly': 'S’exécute chaque {day} à {time} {tz}',
  'routines.modeCreate': 'Créer un nouveau projet à chaque exécution',
  'routines.modeCreateHint': 'Un espace de travail frais et isolé à chaque déclenchement.',
  'routines.modeReuse': 'Réutiliser un projet existant',
  'routines.modeReuseHint': 'Chaque exécution vit comme une nouvelle conversation dans le projet.',
  'routines.pickProject': '— Choisir un projet —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ nouveau projet à chaque exécution',
  'routines.tagPaused': 'suspendue',
  'routines.metaNext': 'prochaine : {when}',
  'routines.metaLast': 'dernière :',
  'routines.triggerManual': 'manuelle',
  'routines.triggerScheduled': 'planifiée',
  'routines.openProject': 'Ouvrir le projet',
  'routines.openProjectTitle': 'Ouvrir le projet dans lequel cette exécution a écrit',
  'routines.runNow': 'Lancer maintenant',
  'routines.edit': 'Modifier',
  'routines.pause': 'Suspendre',
  'routines.resume': 'Reprendre',
  'routines.history': 'Historique',
  'routines.hideHistory': 'Masquer l’historique',
  'routines.delete': 'Supprimer',
  'routines.deleteTitle': 'Supprimer cette automatisation',
  'routines.cancel': 'Annuler',
  'routines.save': 'Enregistrer',
  'routines.saving': 'Enregistrement…',
  'routines.create': 'Créer',
  'routines.creating': 'Création…',
  'routines.status.queued': 'en file',
  'routines.status.running': 'en cours',
  'routines.status.succeeded': 'réussie',
  'routines.status.failed': 'échouée',
  'routines.status.canceled': 'annulée',
  'routines.confirmDelete': 'Supprimer cette automatisation ? Les exécutions passées et leurs projets seront conservés.',
  'routines.errorPickProject': 'Choisissez un projet à réutiliser, ou passez à « Créer un nouveau à chaque exécution »',
  'routines.errorAgentEmptyOutput': 'L’agent a terminé sans produire de sortie. Le modèle ou le fournisseur a peut-être renvoyé une réponse vide — vérifiez les logs de l’agent pour les erreurs amont.',
  'entry.helpAria': 'Aide',
  'entry.helpMenuAria': 'Menu d\'aide',
  'entry.helpGetHelp': 'Obtenir de l\'aide sur GitHub',
  'entry.helpSubmitFeature': 'Proposer une fonctionnalité',
  'entry.helpWhatsNew': 'Nouveautés',
  'entry.helpDownloadDesktop': 'Télécharger l\'app de bureau',
  'entry.githubStarLabel': 'Étoile',
  'entry.githubStarTitle': 'Cliquez pour nous mettre une étoile sur GitHub',
  'entry.githubStarAria': 'Mettre une étoile à Open Design sur GitHub',
  'entry.tabImageTemplates': 'Modèles d\'image',
  'entry.tabVideoTemplates': 'Modèles de vidéo',
  'promptTemplates.searchPlaceholder': 'Rechercher des modèles…',
  'promptTemplates.countLabel': '{n} résultats',
  'promptTemplates.emptyImage': 'Aucun modèle de prompt d\'image installé pour l\'instant.',
  'promptTemplates.emptyVideo': 'Aucun modèle de prompt vidéo installé pour l\'instant.',
  'promptTemplates.emptyNoMatch': 'Aucun modèle ne correspond à votre recherche.',
  'promptTemplates.attributionFooter': 'Adapté de bibliothèques de prompts publiques. Chaque carte renvoie vers l\'auteur original.',
  'promptTemplates.openPreviewTitle': 'Ouvrir le prompt et l\'aperçu',
  'promptTemplates.sourcePrefix': 'Source :',
  'promptTemplates.fetchError': 'Impossible de charger le contenu de ce modèle.',
  'promptTemplates.promptLabel': 'Corps du prompt',
  'promptTemplates.copyPrompt': 'Copier le prompt',
  'promptTemplates.copyDone': 'Copié !',
  'promptTemplates.modelHint': 'Modèle suggéré : {model}',
  'promptTemplates.openSource': 'Voir l\'original',
  'promptTemplates.openFullscreen': 'Ouvrir l\'aperçu en plein écran',
  'promptTemplates.closeFullscreen': 'Fermer l\'aperçu plein écran',
  'promptTemplates.allSources': 'Toutes les sources',
  'promptTemplates.sourceFilterAria': 'Filtrer par source',
  'promptTemplates.retry': 'Réessayer',
  'connectors.title': 'Connecteurs',
  'connectors.subtitle': 'Sources de données locales et futures pouvant alimenter les artefacts dynamiques.',
  'connectors.account': 'Compte',
  'connectors.noAccount': 'Non connecté',
  'connectors.tools': 'Outils',
  'connectors.connect': 'Connecter',
  'connectors.disconnect': 'Déconnecter',
  'connectors.authorizationPending': 'En attente d’autorisation...',
  'connectors.authorizationPendingHint': 'Terminez l’autorisation dans la fenêtre ouverte.',
  'connectors.cancelAuthorization': 'Annuler',
  'connectors.configure': 'Configurer',
  'connectors.unavailable': 'Indisponible',
  'connectors.phaseStubTitle': 'Les API de connecteurs arrivent en phase 3 ; ceci est un aperçu.',
  'connectors.statusAvailable': 'Disponible',
  'connectors.statusConnected': 'Connecté',
  'connectors.statusError': 'Erreur',
  'connectors.statusDisabled': 'Désactivé',
  'connectors.gateTitle': 'Ajoutez votre clé API Composio pour continuer',
  'connectors.gateBody': 'Collez votre clé ci-dessus, puis cliquez sur Enregistrer la clé pour charger les intégrations disponibles.',
  'connectors.aboutLabel': 'À propos',
  'connectors.detailsLabel': 'Détails',
  'connectors.statusLabel': 'Statut',
  'connectors.category.aiAgents': 'Agents IA',
  'connectors.category.aiInfrastructure': 'Infrastructure IA',
  'connectors.category.accounting': 'Comptabilité',
  'connectors.category.admin': 'Administration',
  'connectors.category.advertising': 'Publicité',
  'connectors.category.analytics': 'Analytique',
  'connectors.category.automation': 'Automatisation',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendrier',
  'connectors.category.commerce': 'Commerce',
  'connectors.category.communication': 'Communication',
  'connectors.category.contacts': 'Contacts',
  'connectors.category.dataPlatform': 'Plateforme de données',
  'connectors.category.database': 'Base de données',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Développement',
  'connectors.category.documentation': 'Documentation',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Éducation',
  'connectors.category.email': 'E-mail',
  'connectors.category.events': 'Événements',
  'connectors.category.fieldService': 'Service terrain',
  'connectors.category.finance': 'Finance',
  'connectors.category.fitness': 'Santé / fitness',
  'connectors.category.forms': 'Formulaires',
  'connectors.category.gaming': 'Jeux',
  'connectors.category.hr': 'RH',
  'connectors.category.hospitality': 'Hôtellerie',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Intégration',
  'connectors.category.localization': 'Localisation',
  'connectors.category.logistics': 'Logistique',
  'connectors.category.maps': 'Cartes',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Médias',
  'connectors.category.meetings': 'Réunions',
  'connectors.category.nonprofit': 'Associatif',
  'connectors.category.observability': 'Observabilité',
  'connectors.category.payments': 'Paiements',
  'connectors.category.personal': 'Personnel',
  'connectors.category.presentations': 'Présentations',
  'connectors.category.procurement': 'Achats',
  'connectors.category.product': 'Produit',
  'connectors.category.productivity': 'Productivité',
  'connectors.category.projectManagement': 'Gestion de projet',
  'connectors.category.recruiting': 'Recrutement',
  'connectors.category.research': 'Recherche',
  'connectors.category.salesIntelligence': 'Intelligence commerciale',
  'connectors.category.scheduling': 'Planification',
  'connectors.category.search': 'Recherche',
  'connectors.category.security': 'Sécurité',
  'connectors.category.signing': 'Signature',
  'connectors.category.social': 'Réseaux sociaux',
  'connectors.category.spreadsheets': 'Feuilles de calcul',
  'connectors.category.storage': 'Stockage',
  'connectors.category.support': 'Assistance',
  'connectors.category.surveys': 'Sondages',
  'connectors.category.tasks': 'Tâches',
  'connectors.category.timeTracking': 'Suivi du temps',
  'connectors.category.video': 'Vidéo',
  'connectors.category.whiteboard': 'Tableau blanc',
  'connectors.categoryLabel': 'Catégorie',
  'connectors.providerLabel': 'Fournisseur',
  'connectors.toolsSection': 'Outils',
  'connectors.toolsLoading': 'Chargement des outils…',
  'connectors.noToolsAvailable': 'Aucun outil disponible pour le moment. Connectez-vous pour découvrir les capacités de cette intégration.',
  'connectors.toolDetailsUnavailable': 'Les détails des outils sont indisponibles, mais ce connecteur signale {n} outils.',
  'connectors.loadMoreTools': 'Charger plus d’outils',
  'connectors.openDetailsAria': 'Ouvrir les détails de {name}',
  'connectors.toolsBadgeNone': 'Aucun outil',
  'connectors.toolsBadgeOne': '{n} outil',
  'connectors.toolsBadgeMany': '{n} outils',
  'connectors.searchPlaceholder': 'Rechercher des connecteurs…',
  'connectors.searchAriaLabel': 'Rechercher des connecteurs par nom, fournisseur ou outil',
  'connectors.searchClear': 'Effacer la recherche',
  'connectors.emptyNoMatchTitle': 'Aucun connecteur ne correspond à « {query} »',
  'connectors.emptyNoMatchBody': 'Essayez un autre mot-clé ou effacez la recherche pour voir le catalogue complet.',
  'connectors.emptyNoMatchAction': 'Effacer la recherche',
  'newproj.tabPrototype': 'Prototype',
  'newproj.tabLiveArtifact': 'Artefact dynamique',
  'newproj.tabDeck': 'Diaporama',
  'newproj.tabTemplate': 'Depuis un modèle',
  'newproj.tabMedia': 'Média',
  'newproj.tabOther': 'Autre',
  'newproj.titlePrototype': 'Nouveau prototype',
  'newproj.titleLiveArtifact': 'Nouvel artefact dynamique',
  'newproj.titleDeck': 'Nouveau diaporama',
  'newproj.titleTemplate': 'Partir d\'un modèle',
  'newproj.titleImage': 'Nouvelle image',
  'newproj.titleVideo': 'Nouvelle vidéo',
  'newproj.titleAudio': 'Nouvel audio',
  'newproj.titleMedia': 'Nouveau média',
  'newproj.titleOther': 'Nouveau projet',
  'newproj.namePlaceholder': 'Nom du projet',
  'newproj.fidelityLabel': 'Fidélité',
  'newproj.fidelityWireframe': 'Maquette filaire',
  'newproj.fidelityHigh': 'Haute fidélité',
  'newproj.toggleSpeakerNotes': 'Utiliser des notes d\'orateur',
  'newproj.toggleSpeakerNotesHint': 'Moins de texte sur les diapositives — gardez les points de discussion dans les notes.',
  'newproj.toggleAnimations': 'Inclure des animations',
  'newproj.toggleAnimationsHint': 'Ajouter du mouvement (entrée, survol, transitions) en plus du modèle.',
  'newproj.targetPlatformsLabel': 'Plateformes cibles',
  'newproj.targetPlatformsHint': 'Choisissez-en une ou plusieurs. Le web responsive couvre seulement les points de rupture du navigateur ; ajoutez iOS, Android, tablette ou application de bureau pour des variantes natives multiplateformes.',
  'newproj.platform.responsive.label': 'Web responsive',
  'newproj.platform.responsive.hint': 'Une expérience web adaptée aux navigateurs ordinateur, tablette et mobile',
  'newproj.platform.webDesktop.label': 'Web desktop',
  'newproj.platform.webDesktop.hint': 'Produit ou page d’atterrissage pensée d’abord pour le navigateur',
  'newproj.platform.mobileIos.label': 'Application iOS',
  'newproj.platform.mobileIos.hint': 'Cadres iPhone et règles d’interaction iOS',
  'newproj.platform.mobileAndroid.label': 'Application Android',
  'newproj.platform.mobileAndroid.hint': 'Cadres Pixel et règles d’interaction Material',
  'newproj.platform.tablet.label': 'Application tablette',
  'newproj.platform.tablet.hint': 'Expérience tablette native avec vues fractionnées',
  'newproj.platform.desktopApp.label': 'Application de bureau',
  'newproj.platform.desktopApp.hint': 'Habillage d’application macOS/Windows',
  'newproj.surfaceOptionsLabel': 'Surfaces complémentaires',
  'newproj.includeLandingPage': 'Inclure une page d’atterrissage',
  'newproj.includeLandingPageHint': 'Ajoutez une page marketing responsive pour publicités, listes d’attente, lancements, téléchargements d’application ou explication produit.',
  'newproj.includeOsWidgets': 'Inclure des widgets OS',
  'newproj.includeOsWidgetsHint': 'Ajoutez des widgets natifs de plateforme pour écran d’accueil, écran verrouillé ou accès rapide sur mobile/tablette.',
  'newproj.includeOsWidgetsDisabledHint': 'Disponible quand iOS, Android ou application tablette est sélectionné comme plateforme cible.',
  'newproj.templateLabel': 'Modèle',
  'newproj.noTemplatesTitle': 'Aucun modèle pour l\'instant',
  'newproj.noTemplatesBody': 'Ouvrez un projet, puis utilisez le menu Partager dans la visionneuse de fichiers pour le convertir en modèle. Les modèles apparaissent ici.',
  'newproj.savedTemplate': 'Modèle enregistré',
  'newproj.fileSingular': 'fichier',
  'newproj.filePlural': 'fichiers',
  'newproj.create': 'Créer',
  'newproj.locationLabel': 'Enregistrer dans',
  'newproj.locationDefault': 'Projets Open Design',
  'newproj.locationExternalBase': 'Base externe',
  'newproj.createLiveArtifact': 'Créer un artefact dynamique',
  'newproj.createFromTemplate': 'Créer depuis le modèle',
  'newproj.createDisabledTitle': 'Enregistrez d\'abord un projet comme modèle (menu Partager dans un projet).',
  'newproj.openFolder': 'Ouvrir un dossier',
  'newproj.openingFolder': 'Ouverture…',
  'newproj.importClaudeZip': 'Importer un ZIP Claude Design',
  'newproj.importClaudeZipTitle': 'Importer une exportation .zip Claude Design',
  'newproj.importingClaudeZip': 'Importation…',
  'newproj.privacyFooter': 'Seul vous pouvez voir votre projet par défaut.',
  'newproj.designSystem': 'Système de design',
  'newproj.dsNoneFreeform': 'Aucun — libre',
  'newproj.dsNoneSubtitleEmpty': 'Aucun jeton de système de design ; choisissez votre propre palette',
  'newproj.dsNoneSubtitleSelected': 'Ignorer les jetons du système de design. L\'agent choisit sa propre palette.',
  'newproj.dsCategoryFallback': 'Système de design',
  'newproj.dsSearch': 'Rechercher des systèmes de design…',
  'newproj.dsModeAria': 'Mode de sélection',
  'newproj.dsModeSingle': 'Unique',
  'newproj.dsModeMulti': 'Multiple',
  'newproj.dsNoneTitle': 'Aucun — libre',
  'newproj.dsNoneSub': 'Ignorer les jetons du système de design. L\'agent choisit sa propre palette.',
  'newproj.dsEmpty': 'Aucun système de design ne correspond à « {query} ».',
  'newproj.dsFootSingular': 'sert uniquement d’inspiration.',
  'newproj.dsFootPlural': 'servent uniquement d’inspiration.',
  'newproj.dsFootClear': 'Effacer',
  'newproj.dsBadgeDefault': 'PAR DÉFAUT',
  'newproj.dsPrimaryFallback': 'Primaire',
  'newproj.surfaceImage': 'Image',
  'newproj.surfaceVideo': 'Vidéo',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modèle',
  'newproj.modelSearch': 'Rechercher des modèles…',
  'newproj.modelEmpty': 'Aucun modèle ne correspond.',
  'newproj.modelRecommended': 'Recommandé',
  'newproj.modelMissingTitle': 'Choisir un modèle',
  'newproj.modelMissingSub': 'Choisissez le modèle pour cette surface.',
  'newproj.aspectLabel': 'Format',
  'newproj.videoLengthLabel': 'Durée',
  'newproj.videoLengthSeconds': '{n} s',
  'newproj.audioKindLabel': 'Type d\'audio',
  'newproj.audioKindMusic': 'Musique',
  'newproj.audioKindSpeech': 'Voix / TTS',
  'newproj.audioKindSfx': 'Effets sonores',
  'newproj.audioDurationLabel': 'Durée',
  'newproj.audioDurationSeconds': '{n} s',
  'newproj.voiceLabel': 'Voix',
  'newproj.voicePlaceholder': 'Identifiant de voix du fournisseur, optionnel',
  'newproj.connectorsLabel': 'Connecteurs',
  'newproj.connectorsHint': 'Sources de données que cet artefact peut interroger.',
  'newproj.connectorsEmptyTitle': 'Aucun connecteur configuré',
  'newproj.connectorsEmptyBody': 'Connectez une source de données pour que l\'artefact dynamique utilise de vraies données au lieu d\'espaces réservés.',
  'newproj.connectorsEmptyCta': 'Configurer les connecteurs →',
  'newproj.connectorsLoading': 'Chargement des connecteurs…',
  'newproj.connectorsCountOne': '{n} connecté',
  'newproj.connectorsCountMany': '{n} connectés',
  'newproj.connectorsManage': 'Gérer',
  'newproj.promptTemplateLabel': 'Modèle de référence',
  'newproj.promptTemplateNoneTitle': 'Aucun — rédigez le vôtre',
  'newproj.promptTemplateNoneSub': 'Ignorer la galerie, décrivez votre propre brief',
  'newproj.promptTemplateRefSub': 'Modèle de référence',
  'newproj.promptTemplateSearch': 'Rechercher des modèles…',
  'newproj.promptTemplateEmpty': 'Aucun modèle installé pour cette surface pour l\'instant.',
  'newproj.promptTemplateBodyLabel': 'Prompt (vous pouvez l\'ajuster)',
  'newproj.promptTemplateOptimizeHint': 'Modifiez ce que vous voulez — vos modifications sont transmises au brief de l\'agent.',
  'newproj.promptTemplateBodyEmpty': 'Corps vide — l\'agent ne recevra aucune référence de modèle.',
  'newproj.deleteTemplateTitle': 'Supprimer le modèle',
  'newproj.deleteTemplateConfirm': 'Supprimer « {name} » ? Cette action est irréversible.',
  'newproj.deleteTemplateConfirmCta': 'Supprimer le modèle',
  'newproj.deleteTemplateError': 'Impossible de supprimer ce modèle. Veuillez réessayer.',
  'designs.subRecent': 'Récents',
  'designs.subYours': 'Vos designs',
  'designs.filterAria': 'Filtrer les projets',
  'designs.searchPlaceholder': 'Rechercher…',
  'designs.emptyNoProjects': 'Aucun projet pour l\'instant.',
  'designs.emptyNoMatch': 'Aucun projet ne correspond à votre recherche.',
  'designs.deleteTitle': 'Supprimer le projet',
  'designs.deleteConfirm': 'Supprimer « {name} » ?',
  'designs.cardFreeform': 'libre',
  'designs.badgeLive': 'Dynamique',
  'designs.liveArtifactBadgesAria': 'Badges d’artefact dynamique',
  'designs.liveCount': '{n} dynamiques',
  'designs.statusLive': 'Artefact dynamique',
  'designs.statusArchived': 'Archivé',
  'designs.statusError': 'Erreur',
  'designs.statusRefreshing': 'Actualisation…',
  'designs.statusRefreshFailed': 'Échec de l’actualisation',
  'designs.statusRefreshed': 'Actualisé',
  'designs.status.notStarted': 'Non commencé',
  'designs.status.queued': 'En file d\'attente',
  'designs.status.running': 'En cours',
  'designs.status.awaitingInput': 'Entrée requise',
  'designs.status.incomplete': 'Incomplet',
  'designs.status.succeeded': 'Terminé',
  'designs.status.published': 'Publié',
  'designs.status.failed': 'Échoué',
  'designs.status.canceled': 'Annulé',
  'designs.viewToggleAria': 'Mode d\'affichage',
  'designs.viewGrid': 'Vue grille',
  'designs.viewKanban': 'Vue tableau',
  'designs.kanbanEmptyColumn': 'Aucun design',
  'designs.deleteAria': 'Supprimer le projet {name}',
  'designs.menuMore': 'Plus d’actions',
  'designs.menuRename': 'Renommer',
  'designs.menuDuplicate': 'Dupliquer le projet',
  'designs.menuDelete': 'Supprimer',
  'designs.renamePrompt': 'Nouveau nom pour « {name} »',
  'designs.selectMode': 'Sélectionner',
  'designs.cancelSelect': 'Annuler',
  'designs.deleteSelected': 'Supprimer la sélection',
  'designs.selectedCount': '{n} sélectionné(s)',
  'designs.deleteSelectedConfirm': 'Supprimer {n} projet(s) ?',
  'designs.deleteSelectedSuccess': '{n} projet(s) supprimé(s) avec succès.',
  'designs.deleteSelectedPartial': '{deleted} projet(s) supprimé(s) ; {failed} échec(s).',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Artefact dynamique',
  'designs.tagWebClone': 'Clone de site web',
  'designs.tagSlide': 'Diapositive',
  'designs.tagMedia': 'Média',
  'designs.renameTitle': 'Renommer le projet',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Annuler',
  'examples.typeLabel': 'Type',
  'examples.surfaceLabel': 'Surface',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Image',
  'examples.surfaceVideo': 'Vidéo',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Scénario',
  'examples.modeAll': 'Tout',
  'examples.modePrototypeDesktop': 'Prototypes · Bureau',
  'examples.modePrototypeMobile': 'Prototypes · Mobile',
  'examples.modeDeck': 'Diaporamas',
  'examples.modeDocument': 'Docs et modèles',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Dynamique',
  'examples.scenarioGeneral': 'Général',
  'examples.scenarioEngineering': 'Ingénierie',
  'examples.scenarioProduct': 'Produit',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Ventes',
  'examples.scenarioFinance': 'Finance',
  'examples.scenarioHr': 'RH',
  'examples.scenarioOperations': 'Opérations',
  'examples.scenarioSupport': 'Assistance',
  'examples.scenarioLegal': 'Juridique',
  'examples.scenarioEducation': 'Éducation',
  'examples.scenarioPersonal': 'Personnel',
  'examples.searchPlaceholder': 'Rechercher des exemples…',
  'examples.searchAria': 'Rechercher des exemples par nom',
  'examples.emptyNoSkills': 'Aucun Skill disponible. Le daemon est-il en cours d\'exécution ?',
  'examples.emptyNoMatch': 'Aucun exemple ne correspond à ces filtres.',
  'examples.openPreview': '⤢ Ouvrir l\'aperçu',
  'examples.loadingPreview': 'Chargement de l\'aperçu…',
  'examples.hoverPreview': 'Survoler pour prévisualiser',
  'examples.usePrompt': 'Utiliser ce prompt',
  'examples.previewModalTitle': 'Ouvrir l\'aperçu complet (modale)',
  'examples.shareTitle': 'Partager cet exemple',
  'examples.shareLoadFirst': 'Survolez pour charger l\'aperçu d\'abord',
  'examples.unavailablePlaceholder': 'Pas d\'aperçu {kind} fourni — ouvrez pour en savoir plus',
  'examples.shareUnavailable': 'Pas d\'aperçu {kind} fourni à partager',
  'examples.shareMenu': 'Partager ▾',
  'examples.exportPdfAllSlides': 'Exporter en PDF (toutes les diapos)',
  'examples.exportPptxLocked': 'Exporter en PPTX… (ouvrez d\'abord le modèle)',
  'examples.tagSlideDeck': 'Diaporama',
  'examples.tagTemplate': 'Modèle',
  'examples.tagDesignSystem': 'Système de design',
  'examples.tagMobilePrototype': 'Prototype mobile',
  'examples.tagDesktopPrototype': 'Prototype bureau',
  'examples.tagImage': 'Image',
  'examples.tagVideo': 'Vidéo',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Aperçu',
  'ds.surfaceLabel': 'Surface',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Image',
  'ds.surfaceVideo': 'Vidéo',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Rechercher des systèmes de design…',
  'ds.emptyNoMatch': 'Aucun système de design ne correspond à votre recherche.',
  'ds.badgeDefault': 'PAR DÉFAUT',
  'ds.preview': 'Aperçu',
  'ds.previewTitle': 'Aperçu du système de design',
  'ds.categoryAll': 'Tout',
  'ds.categoryUncategorized': 'Non catégorisé',
  'ds.showcase': 'Vitrine',
  'ds.tokens': 'Jetons',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Chargement du DESIGN.md…',
  'avatar.title': 'Compte et paramètres',
  'avatar.localCli': 'CLI local',
  'avatar.anthropicApi': 'API Anthropic',
  'avatar.useLocal': 'Utiliser le CLI local',
  'avatar.useApi': 'Utiliser API · BYOK',
  'avatar.codeAgent': 'Agent de code',
  'avatar.rescan': 'Réanalyser le PATH',
  'avatar.amrConsole': 'Compte Open Design Cloud',
  'avatar.amrConsoleMeta': 'Solde et recharge',
  'avatar.settings': 'Paramètres',
  'avatar.backToProjects': 'Retour aux projets',
  'avatar.metaActive': 'actif',
  'avatar.metaOffline': 'hors ligne',
  'avatar.metaSelected': 'sélectionné',
  'avatar.noAgentSelected': 'aucun agent sélectionné',
  'avatar.modelSection': 'Modèle',
  'avatar.modelLabel': 'Modèle',
  'avatar.reasoningLabel': 'Raisonnement',
  'avatar.serviceTierLabel': 'Niveau de service',
  'avatar.customSuffix': '(personnalisé)',
  'socialShare.openDesignSection': 'Partager Open Design',
  'socialShare.openDesignTitle': 'Open Design sur GitHub',
  'socialShare.openDesignText': 'Open Design est un workspace à code source disponible pour créer, modifier, déployer et transmettre des artefacts de design.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'PARTAGE SOCIAL',
  'socialShare.publishPageTitle': 'Publier la page de partage',
  'socialShare.publishPageSubtitle': 'Publiez cet aperçu pour pouvoir le partager sur les plateformes sociales.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Créé avec Open Design : {title}. Voir l’artefact déployé et mettre une étoile au dépôt : {repo}',
  'socialShare.projectCopyText': 'Créé avec Open Design : {title}\n{url}\nDépôt Open Design : {repo}',
  'socialShare.deployFirst': 'Déployez puis partagez…',
  'socialShare.copied': 'Copié',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Changer de CLI / modèle',
  'inlineSwitcher.chipCli': 'CLI locale',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'par défaut',
  'inlineSwitcher.noAgent': 'aucun agent',
  'inlineSwitcher.modeLabel': 'Mode',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Fournisseur',
  'inlineSwitcher.modelLabel': 'Modèle',
  'inlineSwitcher.useCli': 'Utiliser la CLI locale',
  'inlineSwitcher.useByok': 'Utiliser votre clé API',
  'inlineSwitcher.daemonOffline': 'Daemon hors ligne — ouvrez les paramètres',
  'inlineSwitcher.noAgentsDetected': 'Aucune CLI détectée dans le PATH',
  'inlineSwitcher.openSettingsForModel': 'Configurez le fournisseur dans les Paramètres',
  'inlineSwitcher.missingApiKey': 'Clé API manquante — ajoutez-la dans les Paramètres.',
  'inlineSwitcher.openFullSettings': 'Ouvrir les paramètres d\'exécution',
  'inlineSwitcher.customSuffix': '(personnalisé)',
  'project.backToProjects': 'Retour aux projets',
  'project.brandReadyTitle': 'Le système de design {name} est prêt',
  'project.brandReadyTitleGeneric': 'Votre système de design est prêt',
  'project.brandReadyCta': 'Aperçu dans Systèmes de design',
  'project.brandReadyDismiss': 'Ignorer',
  'project.brandReadyRefineHint': 'L’extraction automatique peut manquer certains détails. Affinez ce système avant de l’utiliser largement.',
  'project.brandReadyAiOptimize': 'Optimiser avec l’IA',
  'project.brandReadyEditManually': 'Modifier manuellement',
  'project.brandReadyPreviewOpened': 'Aperçu du système de design ouvert.',
  'project.previewCommentSaveFailed': "Le commentaire n'a pas pu être enregistré. Veuillez réessayer.",
  'project.previewCommentReorderFailed': "L'ordre des commentaires n'a pas pu être enregistré et pourrait être réinitialisé au prochain chargement.",
  'project.metaFreeform': 'libre',
  'project.typePrototype': 'Prototype',
  'project.typeDeck': 'Diapositives',
  'project.typeTemplate': 'Modèle',
  'project.typeImage': 'Image',
  'project.typeVideo': 'Vidéo',
  'project.typeAudio': 'Audio',
  'project.customInstructions': 'Instructions du projet',
  'project.customInstructionsPlaceholder': 'Instructions pour ce projet (injectées dans chaque message)…',
  'project.resizeChatPanel': 'Redimensionner le panneau de chat',
  'project.instructionsActive': 'Actif — inclus dans chaque message',
  'project.missing': 'Ce projet a été supprimé ou n’existe plus.',
  'chat.tabChat': 'Discussion',
  'chat.tabComments': 'Commentaires',
  'chat.commentsSoon': 'Commentaires — bientôt disponible',
  'chat.comments.attached': 'Attaché au chat',
  'chat.comments.emptyAttached': 'Aucun commentaire attaché.',
  'chat.comments.saved': 'Commentaires enregistrés',
  'chat.comments.emptySaved': 'Aucun commentaire enregistré.',
  'chat.comments.add': 'Ajouter',
  'chat.comments.addAll': 'Tout ajouter',
  'chat.comments.remove': 'Retirer',
  'chat.comments.placeholder': 'Commenter cet élément…',
  'chat.comments.addSend': 'Ajouter et envoyer',
  'chat.comments.updateSend': 'Mettre à jour et envoyer',
  'chat.comments.removeAttachment': 'Retirer le commentaire attaché',
  'chat.comments.removeAttachmentAria': 'Retirer le commentaire attaché pour {name}',
  'chat.comments.comment': 'Commentaire',
  'chat.comments.sendToChat': 'Envoyer au chat',
  'chat.comments.sending': 'Envoi…',
  'chat.comments.edit': 'Modifier',
  'chat.comments.select': 'Sélectionner',
  'chat.comments.selectAll': 'Tout sélectionner',
  'chat.comments.deselect': 'Désélectionner',
  'chat.comments.nSelected': '{n} sélectionné(s)',
  'chat.comments.pin': 'Épingler',
  'chat.comments.addNote': 'Ajouter une note',
  'chat.comments.savedToast': 'Commentaire enregistré',
  'chat.comments.pinSavedToast': 'Épingle enregistrée',
  'chat.comments.pinAtCoords': 'à {x}, {y}',
  'chat.comments.capturedItems': '{n} élément(s) capturé(s)',
  'chat.comments.clear': 'Effacer',
  'chat.comments.targetImage': 'Image',
  'chat.comments.targetControl': 'Contrôle',
  'chat.comments.targetLink': 'Lien',
  'chat.comments.targetText': 'Texte',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Zone',
  'chat.annotationNotePlaceholder': 'Ajouter une note à ce repère',
  'chat.annotationAttachImage': 'Joindre une image',
  'chat.annotationAttachedImages': 'Images jointes',
  'chat.annotationAttachedRemove': 'Supprimer la dernière image',
  'chat.annotationAddToInput': 'Ajouter au champ',
  'chat.annotationAddingToInput': 'Ajout…',
  'chat.annotationQueue': 'File d’attente',
  'chat.annotationQueueing': 'Ajout à la file…',
  'chat.annotationSubmitOptions': 'Options d\'envoi',
  'chat.annotationSending': 'Envoi…',
  'chat.annotationSendDisabledReason': 'Une tâche est déjà en cours',
  'chat.annotationPreviewMissing': 'Impossible de capturer l’aperçu. Veuillez réessayer.',
  'chat.annotationPreviewMissingInk': 'Impossible de capturer l’aperçu. Réessayez pour éviter d’envoyer uniquement le tracé.',
  'chat.annotationSentWithoutScreenshot': 'Impossible de capturer l’aperçu. L’annotation a été envoyée sans capture d’écran.',
  'chat.annotationTimeout': 'L’envoi de l’annotation a expiré. Veuillez réessayer.',
  'chat.annotationFailed': 'L’envoi de l’annotation a échoué. Veuillez réessayer.',
  'chat.annotationProjectCreateFailed': 'Impossible de créer un projet, donc l’annotation n’a pas été envoyée.',
  'chat.annotationUploadFailed': 'L’envoi de la pièce jointe a échoué. Veuillez réessayer.',
  'chat.conversationsTitle': 'Conversations',
  'chat.conversationsAria': 'Historique des conversations',
  'chat.newConversation': 'Nouvelle conversation',
  'chat.newConversationsTitle': 'Nouvelle conversation',
  'chat.conversationsHeading': 'Conversations',
  'chat.new': 'Nouvelle',
  'chat.emptyConversations': 'Aucune conversation pour l\'instant.',
  'chat.deleteConversation': 'Supprimer la conversation',
  'chat.renameConversationLabel': 'Renommer « {title} »',
  'chat.deleteConversationConfirm': 'Supprimer « {title} » ? Cela supprime ses messages.',
  'chat.untitledConversation': 'Conversation sans titre',
  'chat.forkedConversationTitle': 'Fork de {title}',
  'chat.forkConversationFailed': 'Impossible de créer un fork de cette conversation.',
  'chat.startTitle': 'Démarrer une conversation',
  'chat.startHint': 'Décrivez ce que vous voulez générer, ou partez de l’un de ces exemples :',
  'chat.brandBrowserAssistDesktopOnly': 'L’assistance navigateur nécessite l’app desktop afin qu’Open Design puisse lire la page active du navigateur.',
  'chat.brandBrowserAssistReadFailed': 'Impossible de lire la page du navigateur. Assurez-vous que le site de la marque est ouvert et entièrement chargé.',
  'chat.brandBrowserAssistMessage': 'Open Design a besoin de l’assistance navigateur pour terminer cette extraction de marque. Utilisez la carte ci-dessous pour ouvrir Browser, puis cliquez sur Plus, choisissez Télécharger la page, attendez le message de réussite, et utilisez la carte Étape suivante à gauche pour continuer l’extraction. Si la carte n’est pas visible, ouvrez manuellement l’onglet Browser à droite et suivez Plus > Télécharger la page > Continuer l’extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'Aucun instantané de page enregistré n’est disponible pour cette URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Impossible de lire l’instantané de page enregistré.',
  'chat.brandBrowserSnapshotSaveFailed': 'Impossible d’enregistrer un instantané de page depuis le navigateur.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser ouvert',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Étape 1 : ouvrez l’onglet Browser à droite ou basculez dessus, puis passez toute vérification humaine. Étape 2 : cliquez sur Plus, puis sur Télécharger la page. Étape 3 : attendez le message de réussite de l’instantané enregistré. Étape 4 : revenez à la carte Étape suivante à gauche et cliquez sur Continuer l’extraction pour poursuivre l’extraction programmatique.',
  'brandEnrichment.title': "Optimisation IA",
  'brandEnrichment.body': "Open Design lancera une extraction plus approfondie en arrière-plan, appliquera automatiquement les bons skills de design system et mettra à jour ce système sur place. Cela peut prendre 10 à 20 minutes ; vous pouvez continuer à travailler.",
  'brandEnrichment.cta': "Optimiser avec l’IA",
  'brandEnrichment.busy': "Démarrage de l’optimisation IA…",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md collé',
  'brandExtractionTranscript.user': 'Extraire un système de design depuis {source}.',
  'brandExtractionTranscript.doneTitle': 'L’extraction programmatique de {name} est terminée.',
  'brandExtractionTranscript.doneBody': 'J’ai créé et enregistré le système de design {designSystemId} depuis {source}. Il est prêt à être prévisualisé et utilisé dans de nouveaux designs.',
  'brandExtractionTranscript.next': 'Ensuite, vous pouvez lancer AI Optimize pour une extraction plus approfondie ou créer un nouveau design avec ce système.',
  'chat.fillInputTitle': 'Cliquez pour remplir le champ',
  'chat.jumpToLatest': 'Aller au plus récent',
  'chat.scrollToLatest': 'Défiler jusqu\'au plus récent',
  'chat.messageRail.aria': 'Navigation des messages utilisateur',
  'chat.messageRail.jumpAria': 'Aller au message utilisateur {index}',
  'chat.messageRail.empty': '(Aucun contenu)',
  'chat.you': 'Vous',
  'chat.openFile': 'Ouvrir {name}',
  'chat.copyPrompt': 'Copier le prompt',
  'chat.copyErrorDiagnostic': 'Copier le diagnostic d’erreur',
  'chat.copyDone': 'Copié !',
  'chat.inspect.noEditableTargets': 'Aucune cible de texte ou de style modifiable trouvée.',
  'chat.inspect.noCommentTargets': 'Aucune cible de texte ou visuelle pouvant recevoir un commentaire n’a été trouvée.',
  'chat.inspect.editHint': 'Sélectionnez une cible de texte ou de style dans l’aperçu pour la modifier.',
  'chat.inspect.commentHint': 'Sélectionnez du texte ou une zone dans l’aperçu pour ajouter un commentaire.',
  'chat.composerPlaceholder': 'Décrivez ce que vous voulez générer…',
  'chat.activeFileEditingLabel': 'Modification',
  'chat.activeFilePlaceholder': 'Demandez à Open Design de modifier {file}...',
  'chat.designArtifactsShowMore': 'Afficher {count} fichiers de design supplémentaires',
  'chat.mode.chat.label': 'Demander',
  'chat.mode.chat.title': 'Mode Demander',
  'chat.mode.chat.summary': 'Pour les réponses rapides, les retouches, la planification et la discussion, sans supposer qu’un livrable design doit être créé.',
  'chat.mode.chat.solves': 'Utilisez-le pour clarifier des idées, améliorer des prompts, comparer des options ou poser des questions sur un travail existant.',
  'chat.mode.chat.query1': 'Résume ce brouillon et indique les manques.',
  'chat.mode.chat.query2': 'Aide-moi à choisir la meilleure structure pour cette page d’atterrissage.',
  'chat.mode.chat.query3': 'Relis ce design et propose des améliorations concrètes.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Mode Plan",
  'chat.mode.plan.summary': "Crée d’abord un document de plan modifiable, puis passe à Design après votre relecture.",
  'chat.mode.plan.solves': "Utilisez-le pour les PRD, plans de slides, briefs de prototype, maquettes filaires, storyboards et toute demande large qui nécessite une confirmation avant génération.",
  'chat.mode.plan.query1': "Crée d’abord un plan PPT diapositive par diapositive.",
  'chat.mode.plan.query2': "Rédige un PRD avant de générer le prototype.",
  'chat.mode.plan.query3': "Transforme cette idée en plan de design modifiable.",
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Mode Agent de design',
  'chat.mode.design.summary': 'Pour créer ou modifier des sorties concrètes : pages, prototypes, artefacts live, slides, images, vidéos, HyperFrames, audio, tableaux de bord et fichiers projet.',
  'chat.mode.design.solves': 'Utilisez-le quand Open Design doit générer des fichiers, mettre à jour le workspace ou transformer un brief en livrables multimodaux.',
  'chat.mode.design.query1': 'Crée une page d’atterrissage de lancement produit et un prototype HyperFrames à partir de ce brief.',
  'chat.mode.design.query2': 'Fais un deck investisseur de 10 slides avec notes de prise de parole.',
  'chat.mode.design.query3': 'Génère des concepts image, vidéo et audio pour cette campagne.',
  'chat.mode.cardBestFor': 'Idéal pour',
  'chat.mode.cardTry': 'Exemples de demandes',
  'chat.mode.cardCost': 'Consommation typique',
  'chat.mode.chat.cost': 'Faible',
  'chat.mode.chat.costNote': 'Une simple conversation : rien n’est généré, la consommation est donc minimale.',
  'chat.mode.plan.cost': 'Standard',
  'chat.mode.plan.costNote': 'Crée d’abord un document de plan modifiable avant toute génération.',
  'chat.mode.design.cost': 'Élevée',
  'chat.mode.design.costNote': 'Génère des fichiers et des contenus multimodaux : une exécution peut consommer le plus.',
  'chat.modePicker.choose': 'Choisir un mode',
  'chat.modePicker.current': 'Mode : {name}',
  'chat.modePicker.clear': 'Effacer le mode',
  'chat.modePicker.mode': 'Mode',
  'chat.composerHint': '⌘/Ctrl + Entrée pour envoyer · indiquez objectif, contenu, style et format',
  'chat.cliSettingsTitle': 'Paramètres CLI et modèle',
  'chat.cliSettingsAria': 'Ouvrir les paramètres CLI et modèle',
  'chat.attachTitle': 'Attacher des fichiers (ou coller / déposer)',
  'chat.addContextTitle': 'Ajouter du contexte',
  'chat.attachAria': 'Attacher des fichiers',
  'chat.importTitle': 'Importer des sources (bientôt disponible)',
  'chat.importLabel': 'Importer',
  'chat.importComingSoon': 'Bientôt disponible',
  'chat.importSoon': 'Bientôt',
  'chat.importFig': 'Téléverser un fichier .fig',
  'chat.importGitHub': 'Connecter GitHub',
  'chat.importWeb': 'Capturer un élément web',
  'chat.importFolder': 'Lier un dossier de code',
  'chat.importSkills': 'Skills et systèmes de design',
  'chat.importProject': 'Référencer un autre projet',
  'chat.importDesignSystemHeader': 'Choisir un design system',
  'chat.importDesignSystemBack': 'Retour',
  'chat.importDesignSystemSearch': 'Rechercher un design system…',
  'chat.importDesignSystemEmpty': 'Aucun design system ne correspond à "{query}"',
  'chat.importDesignSystemNone': 'Aucun — libre',
  'chat.importDesignSystemNoneSub': 'Ne pas ancrer à un système cette fois',
  'chat.importDesignSystemActive': 'Actif',
  'chat.importDesignSystemSwitched': 'Design system basculé sur {title}',
  'chat.importDesignSystemFailed': 'Impossible de changer de design system. Veuillez réessayer.',
  'chat.importDesignSystemLoadFailed': 'Impossible de charger les design systems.',
  'browserUse.title': 'Inspiration',
  'browserUse.summary': '{count} actions web, priorisant l’extraction d’assets, le langage visuel, le motion design, les vérifications visuelles et la structure des composants.',
  'browserUse.searchAria': 'Rechercher une inspiration',
  'browserUse.searchPlaceholder': 'Rechercher des captures, polices, couleurs, a11y…',
  'browserUse.empty': 'Aucune inspiration correspondante',
  'browserUse.unavailable': 'L’inspiration n’est pas disponible ici',
  'browserUse.added': 'Ajouté au composeur',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Retour',
  'designBrowser.goForward': 'Avancer',
  'designBrowser.reload': 'Recharger',

  'designBrowser.stopLoading': 'Arrêter le chargement',
  'designBrowser.viewportAria': 'Viewport du navigateur',
  'designBrowser.addressPlaceholder': 'Saisir une URL ou rechercher…',
  'designBrowser.addressAria': 'Adresse du navigateur',
  'designBrowser.suggestion.reference': 'Référence',
  'designBrowser.suggestion.history': 'Historique',
  'designBrowser.menu.copyScreenshot': 'Copier la capture d’écran',
  'designBrowser.menu.hardReload': 'Rechargement forcé',
  'designBrowser.menu.copyUrl': 'Copier l’URL',
  'designBrowser.menu.openInBrowser': 'Ouvrir dans Browser',
  'designBrowser.menu.savePageBrief': 'Enregistrer le brief de page',
  'designBrowser.menu.clearBrowsingHistory': 'Effacer l’historique de navigation',
  'designBrowser.menu.clearCookies': 'Effacer les cookies',
  'designBrowser.menu.clearAllData': 'Effacer toutes les données',
  'designBrowser.status.openHttpUrlFirst': 'Ouvrez d’abord une URL http.',
  'designBrowser.status.openPageBeforeScreenshot': 'Ouvrez une page avant de prendre une capture d’écran.',
  'designBrowser.status.screenshotCopied': 'Capture d’écran copiée dans le presse-papiers',
  'designBrowser.status.openPageBeforeBrief': 'Ouvrez une page avant d’enregistrer un brief.',
  'designBrowser.status.openPageBeforeTools': 'Ouvrez une page avant d’utiliser les outils du navigateur.',
  'designBrowser.status.clickElementToComment': 'Cliquez sur un élément à commenter',
  'designBrowser.status.clickElementToTune': 'Cliquez sur un élément à ajuster',
  'designBrowser.status.noElementSelected': 'Aucun élément du navigateur sélectionné',
  'designBrowser.status.addBrowserComment': 'Ajouter un commentaire navigateur',
  'designBrowser.status.tuneElementThenSaveHtml': 'Ajustez l’élément, puis enregistrez le HTML',
  'designBrowser.status.tuneLiveOnly': 'L’ajustement est uniquement live pour les pages hors projet',
  'designBrowser.status.pickerFailed': 'Échec du sélecteur d’élément du navigateur',
  'designBrowser.status.applyStyleFailed': 'Impossible d’appliquer le style dans la page du navigateur',
  'designBrowser.status.editTextFailed': 'Impossible de modifier le texte dans la page du navigateur',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Seules les pages HTML locales au projet peuvent être enregistrées',
  'designBrowser.status.htmlSaved': 'Modifications HTML enregistrées',
  'designBrowser.status.htmlSaveFailed': 'Échec de l’enregistrement HTML',
  'designBrowser.status.commentSavingUnavailable': 'L’enregistrement des commentaires est indisponible',
  'designBrowser.status.commentSaved': 'Commentaire navigateur enregistré',
  'designBrowser.status.commentSendingUnavailable': 'L’envoi des commentaires est indisponible',
  'designBrowser.comments.aria': 'Commentaires navigateur',
  'designBrowser.comments.openFor': 'Ouvrir le commentaire navigateur pour {label}',
  'designBrowser.comment.dialog': 'Commentaire navigateur',
  'designBrowser.comment.elementFallback': 'Élément du navigateur',
  'designBrowser.comment.close': 'Fermer le commentaire navigateur',
  'designBrowser.comment.noteAria': 'Note du commentaire navigateur',
  'designBrowser.comment.placeholder': 'Décrivez le changement ou le problème…',
  'designBrowser.comment.addNote': 'Ajouter une note',
  'designBrowser.comment.saveComment': 'Enregistrer le commentaire',
  'designBrowser.comment.sending': 'Envoi…',
  'designBrowser.comment.sendToChat': 'Envoyer au chat',
  'designBrowser.inspect.editTitle': 'Modifier l’élément HTML',
  'designBrowser.inspect.tuneTitle': 'Ajuster l’élément du navigateur',
  'designBrowser.inspect.closeTune': 'Fermer l’ajustement navigateur',
  'designBrowser.inspect.colors': 'Couleurs',
  'designBrowser.inspect.text': 'Texte',
  'designBrowser.inspect.fill': 'Remplissage',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Taille',
  'designBrowser.inspect.weight': 'Graisse',
  'designBrowser.inspect.spacing': 'Espacement',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Contenu',
  'designBrowser.inspect.elementText': 'Texte de l’élément',
  'designBrowser.inspect.saving': 'Enregistrement…',
  'designBrowser.inspect.saveHtml': 'Enregistrer le HTML',
  'designBrowser.inspect.liveOnly': 'Live uniquement',
  'designBrowser.reference.kicker': 'Navigateur Open Design',
  'designBrowser.reference.title': 'Tableau de références',
  'designBrowser.reference.subtitle': 'Un ensemble de références sélectionnées : inspiration, vraies UI produit, motion, couleur, typographie, assets et systèmes de design. Ouvrez-en une pour la parcourir en direct tout en collectant le langage de design du prochain artefact.',
  'designBrowser.reference.categoryAria': 'Catégorie de référence',
  'designBrowser.reference.searchPlaceholder': 'Rechercher des références…',
  'designBrowser.reference.searchAria': 'Rechercher des références',
  'designBrowser.reference.clearSearch': 'Effacer la recherche',
  'designBrowser.reference.noMatches': 'Aucune référence ne correspond à « {query} ».',
  'designBrowser.reference.clearFilters': 'Effacer les filtres',
  'designBrowser.reference.open': 'Ouvrir',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Interfaces réelles',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Couleur',
  'designBrowser.reference.group.type': 'Typographie',
  'designBrowser.reference.group.icons': 'Icônes',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photographie',
  'designBrowser.reference.group.3d': '3D et graphismes',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Systèmes de design',
  'designBrowser.reference.group.components': 'Composants',
  'designBrowser.reference.group.guidelines': 'Guides et accessibilité',
  'designBrowser.reference.group.tools': 'Outils et ressources',
  'designBrowser.reference.site.dribbble.detail': 'Shots de design et inspiration UI.',
  'designBrowser.reference.site.behance.detail': 'Portfolios créatifs et études de cas.',
  'designBrowser.reference.site.awwwards.detail': 'Designs de sites web primés.',
  'designBrowser.reference.site.godly.detail': 'Design web moderne sélectionné.',
  'designBrowser.reference.site.land_book.detail': 'Galerie de landing pages et motifs.',
  'designBrowser.reference.site.mobbin.detail': 'Écrans d’app réels et motifs UI.',
  'designBrowser.reference.site.screenlane.detail': 'Derniers motifs de design UI issus d’apps.',
  'designBrowser.reference.site.pageflows.detail': 'Parcours utilisateur et onboarding produit réels.',
  'designBrowser.reference.site.uisources.detail': 'Motifs d’interaction issus des meilleures apps.',
  'designBrowser.reference.site.collectui.detail': 'Collection UI quotidienne par catégorie.',
  'designBrowser.reference.site.gsap.detail': 'Moteur d’animation de production et exemples.',
  'designBrowser.reference.site.animations.detail': 'Motifs d’animation et exemples d’interaction.',
  'designBrowser.reference.site.transitions.detail': 'Motifs de transition pour interfaces modernes.',
  'designBrowser.reference.site.motionsites.detail': 'Références motion et interaction haut de gamme.',
  'designBrowser.reference.site.motion.detail': 'Inspiration d’animations de scroll et de timeline.',
  'designBrowser.reference.site.animography.detail': 'Typographie animée et lettrage cinétique.',
  'designBrowser.reference.site.reactbits.detail': 'Référence d’animations de texte React pour typographie cinétique brillante.',
  'designBrowser.reference.site.coolors.detail': 'Générateur rapide de palettes de couleurs.',
  'designBrowser.reference.site.colorhunt.detail': 'Palettes de couleurs sélectionnées.',
  'designBrowser.reference.site.realtimecolors.detail': 'Prévisualisation de palettes sur une vraie UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Roue chromatique et règles d’harmonie.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes montrées en contexte réel.',
  'designBrowser.reference.site.fonts_google.detail': 'Bibliothèque de polices open source.',
  'designBrowser.reference.site.fontshare.detail': 'Polices de qualité gratuites pour usage commercial.',
  'designBrowser.reference.site.typewolf.detail': 'Polices en situation et conseils d’association.',
  'designBrowser.reference.site.fontpair.detail': 'Suggestions d’associations de polices.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typographie dans des designs réels.',
  'designBrowser.reference.site.thesvg.detail': 'Assets SVG et références vectorielles.',
  'designBrowser.reference.site.svglogos.detail': 'Logos SVG propres pour maquettes produit et marque.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Icônes produit et marques IA pour interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': 'Plus de 200 000 icônes open source au même endroit.',
  'designBrowser.reference.site.lucide.detail': 'Jeu d’icônes ouvert, propre et cohérent.',
  'designBrowser.reference.site.heroicons.detail': 'Icônes SVG conçues pour Tailwind.',
  'designBrowser.reference.site.svgrepo.detail': 'Vecteurs et icônes SVG gratuits.',
  'designBrowser.reference.site.storyset.detail': 'Illustrations vectorielles personnalisables.',
  'designBrowser.reference.site.undraw.detail': 'Illustrations MIT open source.',
  'designBrowser.reference.site.blush.detail': 'Illustrations modulaires à composer.',
  'designBrowser.reference.site.lummi.detail': 'Visuels générés par IA gratuits.',
  'designBrowser.reference.site.whirrls.detail': 'Références d’images dessinées à la main.',
  'designBrowser.reference.site.worldindots.detail': 'Références de cartes à points et data visualisation.',
  'designBrowser.reference.site.unsplash.detail': 'Photos haute résolution gratuites.',
  'designBrowser.reference.site.pexels.detail': 'Photos et vidéos de stock gratuites.',
  'designBrowser.reference.site.pixabay.detail': 'Images et médias libres de droits.',
  'designBrowser.reference.site.cosmos.detail': 'Découverte visuelle et moodboards.',
  'designBrowser.reference.site.spline.detail': 'Design 3D dans le navigateur.',
  'designBrowser.reference.site.threejs.detail': 'Références et démos 3D WebGL.',
  'designBrowser.reference.site.womp.detail': 'Création 3D facile dans le navigateur.',
  'designBrowser.reference.site.pixcap.detail': 'Icônes 3D, mockups et scènes.',
  'designBrowser.reference.site.shots.detail': 'Mockups d’appareils et de navigateurs.',
  'designBrowser.reference.site.mockuuups.detail': 'Mockups d’appareils en glisser-déposer.',
  'designBrowser.reference.site.angle.detail': 'Bibliothèque de mockups d’appareils 3D.',
  'designBrowser.reference.site.rotato.detail': 'Mockups produit 3D animés.',
  'designBrowser.reference.site.impeccable.detail': 'Références de style et d’interface de haute qualité.',
  'designBrowser.reference.site.styles_refero.detail': 'Références de styles de design et systèmes visuels.',
  'designBrowser.reference.site.brandfetch.detail': 'Assets de marque, logos et identité.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Galerie de systèmes de design publics.',
  'designBrowser.reference.site.startups.detail': 'Références produit et marque de startups de premier plan.',
  'designBrowser.reference.site.base_ui.detail': 'Primitives accessibles non stylées pour systèmes personnalisés.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composants React composables construits sur Radix et Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Bibliothèque de composants React moderne et système de design.',
  'designBrowser.reference.site.radix_ui.detail': 'Primitives UI bas niveau accessibles.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Primitives de comportement accessibles par Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Composants accessibles non stylés pour projets Tailwind.',
  'designBrowser.reference.site.mui.detail': 'Écosystème de composants React basé sur Material.',
  'designBrowser.reference.site.mantine.detail': 'Composants et hooks React complets.',
  'designBrowser.reference.site.chakra_ui.detail': 'Composants React accessibles avec tokens de thème.',
  'designBrowser.reference.site.ant.detail': 'Système de composants et motifs enterprise.',
  'designBrowser.reference.site.ark_ui.detail': 'Composants headless pour frameworks modernes.',
  'designBrowser.reference.site.daisyui.detail': 'Classes et thèmes de composants Tailwind CSS.',
  'designBrowser.reference.site.developer_apple.detail': 'Guidelines de design des plateformes Apple.',
  'designBrowser.reference.site.m3_material.detail': 'Material Design 3 de Google.',
  'designBrowser.reference.site.lawsofux.detail': 'Principes UX et heuristiques.',
  'designBrowser.reference.site.webaim.detail': 'Vérificateur de contraste de couleurs.',
  'designBrowser.reference.site.a11yproject.detail': 'Checklist et motifs d’accessibilité.',
  'designBrowser.reference.site.toolfolio.detail': 'Outils, ressources et collections de design.',
  'designBrowser.reference.site.getdesign.detail': 'Ressources de design sélectionnées.',
  'designBrowser.reference.site.tasteskill.detail': 'Entraînement du goût design et références de critique.',
  'designBrowser.reference.site.uigoodies.detail': 'Ressources de design choisies à la main.',
  'designBrowser.reference.site.sidebar.detail': 'Cinq liens design chaque jour.',
  'designBrowser.reference.site.github.detail': 'Implémentation de référence pour les workflows de navigateur intégré.',
  'browserUse.category.assets': 'Extraction d’assets',
  'browserUse.category.tokens': 'Langage visuel',
  'browserUse.category.motion': 'Animation',
  'browserUse.category.visual': 'Vérifications visuelles',
  'browserUse.category.structure': 'Composants',
  'browserUse.category.project': 'Exécution du projet',
  'browserUse.category.general': 'Général',
  'browserUse.input.none': 'Aucune entrée',
  'browserUse.input.assetKind': 'kind: images|svgs|media|fonts, limit=200',
  'browserUse.input.optionalSelector': 'Sélecteur optionnel',
  'browserUse.input.requirementSelector': 'Exigence, sélecteur optionnel',
  'browserUse.input.selectorOptional': 'Sélecteur optionnel',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'selector, scale=2',
  'browserUse.input.gridOverlay': 'columns=12, maxWidth=1200, gap=24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domaine ou termes de recherche',
  'browserUse.input.selector': 'Sélecteur',
  'browserUse.input.selectorText': 'Sélecteur et texte',
  'browserUse.input.scroll': 'Pixels, haut, bas ou page',
  'browserUse.input.terminalRun': 'Commande, délai 120 s',
  'browserUse.input.command': 'Commande',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Meilleurs candidats de logo à partir de l’en-tête, de la navigation, des noms de classe, de la position, de l’image OG et du favicon en secours.',
  'browserUse.action.list_images.output': 'Toutes les images img, srcset, source et backgrounds CSS avec dimensions et texte alternatif.',
  'browserUse.action.download_assets.output': 'Dossier d’assets téléchargés plus _manifest.json avec prise en charge du referer et des cookies.',
  'browserUse.action.extract_svgs.output': 'SVG inline et fichiers .svg liés enregistrés comme fichiers SVG individuels.',
  'browserUse.action.optimize_svgs.output': 'Fichiers SVG optimisés plus taux de compression.',
  'browserUse.action.extract_colors.output': 'Palette pondérée plus variables CSS de couleur :root sous forme de palette.json et palette.html.',
  'browserUse.action.extract_fonts.output': 'Principales familles, tailles, graisses et règles @font-face sous forme de typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Rayons, ombres, espacements et variables CSS sous forme de tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Échelle typographique des titres, du corps et des boutons avec taille, graisse, interligne et ratios.',
  'browserUse.action.extract_buttons.output': 'Bibliothèque de styles de boutons dédupliquée en buttons.html et buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Conteneurs grid et flex, direction, espacements, colonnes et largeurs maximales dans layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Breakpoints responsive issus des media queries dans breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'Dégradés CSS dans gradients.css, gradients.json et HTML d’aperçu.',
  'browserUse.action.extract_shadows.output': 'Ombres de boîte, de texte et ombres portées dans shadows.json avec aperçu.',
  'browserUse.action.extract_easings.output': 'Fonctions d’easing de transitions et d’animations dans easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js et style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, règles de transition et de transformation, bibliothèques de motion détectées, motion.css et motion.json.',
  'browserUse.action.validate_view.output': 'Chemins des captures d’écran plus problèmes visuels et de mise en page structurés.',
  'browserUse.action.audit_layout.output': 'Défauts de mise en page, y compris overflow, limites, chevauchements et texte tronqué dans audit.json.',
  'browserUse.action.audit_accessibility.output': 'Problèmes d’accessibilité avec sélecteurs, labels, rôles, focus, contraste et captures si utile.',
  'browserUse.action.responsive_screenshots.output': 'Captures mobile 390, tablette 834 et desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Capture pleine page au-delà du viewport.',
  'browserUse.action.screenshot_element.output': 'Capture d’un élément unique en 2x par défaut.',
  'browserUse.action.screenshot_with_grid.output': 'Capture avec grille de mise en page superposée.',
  'browserUse.action.screenshot_dark_mode.output': 'Capture avec prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Guide de style sur une page avec couleurs, échelle typographique, rayons et ombres.',
  'browserUse.action.extract_html.output': 'HTML propre et autonome sans script, noscript ni attributs d’événement inline.',
  'browserUse.action.extract_component_inventory.output': 'Motifs de composants répétés, sélecteurs, quantités et captures.',
  'browserUse.action.extract_copy.output': 'Titres, CTA, corps de texte et descriptions dans copy.md et copy.json.',
  'browserUse.action.extract_nav.output': 'Navigation principale et liens de pied de page dans sitemap.md et nav.json.',
  'browserUse.action.extract_forms.output': 'Champs de formulaire, labels, indices de validation et actions de soumission dans forms.json.',
  'browserUse.action.run_project.output': 'URL du serveur de développement détectée et ouverte dans l’onglet Browser.',
  'browserUse.action.detect_project.output': 'Framework, gestionnaire de paquets, commande d’installation, commande de dev et port.',
  'browserUse.action.page_info.output': 'URL, titre, description, image OG, couleur de thème, favicon et viewport.',
  'browserUse.action.snapshot.output': 'Jusqu’à 120 éléments interactifs et textuels visibles avec balise, label, href et coordonnées.',
  'browserUse.action.navigate.output': 'Ouvre la page et renvoie page_info.',
  'browserUse.action.click.output': 'Clique sur le premier élément correspondant après l’avoir fait défiler dans la vue.',
  'browserUse.action.type_text.output': 'Remplit un champ et déclenche les événements input et change.',
  'browserUse.action.scroll.output': 'Position de défilement actuelle et maximale.',
  'browserUse.action.extract_og_metadata.output': 'Titre meta, description, URL canonique, cartes OG/Twitter, image sociale et couleur de thème.',
  'browserUse.action.terminal_run.output': 'stdout, stderr et code de sortie.',
  'browserUse.action.terminal_run_background.output': 'ID de tâche en arrière-plan et sortie récente.',
  'browserUse.action.terminal_read.output': 'Sortie récente du terminal partagé.',
  'chat.designToolbox.title': 'Boîte à outils design',
  'chat.designToolbox.tooltip': 'Boîte à outils design / Surprise-moi',
  'chat.designToolbox.aria': 'Ouvrir la boîte à outils design',
  'chat.designToolbox.searchPlaceholder': 'Rechercher des Skills / MCP / plugins / connecteurs / fichiers de design…',
  'chat.designToolbox.searchAria': 'Rechercher des ressources dans la boîte à outils design',
  'chat.designToolbox.followupSection': 'Suite',
  'chat.designToolbox.resourcesSection': 'Ressources disponibles',
  'chat.designToolbox.selected': 'Sélectionné',
  'chat.designToolbox.noResources': 'Aucune ressource trouvée pour « {query} ».',
  'chat.designToolbox.badge.video': 'Vidéo',
  'chat.designToolbox.badge.image': 'Image',
  'chat.designToolbox.badge.motion': 'Motion',
  'chat.designToolbox.badge.polish': 'Finition',
  'chat.designToolbox.action.auto-match.title': 'Associer l’étape suivante',
  'chat.designToolbox.action.auto-match.badge': 'Associer',
  'chat.designToolbox.action.auto-match.description': 'Définissez d’abord le niveau d’exigence visuelle, puis associez Skills, MCP, plugins, connecteurs et fichiers.',
  'chat.designToolbox.action.asset-search.title': 'Trouver images / références',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Recherchez des images utilisables, captures de référence, moodboards et sources candidates pour le design actuel.',
  'chat.designToolbox.action.icon-workflow.title': 'Trouver / remplacer des icônes',
  'chat.designToolbox.action.icon-workflow.badge': 'Icônes',
  'chat.designToolbox.action.icon-workflow.description': 'Trouvez, générez ou remplacez l’iconographie, les SVG, les icônes Lucide et les symboles visuels avec un style cohérent.',
  'chat.designToolbox.action.image-replace.title': 'Remplacer les images de la page',
  'chat.designToolbox.action.image-replace.badge': 'Remplacer',
  'chat.designToolbox.action.image-replace.description': 'Auditez les images actuelles et remplacez les visuels faibles de hero, section, arrière-plan ou carte par de meilleurs assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extraire des références visuelles',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analysez une capture ou un site de référence pour en extraire palette, typographie, posture de mise en page, motion et direction d’assets.',
  'chat.designToolbox.action.motion.title': 'Ajouter des animations',
  'chat.designToolbox.action.motion.badge': 'Motion',
  'chat.designToolbox.action.motion.description': 'Ajoutez du motion d’entrée, de défilement, de transition d’état et de micro-interaction au HTML ou à l’élément de page actuel.',
  'chat.designToolbox.action.motion-polish.title': 'Affiner les animations',
  'chat.designToolbox.action.motion-polish.badge': 'Timing',
  'chat.designToolbox.action.motion-polish.description': 'Revoyez le timing, l’easing, les performances et les fallbacks reduced-motion du motion existant.',
  'chat.designToolbox.action.transition-motion.title': 'Concevoir des transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Concevez des transitions de page, scène, chargement et état avec un timing sobre et des fallbacks reduced-motion.',
  'chat.designToolbox.action.threejs-scene.title': 'Scène 3D / Three.js',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Ajoutez ou planifiez des visuels interactifs Three.js, Spline, Vanta, particules, WebGL, carte ou style deck.gl.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Retirer l’effet IA',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Goût',
  'chat.designToolbox.action.anti-ai-polish.description': 'Retirez l’effet template, les dégradés IA, les empilements de cartes bas de gamme et le texte vague.',
  'chat.designToolbox.action.visual-polish.title': 'Affiner le design / prêt à livrer',
  'chat.designToolbox.action.visual-polish.badge': 'Finition',
  'chat.designToolbox.action.visual-polish.description': 'Auditez la hiérarchie visuelle, la typo, les espacements, le responsive, l’accessibilité et la qualité de livraison.',
  'chat.designToolbox.action.image-gen.title': 'Générer images / références visuelles',
  'chat.designToolbox.action.image-gen.badge': 'Image',
  'chat.designToolbox.action.image-gen.description': 'Générez des références de sections, assets, icônes, visuels sociaux ou un moodboard pour la page actuelle.',
  'chat.designToolbox.action.chart-gen.title': 'Générer graphiques / diagrammes',
  'chat.designToolbox.action.chart-gen.badge': 'Graphiques',
  'chat.designToolbox.action.chart-gen.description': 'Générez des ECharts, React Flow, diagrammes, dashboards, cartes de relations ou assets de data visualisation.',
  'chat.designToolbox.action.logo-gen.title': 'Générer logo / identité',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Créez des pistes de logo, wordmarks, lockups, marques et prompts de système d’identité pour la marque actuelle.',
  'chat.designToolbox.action.plan-outline.title': "Générer un plan PPT depuis une idée",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': 'Transformez une idée brute en plan de deck Markdown modifiable avant de créer les slides.',
  'chat.designToolbox.action.video-gen.title': 'Générer vidéo / script motion',
  'chat.designToolbox.action.video-gen.badge': 'Vidéo',
  'chat.designToolbox.action.video-gen.description': 'Transformez le design en courte vidéo, storyboard Remotion / HyperFrames ou prompt prêt pour la génération.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'Modèle MCP',
  'chat.designToolbox.kind.connector': 'Connecteur',
  'chat.designToolbox.kind.designFile': 'Fichier de design',
  'chat.designToolbox.context.browser': 'Navigateur',
  'chat.designToolbox.context.designFiles': 'Fichiers de design',
  'chat.designToolbox.context.designSystem': 'Système de design',
  'chat.designToolbox.context.folder': 'Dossier',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Chat latéral',
  'chat.designToolbox.context.liveArtifact': 'Artefact dynamique',
  'chat.designToolbox.context.file': 'Fichier',
  'chat.designToolbox.prompt.contextGeneric': 'Cible actuelle : le HTML / fichier de design / élément web actuellement ouvert.',
  'chat.designToolbox.prompt.contextSpecific': 'Cible actuelle : {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Préservez l’intention déjà présente dans le champ : {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Skill sélectionné : {skill}. Utilisez-le comme workflow principal pour ce tour.',
  'chat.designToolbox.prompt.noSkill': 'Si aucun Skill précis ne correspond, choisissez d’abord la meilleure combinaison parmi les Skills, MCP, plugins, connecteurs et fichiers de design disponibles.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Agissez comme orchestrateur Creative Director et terminez un workflow de design :',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Définissez d’abord ce que signifie un « bon design » : audience, objectif business, sensation de marque, références de style, densité d’information, standards couleur/typo/motion/assets et motifs IA/template à éviter.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Recherchez et associez tout l’index de ressources ci-dessus. Ne vous limitez pas aux recommandations de la boîte à outils : combinez Skills, MCP, plugins, connecteurs et fichiers de design quand c’est utile.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Si la cible ou le niveau esthétique reste flou, guidez-moi avec un question-form structuré, incluez des valeurs par défaut recommandées et rendez chaque question à choix fermé modifiable avec un champ de réponse personnalisée. Si c’est suffisamment clair, exécutez directement l’étape suivante.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Terminez le flux dans cet ordre : diagnostic -> direction de style -> sélection des ressources -> édition/génération concrète -> vérification. À chaque étape, expliquez pourquoi ces ressources ont été choisies et ce qui doit être confirmé ensuite.',
  'chat.designToolbox.prompt.assetSearch': 'Trouvez les meilleurs assets image/référence pour le design actuel. Cherchez dans les fichiers disponibles, connecteurs, MCP, captures Browser et outils de génération. Retournez des candidats concrets avec des notes d’usage, les réserves de licence/source quand c’est pertinent, et un prompt de génération fallback si aucun asset utilisable n’existe.',
  'chat.designToolbox.prompt.iconWorkflow': 'Améliorez le système d’icônes du design actuel : trouvez les icônes manquantes, remplacez les icônes faibles, gardez stroke/fill/rayon/épaisseur cohérents, privilégiez les bibliothèques d’icônes existantes quand elles sont disponibles, et ne générez des SVG/prompts d’icônes que si une icône de bibliothèque ne suffit pas.',
  'chat.designToolbox.prompt.imageReplace': 'Auditez chaque emplacement d’image visible dans le design actuel, identifiez les visuels faibles ou placeholders, puis remplacez-les ou spécifiez de meilleurs visuels hero, section, arrière-plan, carte et social. Préservez le layout et donnez les choix exacts de fichier/prompt/source.',
  'chat.designToolbox.prompt.referenceExtract': 'Utilisez l’image, le site ou le fichier de design de référence actuel comme entrée visuelle. Extrayez palette, échelle typographique, rythme de layout, posture des composants, indices de motion et style d’assets, puis appliquez ces constats au design actuel sans copier mot pour mot des assets de marque protégés.',
  'chat.designToolbox.prompt.motion': 'Ajoutez un motion de haute qualité à l’élément HTML / page actuel : choisissez les 1 ou 2 moments les plus utiles parmi entrée, scroll, transition d’état, transition, motion d’icône façon Rive/Lottie ou micro-interactions GSAP/Motion. Restez sobre, privilégiez transform / opacity et incluez des fallbacks prefers-reduced-motion.',
  'chat.designToolbox.prompt.planOutline': "Créez ou mettez à jour un document de planification Markdown pour un plan PPT/deck à partir de cette idée. Ne générez pas encore le deck final. Incluez titres slide par slide, objectifs, bullets de contenu, direction visuelle, données/assets requis et questions ouvertes. Enregistrez-le comme fichier `.md` dans Design Files et dites-moi quel fichier relire.",
  'chat.designToolbox.prompt.motionPolish': 'Revoyez et polissez le timing, l’easing, les performances et l’accessibilité du motion existant. Supprimez toute animation brusque, cheap ou nuisible à la lisibilité ; utilisez une timeline plus raffinée si nécessaire.',
  'chat.designToolbox.prompt.transitionMotion': 'Concevez des transitions de haute qualité pour le design actuel : changements de page/scène, transitions de chargement, changements d’état et passages entre sections. Utilisez GSAP/Motion/CSS quand c’est approprié, gardez le tout performant et incluez un comportement à motion réduit.',
  'chat.designToolbox.prompt.threejsScene': 'Planifiez ou implémentez un visuel Three.js/WebGL ciblé pour le design actuel. Envisagez Three.js, des scènes façon Spline, des arrière-plans Vanta, systèmes de particules, couches de données Mapbox/deck.gl ou effets de portail navigateur, mais gardez la scène utile et vérifiez qu’elle s’affiche.',
  'chat.designToolbox.prompt.antiAiPolish': 'Faites une passe anti-effet-IA : retirez les layouts templatisés, les dégradés/glows cheap, les piles de cartes sans sens et le copy vague. Préservez l’information et donnez l’impression qu’un vrai designer a livré le résultat.',
  'chat.designToolbox.prompt.visualPolish': 'Polissez ce design jusqu’à ce qu’il soit prêt à être livré : vérifiez hiérarchie, typographie, espacements, responsive, états des boutons, états vide/chargement/erreur et accessibilité ; corrigez directement les points les plus importants.',
  'chat.designToolbox.prompt.imageGen': 'Créez le prochain plan d’assets visuels pour ce design : références de sections, assets hero, illustrations, icônes, visuels sociaux ou moodboard. Décidez d’abord quel type d’image manque, puis fournissez des prompts exécutables / un plan de fichiers.',
  'chat.designToolbox.prompt.chartGen': 'Générez le bon graphique, diagramme ou visuel de données pour le design actuel. Choisissez entre ECharts, React Flow, diagrammes SVG/CSS, radar charts, cartes relationnelles, dashboards ou visualisations deck.gl/cartographiques selon les données et l’objectif utilisateur.',
  'chat.designToolbox.prompt.logoGen': 'Créez des directions de logo et d’identité pour la marque actuelle. Proposez plusieurs pistes pour wordmark, symbole, lockup, palette, règles d’usage et prompts de génération ; assurez-vous que le résultat est original et utilisable dans l’artefact actuel.',
  'chat.designToolbox.prompt.videoGen': 'Orientez ce design vers la vidéo : créez un storyboard de courte vidéo, une structure de frames HyperFrames / Remotion, ou un prompt prêt pour Sora/fal. Privilégiez une transformation naturelle du HTML / contenu de page existant en séquences.',
  'chat.designToolbox.prompt.useSkill': 'Utilisez {skill} sur le design actuel.',
  'chat.designToolbox.prompt.skillInstruction': 'Décidez d’abord du meilleur objectif de suivi, puis réalisez une passe concrète. Si cela dépend d’assets ou d’API externes, fournissez un fallback exécutable ou indiquez ce que je dois fournir.',
  'chat.designToolbox.prompt.selectedResource': 'Ressource sélectionnée : {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Description de la ressource : {description}',
  'chat.designToolbox.prompt.pluginResource': 'Utilisez ce plugin comme contexte principal pour le flux de design en cours. S’il expose des inputs ou une GenUI, guidez-moi pour choisir si nécessaire ; s’il ne convient pas à la cible, choisissez une meilleure ressource globale et expliquez pourquoi.',
  'chat.designToolbox.prompt.mcpResource': 'Privilégiez cette capacité MCP pour la prochaine étape de design. Quand des assets externes, de la capture web, de la génération image/vidéo ou des données sont nécessaires, décidez d’abord si elle peut faire le travail, puis donnez un plan exécutable.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Ce MCP est un modèle configurable. Si c’est l’outil le plus utile pour cette étape de design, guidez d’abord la configuration ; si une alternative configurée existe, poursuivez avec cette alternative.',
  'chat.designToolbox.prompt.connectorResource': 'Utilisez ce connecteur quand de vraies données, des assets, du contenu de compte ou un accès à un workflow externe sont nécessaires. Avant de l’utiliser, expliquez ce qui sera lu ou écrit et demandez confirmation quand c’est approprié.',
  'chat.designToolbox.prompt.fileResource': 'Utilisez ce fichier de design comme cible actuelle ou asset de référence et terminez l’étape suivante à partir de lui. Si d’autres fichiers doivent être comparés, poursuivez la recherche dans tous les fichiers de design.',
  'chat.designToolbox.prompt.resourceIndex': 'Index des ressources disponibles : skills({skills}), plugins({plugins}), MCP({mcpEnabled} activés / {mcpTemplates} modèles), connecteurs({connectors} connectés), fichiers de design({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Skills recherchables',
  'chat.designToolbox.prompt.searchablePlugins': 'Plugins recherchables',
  'chat.designToolbox.prompt.availableMcp': 'MCP disponibles',
  'chat.designToolbox.prompt.connectedConnectors': 'Connecteurs connectés',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Fichiers de design de référence',
  'chat.designToolbox.prompt.mcpTemplateName': 'Modèle {name}',
  'chat.designToolbox.prompt.processRule': 'Règle de workflow : définissez d’abord l’objectif esthétique et les contraintes, puis cherchez et associez les ressources ; quand un choix utilisateur est nécessaire, générez un question-form structuré avec réponses personnalisées modifiables et continuez après confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} autres',
  'chat.designToolbox.prompt.compactLine': '{label} : {values}{suffix}.',
  'chat.mentionTabsAria': 'Surfaces de mention',
  'chat.mentionTabAll': 'Tout',
  'chat.mentionTabTabs': 'Onglets',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connecteurs',
  'chat.mentionTabFiles': 'Fichiers de design',
  'chat.mentionNoResults': 'Aucun résultat pour « {query} ».',
  'chat.mentionSearchPrompt': 'Rechercher des fichiers de design, onglets, plugins, Skills, serveurs MCP et connecteurs.',
  'chat.mentionSectionTabs': 'Onglets',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connecteurs',
  'chat.mentionSectionFiles': 'Fichiers de design',
  'chat.mentionActiveSkill': 'Actif',
  'chat.mentionUseMcpTitle': 'Utiliser {name}',
  'chat.mentionUseConnectorTitle': 'Utiliser {name}',
  'chat.mentionPluginOfficial': 'Officiel',
  'chat.mentionPluginMine': 'Mon plugin',
  'chat.linkedFolderRemoveAria': 'Supprimer le dossier lié {path}',
  'chat.linkedFolderNotFound': 'Le dossier n\'existe pas',
  'chat.linkedFolderAlready': 'Ce dossier est déjà lié',
  'chat.linkedFolderPickError': 'Impossible d\'ouvrir le sélecteur de dossier',
  'chat.queuedHeader': 'En file',
  'chat.queuedToSend': 'à envoyer',
  'chat.queuedEditQueuedTaskAria': 'Modifier la tâche en file',
  'chat.queuedSave': 'Enregistrer',
  'chat.queuedCancel': 'Annuler',
  'chat.queuedReorder': 'Glisser pour réorganiser',
  'chat.queuedEdit': 'Modifier',
  'chat.queuedMore': 'autres en file',
  'chat.queuedFollowUpFallback': 'Suivi en file',
  'chat.send': 'Envoyer',
  'chat.stop': 'Arrêter',
  'chat.removeAria': 'Retirer {name}',
  'chat.example1Title': 'Pitch deck éditorial',
  'chat.example1Tag': 'Magazine',
  'chat.example1Prompt': 'Un pitch deck éditorial de 10 diapositives pour un studio de design levant des fonds — mise en page grille suisse, titres avec empattement surdimensionnés et lettrines, numéros de section en monospace, généreux espaces négatifs, et diapositives photo pleine page entrecoupées de diapos riches en texte. Couverture, vision, marché, produit, traction, équipe, levée de fonds, contact.',
  'chat.example2Title': 'Tableau de bord SaaS analytics',
  'chat.example2Tag': 'Données',
  'chat.example2Prompt': 'Un tableau de bord analytics dense pour un SaaS d\'outils développeurs — bandeau KPI avec deltas semaine sur semaine, deux graphiques en lignes empilées (MRR et espaces de travail actifs), une carte de chaleur mondiale d\'utilisation, une grille de rétention de cohortes, un classement des meilleurs clients et un fil d\'actualité en temps réel. Thème sombre, chiffres tabulaires en monospace, accents sparkline.',
  'chat.example3Title': 'Rapport annuel long défilement',
  'chat.example3Tag': 'Éditorial',
  'chat.example3Prompt': 'Un rapport annuel interactif pour une ONG climatique — mise en page éditoriale à long défilement mêlant de grands blocs de citation, des visualisations de données (barres empilées, compteurs animés, une carte choroplèthe des sites de projet), des séparateurs photo, un mur de donateurs et un appel à l\'action final. Texte en serif moderne, étiquettes de graphiques en sans-serif, palette papier aux tons terreux.',
  'home.recommendation.eyebrow': 'Recommandé pour vous',
  'home.recommendation.primaryCta': 'Commencer à créer',
  'home.recommendation.change': 'Essayer un autre',
  'home.recommendation.browseAll': 'Tous les types',
  'home.recommendation.defaultProjectName': 'Nouveau projet',
  'home.recommendation.startFailed': 'Impossible de démarrer la création. Veuillez réessayer.',
  'studio.firstArtifactHint.title': 'Votre première création est prête',
  'studio.firstArtifactHint.body': "Essayez de le modifier et de l'annoter directement — exportez ou partagez quand vous êtes satisfait.",
  'studio.firstArtifactHint.dismiss': 'Compris',
  'home.starter.product_ui_prototype.title': 'Commencer avec un prototype de produit modifiable',
  'home.starter.product_ui_prototype.desc': 'À partir de votre objectif, commencez avec une interface cliquable que vous pouvez affiner.',
  'home.starter.product_ui_prototype.firstPrompt': 'Concevez un prototype de produit modifiable pour [votre produit] avec les écrans clés et un flux principal clair.',
  'home.starter.product_ui_component.title': 'Commencer à partir d\'un composant réutilisable',
  'home.starter.product_ui_component.desc': 'Construisez d\'abord un composant, puis assemblez-le en écrans complets.',
  'home.starter.product_ui_component.firstPrompt': 'Concevez un composant réutilisable [nom du composant] avec ses principaux états et variantes.',
  'home.starter.product_ui_lowfi.title': 'Commencer avec un prototype basse fidélité',
  'home.starter.product_ui_lowfi.desc': 'Esquissez d\'abord la structure, puis augmentez la fidélité.',
  'home.starter.product_ui_lowfi.firstPrompt': 'Créez un wireframe basse fidélité des écrans principaux pour [votre produit].',
  'home.starter.marketing_landing.title': 'Commencer avec une page de destination',
  'home.starter.marketing_landing.desc': 'Transformez votre campagne en une page de destination prête à publier.',
  'home.starter.marketing_landing.firstPrompt': 'Concevez une page de destination pour [votre produit] avec un hero, les avantages clés et un appel à l\'action clair.',
  'home.starter.marketing_multivariant.title': 'Commencer avec plusieurs variantes de page de destination',
  'home.starter.marketing_multivariant.desc': 'Générez quelques versions à comparer avant de vous décider.',
  'home.starter.marketing_multivariant.firstPrompt': 'Créez 3 variantes de page de destination pour [votre produit] avec des messages hero différents à comparer.',
  'home.starter.internal_dashboard.title': 'Commencer avec un tableau de bord interne',
  'home.starter.internal_dashboard.desc': 'Commencez à partir d\'une mise en page de tableau de bord pour votre workflow.',
  'home.starter.internal_dashboard.firstPrompt': 'Concevez un tableau de bord interne affichant [indicateurs clés] avec des filtres et un tableau de données.',
  'home.starter.internal_report.title': 'Commencer avec un rapport',
  'home.starter.internal_report.desc': 'Décrivez les données et les champs que vous souhaitez voir.',
  'home.starter.internal_report.firstPrompt': 'Créez une page de rapport résumant [décrivez les données, les champs et les indicateurs qui vous intéressent].',
  'home.starter.general_menu.title': 'Commencer avec votre premier projet',
  'home.starter.general_menu.desc': 'Décrivez ce que vous voulez et nous générerons une première version modifiable.',
  'home.starter.general_menu.firstPrompt': 'Créez une première version modifiable de [décrivez ce que vous voulez réaliser].',
  'chat.example4Title': 'Vidéo motion produit',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Créez un storyboard de vidéo motion de 15 secondes pour le lancement d\'une app de productivité : accroche, gros plans UI, typographie cinétique, transitions de fonctionnalités, logo final et CTA. Incluez le timing, les scènes, la caméra et les textes à l\'écran.',
  'preview.usePlugin': 'Utiliser le plugin',
  'preview.usePluginOnly': 'Utiliser sans prompt',
  'preview.usePluginOnlyDesc': 'Utiliser la structure du plugin sans charger le prompt exemple',
  'preview.replicateContent': 'Utiliser',
  'preview.replicateContentDesc': 'Utiliser le prompt exemple pour recreer la previsualisation',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remixer cet exemple dans un nouveau projet modifiable',
  'preview.shareMenu': 'Partager',
  'preview.exportMenu': 'Exporter',
  'preview.shareTemplateBadge': 'Modèle',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copier le lien du modèle',
  'preview.copyShareText': 'Copier le texte de partage',
  'preview.shareSocialGroup': 'Partager sur les réseaux',
  'preview.shareCopyGroup': 'Copier',
  'preview.shareExportGroup': 'Exporter les fichiers',
  'preview.shareCopied': 'Copié',
  'preview.shareCopyFailed': 'Échec de la copie',
  'preview.shareTextDefault': 'Modèle Open Design : {title}',
  'preview.openInNewTab': 'Ouvrir dans un nouvel onglet',
  'preview.exit': '⤓ Quitter',
  'preview.fullscreen': '⤢ Plein écran',
  'preview.closeTitle': 'Fermer (Échap)',
  'preview.loading': 'Chargement de {label}…',
  'preview.errorTitle': 'Impossible de charger cet exemple.',
  'preview.errorBody': 'Le chargement du HTML de l\'exemple a échoué. Vérifiez qu\'Open Design est en cours d\'exécution et réessayez.',
  'preview.retry': 'Réessayer',
  'preview.unavailableTitle': 'Aucun aperçu fourni pour {noun}.',
  'preview.unavailableBody': 'Exécutez le prompt dans le chat pour générer un résultat {kind}.',
  'preview.nounSkill': 'ce Skill',
  'preview.nounPlugin': 'ce plugin',
  'preview.nounTemplate': 'ce modèle',
  'preview.showSidebar': 'Afficher {label}',
  'preview.hideSidebar': 'Masquer {label}',
  'misc.savedTemplate': 'Modèle enregistré',
  'misc.primary': 'Primaire',
  'misc.designSystem': 'Système de design',
  'workspace.designFiles': 'Fichiers de design',
  'workspace.focusMode': 'Espace de travail focalisé',
  'workspace.showChat': 'Afficher le chat',
  'workspace.closeTab': 'Fermer l\'onglet',
  'workspace.fileSyncDownloading': 'Téléchargement depuis l\'équipe…',
  'workspace.fileSyncUploading': 'Synchronisation avec l\'équipe…',
  'workspace.deleteFileConfirm': 'Supprimer « {name} » du dossier du projet ?',
  'workspace.readonlyNotice': 'Ceci est un projet partagé — vous pouvez le consulter et le commenter, mais pas modifier les artefacts via Chat ou les outils d\'édition.',
  'workspace.readonlyNoticeBy': 'Ce projet partagé a été créé par {owner} — vous pouvez le consulter et le commenter, mais pas modifier les artefacts via Chat ou les outils d\'édition.',
  'workspace.deleteSelectedFilesConfirm': 'Supprimer les {n} fichier(s) sélectionné(s) du dossier du projet ?',
  'workspace.deleteSelectedFilesPartial': 'Échec de la suppression de {n} fichier(s).',
  'workspace.openFromDesignFiles': 'Ouvrir un fichier depuis',
  'workspace.designFilesLink': 'Fichiers de design',
  'workspace.loadingSketch': 'Chargement du croquis…',
  'workspace.newTab': 'Nouvel onglet',
  'workspace.searchFilesPlaceholder': 'Rechercher des fichiers…',
  'workspace.openTabs': 'Onglets ouverts',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Ouvrir un fichier',
  'workspace.noFilesMatch': 'Aucun fichier correspondant',
  'workspace.allFiles': 'Tous',
  'workspace.createNew': 'Créer',
  'workspace.tabOpen': 'Ouvert',
  'workspace.sideChatContextBanner': 'Contexte de la conversation actuelle intégré',
  'workspace.sideChatDefaultTitle': 'Chat latéral',
  'workspace.newTerminal': 'Nouveau terminal',
  'workspace.newTerminalDescription': 'Ouvrir un shell dans le répertoire du projet dans un nouvel onglet',
  'workspace.newBrowser': 'Nouveau navigateur',
  'workspace.newBrowserDescription': 'Ouvrir un onglet navigateur intégré pour les sites de référence et les tâches',
  'workspace.newSketchDescription': 'Esquisser des mises en page et notes rapides comme contexte de design pour l’agent',
  'workspace.terminalStarting': 'Démarrage du terminal…',
  'workspace.terminalStartingDescription': 'Préparation du shell du projet. Cela prend généralement quelques secondes.',
  'workspace.terminalSessionEnded': 'Session terminée',
  'workspace.terminalReconnecting': 'Reconnexion…',
  'workspace.terminalStartFailed': 'Impossible de démarrer la session de terminal',
  'workspace.terminalRestart': 'Redémarrer',
  'designFiles.title': 'Fichiers de design',
  'designFiles.upload': 'Téléverser des fichiers',
  'designFiles.pasteText': 'Coller comme fichier texte',
  'designFiles.newSketch': 'Nouveau croquis',
  'designFiles.newDocument': 'Nouveau document',
  'designFiles.newDocumentTitle': 'Créer un nouveau document Markdown',
  'designFiles.empty': 'Les créations apparaîtront ici',
  'designFiles.syncing': 'Synchronisation des fichiers de l\'équipe…',
  'designFiles.refresh': 'Actualiser',
  'designFiles.delete': 'Supprimer',
  'designFiles.searchPlaceholder': 'Rechercher des fichiers…',
  'designFiles.up': 'Haut',
  'designFiles.back': 'Retour',
  'designFiles.crumbs': 'projet',
  'designFiles.rowMenu': 'Menu de ligne',
  'designFiles.openInTab': 'Ouvrir dans un onglet',
  'designFiles.download': 'Télécharger',
  'designFiles.downloadSelected': 'Télécharger {n} sélectionnés en ZIP',
  'designFiles.deleteSelected': 'Supprimer {n}',
  'designFiles.clearSelection': 'Effacer la sélection',
  'designFiles.selectPage': 'Tout sélectionner sur la page',
  'designFiles.selectAll': 'Tout sélectionner',
  'designFiles.dropTitle': '⤓ Déposez les fichiers ici',
  'designFiles.dropDesc': 'Images, documents, références ou dossiers — l\'agent les utilisera comme contexte.',
  'designFiles.dropLabel': 'Déposez les fichiers ici',
  'designFiles.upload.title': 'Téléverser des fichiers',
  'designFiles.paste.title': 'Coller du texte comme fichier',
  'designFiles.upload.label': 'Téléverser',
  'designFiles.paste.label': 'Coller',
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Objectif',
  'designFiles.documentTemplate.goalBody': 'Décrivez ce qu’Open Design doit générer, modifier ou décider à partir de ce document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'Comment utiliser ce document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Utilisez n’importe quel format Markdown : titres, tableaux, checklists, liens, citations, blocs de code et images.',
  'designFiles.documentTemplate.capabilityAgent': 'L’agent Open Design peut lire, modifier et utiliser ce fichier comme contexte de projet.',
  'designFiles.documentTemplate.capabilityImages': 'Collez des images ou glissez des fichiers image dans l’éditeur ; les images importées sont insérées à l’emplacement du curseur.',
  'designFiles.documentTemplate.scenarioHeading': 'Guide de scénario',
  'designFiles.documentTemplate.scenario.prototype': 'Pour les prototypes, décrivez l’objectif produit, les utilisateurs cibles, les flux, écrans, modules, états d’interaction, breakpoints responsive et tokens de design comme couleur, typo, espacement, rayon et motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'Pour les wireframes, décrivez le flux utilisateur, la liste des écrans, la hiérarchie de layout, les blocs de contenu, les contraintes basse fidélité et les questions auxquelles la structure doit répondre avant le design visuel.',
  'designFiles.documentTemplate.scenario.mobile': 'Pour les apps mobiles, listez les plateformes cibles, écrans, modèle de navigation, gestes, motifs natifs, tailles d’appareil, états et tokens de design mobile.',
  'designFiles.documentTemplate.scenario.slideDeck': 'Pour les slides, rédigez un plan PPT paginé : une section par slide avec titre, objectif, message clé, preuves, direction visuelle, notes orateur et besoins d’export.',
  'designFiles.documentTemplate.scenario.document': 'Pour les documents, définissez l’audience, le ton, la structure des sections, les sources, citations ou données, les attentes de mise en page et les exigences PDF/export.',
  'designFiles.documentTemplate.scenario.image': 'Pour les images, précisez le sujet, le ratio, la composition, le style visuel, les tokens de marque, les fichiers de référence et les contraintes négatives.',
  'designFiles.documentTemplate.scenario.video': 'Pour la vidéo, esquissez un storyboard avec scènes, timing, sous-titres, motion, assets, notes audio et format de sortie.',
  'designFiles.documentTemplate.scenario.hyperframes': 'Pour HyperFrames, décrivez la pièce de motion HTML : scènes, timeline, sous-titres, moments audio-réactifs, transitions et exigences de capture/export.',
  'designFiles.documentTemplate.scenario.audio': 'Pour l’audio, définissez la direction voix ou musique, la durée, l’ambiance, le script ou copy, le rythme, les notes de prononciation et l’usage final.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'Pour les artefacts dynamiques, décrivez les sources de données, la fréquence d’actualisation, les widgets, filtres, interactions, états vide/chargement/erreur et éventuelles alertes ou automatisations.',
  'designFiles.documentTemplate.scenario.designSystem': 'Pour les design systems, listez les objectifs de marque, tokens, typographie, couleur, espacement, composants, assets, références et règles à suivre ou éviter.',
  'designFiles.documentTemplate.scenario.default': 'Décrivez l’audience, le livrable, le contenu requis, les références, les contraintes et ce qui définira un résultat terminé.',
  'designFiles.documentTemplate.nextHeading': 'Étape suivante',
  'designFiles.documentTemplate.nextBody': 'Relisez et modifiez ce document, puis demandez à Open Design de générer, réviser ou travailler à partir de lui.',

  'designFiles.projectMenu': 'Actions du projet',
  'designFiles.createDesignSystemFromProject': 'Créer un design system à partir de ce projet',
  'designFiles.duplicateProject': 'Dupliquer le projet',

  'designFiles.previewOpen': 'Ouvrir',
  'designFiles.previewClose': 'Fermer l\'aperçu',
  'designFiles.modified': 'Modifié {time} · {size}',
  'designFiles.weeksAgo': 'il y a {n} sem',
  'designFiles.groupBy': 'Grouper par',
  'designFiles.groupByKind': 'Type',
  'designFiles.groupByModified': 'Modification',
  'designFiles.filterBy': 'Filtrer par type',
  'designFiles.filterClear': 'Effacer',
  'designFiles.filterCount': '{n} types',
  'designFiles.expandGroup': 'Développer',
  'designFiles.collapseGroup': 'Réduire',
  'designFiles.sectionPages': 'Pages',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Images',
  'designFiles.sectionSketches': 'Croquis',
  'designFiles.sectionLiveArtifacts': 'Artefacts dynamiques',
  'designFiles.sectionOther': 'Autre',
  'designFiles.modifiedToday': 'Aujourd’hui',
  'designFiles.modifiedYesterday': 'Hier',
  'designFiles.modifiedPrevious7Days': '7 derniers jours',
  'designFiles.modifiedPrevious30Days': '30 derniers jours',
  'designFiles.modifiedOlder': 'Plus ancien',
  'designFiles.showMore': 'Afficher +{n} de plus',
  'designFiles.kindHtml': 'Page HTML',
  'designFiles.kindImage': 'Image',
  'designFiles.kindSketch': 'Croquis',
  'designFiles.kindText': 'Texte',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Document',
  'designFiles.kindPresentation': 'Présentation',
  'designFiles.kindSpreadsheet': 'Tableur',
  'designFiles.kindLiveArtifact': 'Artefact dynamique',
  'designFiles.kindBinary': 'Binaire',
  'designFiles.kindFolder': 'Dossier',
  'designFiles.folderCount': '{n} fichiers',
  'designFiles.newFolderTitle': 'Nouveau dossier',
  'designFiles.newFolderLabel': 'Nom du dossier',
  'designFiles.moveTitle': 'Déplacer vers le dossier',
  'designFiles.moveLabel': 'Dossier de destination',
  'designFiles.moveRoot': 'Racine du projet',
  'designFiles.moveNewFolder': 'Nouveau dossier…',
  'designFiles.move': 'Déplacer',
  'designFiles.copyPath': 'Copier le chemin',
  'designFiles.copiedPath': 'Chemin copié',
  'designFiles.copyLocalPath': 'Copier le chemin du fichier local',
  'designFiles.copiedLocalPath': 'Chemin du fichier local copié',
  'designFiles.deleteFolderConfirm': 'Supprimer le dossier « {name} » et tout son contenu ?',
  'designFiles.folderCreated': 'Dossier « {name} » créé',
  'designFiles.folderDeleted': 'Dossier « {name} » supprimé',
  'designFiles.filesMoved': '{n} déplacé(s) vers {dest}',
  'designFiles.colName': 'Nom',
  'designFiles.colKind': 'Type',
  'designFiles.colModified': 'Modifié le',
  'designFiles.perPage': 'Afficher',
  'designFiles.all': 'Tout',
  'designFiles.prev': 'Précédent',
  'designFiles.next': 'Suivant',
  'designFiles.jumpToPage': 'Aller à la page',
  'designFiles.pageInfo': '{start}–{end} sur {total}',
  'designFiles.sectionFolders': 'Dossiers',
  'designFiles.sectionStylesheets': 'Feuilles de style',
  'designFiles.sectionDocuments': 'Documents',
  'designFiles.kindStylesheet': 'Feuille de style',
  'designFiles.modifiedExt': 'Modifié {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Infos utiles',
  'designFiles.usefulInfoTip': 'Double-cliquez sur n’importe quel fichier pour l’ouvrir dans un onglet complet.',
  'designFiles.usefulInfoTip2': 'Tapez @ dans le chat pour référencer un fichier comme contexte.',
  'designFiles.usefulInfoTip4': 'Choisissez un design system pour rester fidèle à votre marque.',
  'designFiles.usefulInfoTip5': 'En panne d’idées ? Essayez un modèle de plugin dans Communauté, sur l’accueil.',
  'designFiles.usefulInfoTip6': 'Questions ou suggestions ? Rejoignez-nous sur Discord.',
  'designFiles.usefulInfoTip7': 'Open Design vous plaît ? Donnez-nous une étoile sur GitHub.',
  'designFiles.usefulInfoTip8': 'Suivez @OpenDesignHQ sur X pour suivre les nouveautés.',
  'designFiles.usefulInfoTip9': 'Glissez images, documents ou dossiers entiers dans ce panneau — l’agent les utilisera comme contexte.',
  'designFiles.usefulInfoTip10': 'Cliquez sur « Nouveau croquis », dessinez une mise en page et laissez l’agent la générer.',
  'designFiles.usefulInfoTip11': 'Sélectionnez un élément dans l’aperçu pour le commenter — l’agent fera des retouches ciblées.',
  'designFiles.usefulInfoTip12': 'Résultat décevant ? Entourer l’élément va plus vite que tout redécrire.',
  'designFiles.usefulInfoTip13': 'Exportez vos designs en PDF, image ou HTML autonome en un clic.',
  'designFiles.usefulInfoTip14': 'Un projet vous plaît ? Enregistrez-le comme modèle via le menu Partager.',
  'designFiles.usefulInfoTip15': 'Après le déploiement, générez directement des cartes de partage social.',
  'designFiles.usefulInfoTip16': 'Suivez @opendesign.ai sur Threads pour les coulisses de l\'équipe.',
  'designFiles.usefulInfoTip17': 'Suivez @opendesign.ai sur Instagram pour de l\'inspiration design.',
  'designFiles.usefulInfoTip18': 'Abonnez-vous à Open Design sur YouTube pour des tutoriels et démos.',
  'designFiles.usefulInfoTip19': 'Suivez Open Design sur LinkedIn pour l\'actualité produit.',
  'designFiles.usefulInfoTip20': 'Suivez Open Design sur Xiaohongshu pour des astuces et de l\'inspiration.',
  'quickSwitcher.placeholder': 'Ouvrir un fichier…',
  'quickSwitcher.empty': 'Aucun fichier dans ce projet',
  'quickSwitcher.noMatches': 'Aucun résultat',
  'quickSwitcher.navigate': 'naviguer',
  'quickSwitcher.open': 'ouvrir',
  'quickSwitcher.close': 'fermer',
  'pasteDialog.title': 'Coller du texte',
  'pasteDialog.hint': 'Enregistré dans le dossier du projet. Choisissez un nom.',
  'pasteDialog.fileNameLabel': 'Nom du fichier',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'Contenu',
  'pasteDialog.contentPlaceholder': 'Collez n\'importe quoi…',
  'pasteDialog.save': 'Enregistrer',
  'pasteDialog.cancel': 'Annuler',
  'sketch.save': 'Enregistrer le croquis',
  'sketch.cancel': 'Annuler',
  'sketch.saving': 'Enregistrement…',
  'sketch.saved': 'Enregistré',
  'sketch.tooltipMainMenu': 'Menu principal : enregistrer, exporter, aide et réglages du canevas',
  'sketch.tooltipLock': 'Garder l’outil de dessin actuel actif pour un usage répété',
  'sketch.tooltipHand': 'Déplacer le canevas sans sélectionner d’objets',
  'sketch.tooltipSelection': 'Sélectionner, déplacer, redimensionner ou modifier des objets sur le canevas',
  'sketch.tooltipRectangle': 'Dessiner un rectangle ou une zone de carte',
  'sketch.tooltipDiamond': 'Dessiner un losange pour les décisions ou les embranchements',
  'sketch.tooltipEllipse': 'Dessiner un cercle ou une ellipse',
  'sketch.tooltipArrow': 'Dessiner un connecteur directionnel ou une flèche de flux',
  'sketch.tooltipLine': 'Dessiner un séparateur droit ou une ligne de connexion',
  'sketch.tooltipFreedraw': 'Dessiner des traits à main levée sur le canevas',
  'sketch.tooltipText': 'Ajouter du texte modifiable au canevas',
  'sketch.tooltipImage': 'Insérer une image dans le canevas',
  'sketch.tooltipEraser': 'Effacer des objets du canevas',
  'sketch.tooltipFrame': 'Créer un frame pour regrouper une zone du canevas',
  'sketch.tooltipEmbeddable': 'Web Embed prend uniquement en charge les liens https:// ou http:// valides',
  'sketch.tooltipLaser': 'Pointer temporairement vers le contenu du canevas sans le modifier',
  'sketch.tooltipMoreTools': 'Ouvrir des outils supplémentaires comme frame, web embed et pointeur laser',
  'sketch.tooltipDirty': 'Modifications non enregistrées',
  'sketch.tooltipClean': 'Enregistré',
  'fileViewer.empty': 'Sélectionnez un fichier à afficher.',
  'fileViewer.loading': 'Chargement…',
  'fileViewer.exportPptx': 'Exporter en PPTX',
  'fileViewer.openInNewTab': 'Ouvrir dans un nouvel onglet',
  'fileViewer.copyPath': 'Copier le chemin',
  'fileViewer.copied': 'Copié !',
  'fileViewer.share': 'Partager',
  'fileViewer.binaryMeta': 'Binaire · {size}',
  'fileViewer.binaryNote': 'Fichier binaire ({size} octets). Téléchargez ou ouvrez depuis le disque pour inspecter.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Document',
  'fileViewer.presentationMeta': 'Présentation',
  'fileViewer.spreadsheetMeta': 'Tableur',
  'fileViewer.previewUnavailable': 'Aperçu indisponible. Téléchargez ou ouvrez le fichier pour inspecter.',
  'fileViewer.download': 'Télécharger',
  'fileViewer.open': 'Ouvrir',
  'fileViewer.imageMeta': 'Image · {size}',
  'fileViewer.reactMeta': 'Composant React · {size}',
  'fileViewer.sketchMeta': 'Croquis · {size}',
  'fileViewer.markdownStreamingMeta': 'Aperçu en cours…',
  'fileViewer.markdownErrorMeta': 'L\'aperçu peut être incomplet (erreur de génération).',
  'fileViewer.markdownStreamingStatus': 'Génération en cours… affichage du Markdown partiel.',
  'fileViewer.markdownErrorStatus': 'Erreur de génération. Affichage du dernier contenu disponible.',
  'fileViewer.markdownSaving': 'Enregistrement...',
  'fileViewer.markdownSaveFailed': 'Échec de l’enregistrement',
  'fileViewer.markdownSaved': 'Enregistré',
  'fileViewer.markdownAutoSaved': 'Enregistrement auto · {time}',
  'fileViewer.markdownAutoSaveHint': 'Enregistrement auto activé',
  'fileViewer.markdownViewMode': 'Mode d’affichage Markdown',
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': 'Éditeur Markdown',
  'fileViewer.markdownEditorPlaceholder': 'Saisissez des notes, exigences ou instructions pour ce document...',
  'fileViewer.markdownPreview': 'Aperçu Markdown',
  'fileViewer.videoMeta': 'Vidéo · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Recharger',
  'fileViewer.reloadDisk': 'Recharger depuis le disque',
  'fileViewer.copy': 'Copier',
  'fileViewer.copyTitle': 'Copier le contenu du fichier',
  'fileViewer.saveDisabled': 'Enregistrer (visionneuse en lecture seule)',
  'fileViewer.save': 'Enregistrer',
  'fileViewer.preview': 'Aperçu',
  'fileViewer.source': 'Source',
  'fileViewer.tweaks': 'Ajustements',
  'fileViewer.tweaksUnavailable': 'Aucun panneau d\'ajustements dans cet artefact',
  'fileViewer.jsxModuleTitle': 'Aucun aperçu autonome',
  'fileViewer.jsxModuleBody': 'Ce fichier est un module de composant chargé par une autre page.',
  'fileViewer.jsxModuleCta': 'Ouvrez la page qui le rend :',
  'fileViewer.comment': 'Commenter',
  'fileViewer.edit': 'Modifier',
  'fileViewer.draw': 'Dessiner',
  'fileViewer.mark': 'Annoter',
  'fileViewer.markTool': 'Outil d’annotation',
  'fileViewer.boxSelect': 'Sélection par cadre',
  'fileViewer.textTool': 'Texte',
  'fileViewer.textAnnotationRemove': 'Supprimer le texte',
  'fileViewer.screenshot': 'Capture d’écran',
  'fileViewer.versions.entry': 'Versions',
  'fileViewer.versions.entryFull': 'Historique des versions',
  'fileViewer.versions.title': 'Versions',
  'fileViewer.versions.countOne': '1 version',
  'fileViewer.versions.countMany': '{count} versions',
  'fileViewer.versions.current': 'Actuelle',
  'fileViewer.versions.sourceAi': 'Modification IA',
  'fileViewer.versions.sourceManual': 'Modification manuelle',
  'fileViewer.versions.sourceRestore': 'Restaurée',
  'fileViewer.versions.restoredFrom': 'Restauré depuis v{version}',
  'fileViewer.versions.versionLabel': 'Version {version}',
  'fileViewer.versions.listAria': 'Versions du fichier',
  'fileViewer.versions.loading': 'Chargement des versions...',
  'fileViewer.versions.empty': 'Aucune version pour le moment.',
  'fileViewer.versions.loadFailed': 'Impossible de charger les versions.',
  'fileViewer.versions.previewFailed': 'Impossible de charger l’aperçu de cette version.',
  'fileViewer.versions.previewLoading': 'Chargement de l’aperçu...',
  'fileViewer.versions.noPrompt': 'Aucun prompt enregistré',
  'fileViewer.versions.noPromptBody': 'Aucun prompt n’a été enregistré pour cette version.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Copier le prompt',
  'fileViewer.versions.fullscreen': 'Aperçu plein écran',
  'fileViewer.versions.open': 'Ouvrir l’aperçu',
  'fileViewer.versions.currentHelp': 'C’est déjà la version actuelle.',
  'fileViewer.versions.restoreHelp': 'Le changement restaure ce HTML comme nouvelle version actuelle.',
  'fileViewer.versions.restore': 'Passer à cette version',
  'fileViewer.versions.restoreConfirmTitle': 'Basculer vers cette version ?',
  'fileViewer.versions.restoreConfirmCta': 'Basculer',
  'fileViewer.versions.restoring': 'Changement...',
  'fileViewer.versions.restoreFailed': 'Impossible de passer à cette version.',
  'fileViewer.versions.restoreSuccess': 'Version activée.',
  'fileViewer.editScreenshotToChat': 'Capture d’écran vers le chat',
  'manualEdit.layers': 'Calques',
  'manualEdit.editableCount': '{count} modifiable(s)',
  'manualEdit.hiddenBadge': 'Masqué',
  'manualEdit.title': 'Éditeur manuel',
  'manualEdit.fallbackTitle': 'Modifier',
  'manualEdit.movePanel': 'Déplacer le panneau d’édition',
  'manualEdit.editParams': 'Modifier les paramètres',
  'manualEdit.closePanel': 'Fermer le panneau d’édition',
  'manualEdit.selectLayer': 'Sélectionnez un calque',
  'manualEdit.empty': 'Cliquez sur un élément dans l’aperçu ou choisissez un calque.',
  'manualEdit.noEditableLayers': 'Aucun calque modifiable trouvé.',
  'manualEdit.noClass': 'aucune classe',
  'manualEdit.tabsAria': 'Onglets d’édition manuelle',
  'manualEdit.tabContent': 'Contenu',
  'manualEdit.tabStyle': 'Style',
  'manualEdit.tabAttributes': 'Attributs',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'Source',
  'manualEdit.attributesJson': 'Attributs JSON',
  'manualEdit.selectedHtml': 'HTML de l’élément sélectionné',
  'manualEdit.fullSource': 'Source complète de l’artefact',
  'manualEdit.applyContent': 'Appliquer le contenu',
  'manualEdit.applyStyle': 'Appliquer le style',
  'manualEdit.applyAttributes': 'Appliquer les attributs',
  'manualEdit.applyHtml': 'Appliquer le HTML',
  'manualEdit.applySource': 'Appliquer la source',
  'manualEdit.invalidAttributes': 'JSON d’attributs invalide.',
  'manualEdit.changes': 'Modifications',
  'manualEdit.undo': 'Annuler',
  'manualEdit.redo': 'Rétablir',
  'manualEdit.noChanges': 'Aucune modification manuelle pour l’instant.',
  'manualEdit.imageUrl': 'URL de l’image',
  'manualEdit.altText': 'Texte alternatif',
  'manualEdit.label': 'Libellé',
  'manualEdit.text': 'Texte',
  'manualEdit.href': 'Lien (href)',
  'manualEdit.textColor': 'Couleur du texte',
  'manualEdit.background': 'Arrière-plan',
  'manualEdit.fontSize': 'Taille de police',
  'manualEdit.weight': 'Graisse',
  'manualEdit.align': 'Alignement',
  'manualEdit.textAlignLeft': 'Aligner à gauche',
  'manualEdit.textAlignCenter': 'Centrer',
  'manualEdit.textAlignRight': 'Aligner à droite',
  'manualEdit.padding': 'Marge interne',
  'manualEdit.margin': 'Marge',
  'manualEdit.radius': 'Rayon',
  'manualEdit.referenceValues': 'Valeurs de référence',
  'manualEdit.referenceValuesEmpty': 'Aucune valeur de référence correspondante',
  'manualEdit.referenceValuesLoading': 'Chargement…',
  'manualEdit.lineHeight': 'Interligne',
  'manualEdit.letterSpacing': 'Interlettrage',
  'manualEdit.borderStyle': 'Style de bordure',
  'manualEdit.borderStyleSolid': 'Continu',
  'manualEdit.borderStyleDashed': 'Tirets',
  'manualEdit.borderStyleDotted': 'Pointillés',
  'manualEdit.borderStyleDouble': 'Double',
  'manualEdit.borderStyleNone': 'Aucun',
  'manualEdit.border': 'Bordure',
  'manualEdit.width': 'Largeur',
  'manualEdit.minHeight': 'Hauteur minimale',
  'manualEdit.deleteElement': 'Supprimer l’élément',
  'manualEdit.deleteElementConfirm': 'Supprimer l’élément sélectionné ? Cette action peut être annulée avec Annuler.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Importer une image',
  'manualEdit.uploadingImage': 'Import de l’image…',
  'manualEdit.uploadImageFailed': 'Impossible d’importer l’image.',
  'manualEdit.focusSlides': 'Focaliser les slides',
  'manualEdit.showPanels': 'Afficher les panneaux',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Zoom arrière',
  'fileViewer.zoomIn': 'Zoom avant',
  'fileViewer.resetZoom': 'Réinitialiser le zoom',
  'fileViewer.viewportAria': 'Zone d’aperçu',
  'fileViewer.viewportDesktop': 'Ordinateur',
  'fileViewer.viewportDesktopTitle': 'Aperçu ordinateur pleine largeur',
  'fileViewer.viewportTablet': 'Tablette',
  'fileViewer.viewportTabletTitle': 'Aperçu tablette en 820 × 1180 (référence portrait moderne)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Aperçu mobile en 390 × 844',
  'fileViewer.reloadAria': 'Recharger',
  'fileViewer.previousSlide': 'Diapositive précédente',
  'fileViewer.nextSlide': 'Diapositive suivante',
  'fileViewer.slideNavAria': 'Navigation des diapositives',
  'fileViewer.speakerNotes': 'Notes du présentateur',
  'fileViewer.speakerNotesSlide': 'Diapositive {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'Aucune note pour cette diapositive.',
  'fileViewer.speakerNotesEdit': 'Modifier',
  'fileViewer.speakerNotesSave': 'Enregistrer les notes',
  'fileViewer.speakerNotesSaving': 'Enregistrement…',
  'fileViewer.speakerNotesSaved': 'Enregistré',
  'fileViewer.speakerNotesSaveFailed': 'Impossible d’enregistrer les notes du présentateur.',
  'fileViewer.speakerNotesPlaceholder': 'Ajouter des notes pour cette diapositive…',
  'fileViewer.previewAssetBlockedTitle': 'Ressource d’aperçu bloquée',
  'fileViewer.previewAssetBlockedDetail': 'Impossible de charger {filePath}. Remplacez les liens symboliques externes par des fichiers dans ce projet.',
  'fileViewer.presenterReset': 'Réinitialiser',
  'fileViewer.present': 'Présenter',
  'fileViewer.presentInTab': 'Dans cet onglet',
  'fileViewer.presentFullscreen': 'Plein écran',
  'fileViewer.presentNewTab': 'Nouvel onglet',
  'fileViewer.presentFromBeginning': 'Commencer depuis le début',
  'fileViewer.presentFromCurrentSlide': 'Commencer à la diapositive actuelle',
  'fileViewer.presenterMode': 'Mode Présentateur',
  'fileViewer.exitPresentation': 'Quitter la présentation',
  'fileViewer.shareLabel': 'Partager',
  'fileViewer.shareMenuShareLink': 'PARTAGER',
  'fileViewer.shareMenuPublishOnline': 'PUBLIER EN LIGNE',
  'fileViewer.shareMenuDownload': 'TÉLÉCHARGER',
  'fileViewer.shareMenuPresentation': 'Présentation',
  'fileViewer.shareMenuSourceFiles': 'Fichiers source',
  'fileViewer.shareMenuSave': 'ENREGISTRER',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Publish this file for everyone',
  'fileViewer.publishSingleFileDescription': 'Make the current file externally visible. Anyone with the published link can view it online.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Publishing…',
  'fileViewer.unpublishFile': 'Annuler la publication',
  'fileViewer.shareEmptyStateTitle': 'Rien à partager pour l\'instant',
  'fileViewer.shareEmptyStateDescription': 'Créez ou rejoignez une équipe pour partager ce fichier avec vos collègues',
  'fileViewer.shareEmptyStateCreateTeam': 'Créer une équipe',
  'fileViewer.shareTeamMissingTitle': 'Pas encore d\'équipe pour partager',

  'fileViewer.publishFileRequiresTeam': 'La publication d’un lien public nécessite un espace de travail d’équipe. Passez à un espace d’équipe ou utilisez Déployer pour publier ce fichier.',
  'fileViewer.publishFileRequiresWorkspace': 'La publication d’un lien public nécessite d’être connecté à un espace de travail. Connectez-vous à Open Design Cloud ou utilisez Déployer pour publier ce fichier.',
  'fileViewer.publishFileFailed': 'Impossible de publier ce fichier. Veuillez réessayer.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Copier le lien de partage',
  'fileViewer.openSharePage': 'Ouvrir la page de partage',
  'fileViewer.shareLinkRequiresDeploy': 'Publiez d’abord en ligne pour obtenir un lien',
  'fileViewer.shareLinkPublishGuide': 'Publiez en ligne ci-dessus pour activer le partage ↑',
  'fileViewer.shareAfterGenerationComplete': 'Partage disponible après la génération',
  'fileViewer.copyProviderLink': 'Copier le lien {provider}',
  'fileViewer.copyCloudflareLink': 'Copier le lien Cloudflare',
  'fileViewer.screenshotCopying': 'Copie de la capture d’écran…',
  'fileViewer.screenshotCopied': 'Capture d’écran copiée dans le presse-papiers',
  'fileViewer.screenshotClipboardDenied': 'Le navigateur a bloqué l’accès au presse-papiers',
  'fileViewer.screenshotPreviewLoading': 'L’aperçu est encore en cours de chargement. Réessayez dans un instant.',
  'fileViewer.screenshotCaptureFailed': 'Impossible de capturer l’aperçu. Veuillez réessayer.',
  'fileViewer.exportPdf': 'Exporter en PDF',
  'fileViewer.exportPdfAllSlides': 'Exporter en PDF (toutes les diapos)',
  'fileViewer.exportPptxBusy': 'Attendez la fin du tour en cours.',
  'fileViewer.exportPptxHint': 'Envoyez une requête à l\'agent pour convertir ce design en PPTX.',
  'fileViewer.exportPptxNa': 'L\'export PPTX n\'est pas disponible ici.',
  'fileViewer.exportZip': 'Télécharger en .zip',
  'fileViewer.exportHtml': 'Exporter en HTML autonome',
  'fileViewer.exportMd': 'Exporter en Markdown',
  'fileViewer.exportImage': 'Exporter en image',
  'fileViewer.exportPptxImages': 'Exporter en PPTX (images)',
  'fileViewer.exportPptxEditable': 'Exporter en PPTX (modifiable)',
  'fileViewer.exportPptxEditableHint': 'Formes et texte natifs modifiables (pas au pixel près)',
  'fileViewer.exportPptxModalSubtitle': 'Choisissez le mode d’export, puis téléchargez.',
  'fileViewer.exportPptxScreenshot': 'PPTX en captures d’écran',
  'fileViewer.exportPptxScreenshotHint': 'Une image par diapositive — fidèle au pixel près, mais non modifiable.',
  'fileViewer.exportPptxConfirm': 'Exporter',
  'fileViewer.exportPptxRecommended': 'Recommandé',
  'fileViewer.exportingProgress': 'Exportation…',
  'fileViewer.exportSlideProgress': 'Exportation de la diapositive {current}/{total}…',
  'fileViewer.exportingElapsed': 'Exportation… {seconds}s',
  'fileViewer.exportSlideEta': 'Diapositive {current}/{total} · ~{seconds}s restantes',
  'fileViewer.exportFailed': 'Échec de l’exportation. Veuillez réessayer.',
  'fileViewer.exportDone': 'Exportation terminée',
  'fileViewer.exportImageFailed': 'La capture d\'image a échoué. Veuillez réessayer ou utiliser l\'outil de capture d\'écran de votre navigateur.',
  'fileViewer.exportImageModalSubtitle': 'Choisissez un format, puis téléchargez l’aperçu actuel en image.',
  'fileViewer.exportImageFormatLabel': 'Format',
  'fileViewer.exportImageSaving': 'Enregistrement de l’image…',
  'fileViewer.exportImageSaved': 'Image enregistrée',
  'fileViewer.exportImageDownloadStarted': 'Téléchargement démarré',
  'fileViewer.exportImageDownloadDetails': '{filename} se trouve dans les téléchargements du navigateur si aucune fenêtre Enregistrer sous n’est apparue.',
  'fileViewer.exportJsx': 'Exporter en JSX',
  'fileViewer.exportReactHtml': 'Exporter l\'aperçu en HTML',
  'fileViewer.exportStarted': 'Export démarré',
  'fileViewer.saveAsTemplate': 'Enregistrer comme modèle…',
  'fileViewer.savingTemplate': 'Enregistrement du modèle…',
  'fileViewer.savedTemplate': 'Enregistré comme « {name} »',
  'fileViewer.savedTemplateFail': 'Impossible d\'enregistrer le modèle — réessayez.',
  'fileViewer.templateNamePrompt': 'Nom du modèle',
  'fileViewer.templateNameDefault': 'Modèle sans titre',
  'fileViewer.templateDescPrompt': 'Courte description (optionnelle — qu\'est-ce qui rend ce modèle utile ?)',
  'liveArtifact.refresh.button': 'Actualiser',
  'liveArtifact.refresh.buttonTitle': 'Actualiser cet artefact dynamique',
  'liveArtifact.refresh.loadingTitle': 'Chargement de l’artefact dynamique…',
  'liveArtifact.refresh.noSourceTitle': 'Aucune source d’actualisation n’est encore disponible.',
  'liveArtifact.refresh.running': 'Actualisation…',
  'liveArtifact.refresh.runningMessage': 'Actualisation des données et de l’aperçu. Cela peut prendre un moment.',
  'liveArtifact.refresh.runningAction': 'L’aperçu précédent reste visible jusqu’à la réussite de l’actualisation.',
  'liveArtifact.refresh.successOne': 'Actualisation terminée. Données mises à jour.',
  'liveArtifact.refresh.successMany': 'Actualisation terminée. Données mises à jour.',
  'liveArtifact.refresh.successAction': 'L’aperçu a été rechargé avec les dernières données validées.',
  'liveArtifact.refresh.previousFailure': 'Échec de l’actualisation précédente : {message}',
  'liveArtifact.refresh.failureAction': 'Consultez l’historique d’actualisation, corrigez la source ou le problème d’autorisation, puis réessayez.',
  'liveArtifact.refresh.networkFailure': 'La requête d’actualisation a échoué. Vérifiez votre connexion puis réessayez.',
  'liveArtifact.refresh.genericFailure': 'Échec de l’actualisation.',
  'liveArtifact.refresh.statusNever': 'Non actualisable',
  'liveArtifact.refresh.statusReady': 'Prêt à actualiser',
  'liveArtifact.refresh.statusSucceeded': 'À jour',
  'liveArtifact.refresh.statusFailed': 'Échec de l’actualisation',
  'liveArtifact.refresh.statusRunning': 'Actualisation en cours',
  'liveArtifact.refresh.statusRunningDescription': 'Une actualisation est actuellement en cours.',
  'liveArtifact.refresh.statusSucceededDescription': 'La dernière actualisation s’est terminée avec succès.',
  'liveArtifact.refresh.statusFailedDescription': 'La dernière tentative d’actualisation ne s’est pas terminée correctement.',
  'liveArtifact.refresh.statusReadyDescription': 'Des sources actualisables sont configurées, mais aucune exécution n’est en cours.',
  'liveArtifact.refresh.statusNeverDescription': 'Cet artefact dynamique n’a pas encore de source d’actualisation.',
  'liveArtifact.refresh.eventStarted': 'Démarrée',
  'liveArtifact.refresh.eventSucceeded': 'Réussie',
  'liveArtifact.refresh.eventFailed': 'Échouée',
  'liveArtifact.refresh.eventStartedDetail': 'Actualisation démarrée…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} source mise à jour',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} sources mises à jour',
  'liveArtifact.refresh.timelineEmpty': 'Aucune activité d’actualisation dans cette session. Lancez Actualiser pour enregistrer une chronologie, ou attendez les exécutions automatiques.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Dernière actualisation',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Jamais',
  'liveArtifact.refresh.justNow': 'à l’instant',
  'liveArtifact.refresh.factCreated': 'Créé',
  'liveArtifact.refresh.factLastUpdated': 'Dernière mise à jour',
  'liveArtifact.refresh.factUnknown': 'Inconnu',
  'liveArtifact.refresh.persistedTitle': 'Historique d’actualisation conservé',
  'liveArtifact.refresh.persistedHint': 'Entrées chargées depuis refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'Aucun historique d’actualisation conservé pour l’instant.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'réussi',
  'liveArtifact.refresh.persistedStatusRunning': 'en cours',
  'liveArtifact.refresh.persistedStatusFailed': 'échoué',
  'liveArtifact.refresh.persistedStatusCancelled': 'annulé',
  'liveArtifact.refresh.persistedStatusSkipped': 'ignoré',
  'liveArtifact.refresh.sessionTitle': 'Activité de la session',
  'liveArtifact.refresh.sessionHint': 'Événements observés pendant que cet onglet est ouvert',
  'liveArtifact.refresh.docSourceTitle': 'Source du document',
  'liveArtifact.refresh.docSourceHint': 'Source configurée',
  'liveArtifact.refresh.docSourceType': 'Type',
  'liveArtifact.refresh.docSourceTool': 'Outil',
  'liveArtifact.refresh.docSourceConnector': 'Connecteur',
  'liveArtifact.refresh.debugSummary': 'Métadonnées de débogage avancées',
  'liveArtifact.refresh.debugNote': 'Peut inclure des IDs de connecteur, des noms de fichiers, des métadonnées de source et des chemins internes d’artefact.',
  'liveArtifact.viewer.tabPreview': 'Aperçu',
  'liveArtifact.viewer.tabCode': 'Code',
  'liveArtifact.viewer.tabData': 'Données',
  'liveArtifact.viewer.tabRefreshHistory': 'Historique d’actualisation',
  'liveArtifact.viewer.dataEmpty': 'Aucun cache data.json disponible.',
  'liveArtifact.viewer.code.templateHeading': 'HTML du modèle',
  'liveArtifact.viewer.code.renderedHeading': 'HTML rendu',
  'liveArtifact.viewer.code.templateHelp': 'Le modèle modifiable utilisé avec data.json pour générer l’aperçu.',
  'liveArtifact.viewer.code.renderedHelp': 'Le fichier index.html généré actuellement chargé dans l’aperçu.',
  'liveArtifact.viewer.code.variantAria': 'Variante du code',
  'liveArtifact.viewer.code.variantTemplate': 'Modèle',
  'liveArtifact.viewer.code.variantRendered': 'Rendu',
  'liveArtifact.viewer.code.loading': 'Chargement du code…',
  'liveArtifact.viewer.code.unavailable': 'Le code n’est pas encore disponible.',
  'liveArtifact.viewer.code.empty': 'Ce fichier de code est vide.',
  'fileViewer.deployToVercel': 'Déployer sur Vercel',
  'fileViewer.redeployToVercel': 'Redéployer',
  'fileViewer.deployingToVercel': 'Déploiement sur Vercel…',
  'fileViewer.deployProviderLabel': 'Fournisseur',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Cible',
  'fileViewer.deployTargetPreview': 'Aperçu',
  'fileViewer.deployTargetProduction': 'Production',
  'fileViewer.deployToProvider': 'Déployer sur {provider}',
  'fileViewer.redeployToProvider': 'Redéployer sur {provider}',
  'fileViewer.deployingToProvider': 'Déploiement sur {provider}…',
  'fileViewer.preparingPublicLink': 'Préparation du lien public…',
  'fileViewer.copyDeployLink': 'Copier le lien',
  'fileViewer.deployModalTitle': 'Déployer',
  'fileViewer.deployModalSubtitle': 'Utilisez le compte du fournisseur sélectionné pour déployer cet aperçu HTML.',
  'fileViewer.vercelToken': 'Jeton Vercel',
  'fileViewer.vercelTokenGetLink': 'Obtenir un jeton Vercel',
  'fileViewer.vercelTokenPlaceholder': 'Collez votre jeton Vercel',
  'fileViewer.vercelTokenReuseHint': 'Le jeton enregistré sera utilisé. Saisissez un nouveau jeton pour le remplacer.',
  'fileViewer.vercelTokenRequired': 'Saisissez et enregistrez d’abord un jeton Vercel.',
  'fileViewer.cloudflareApiToken': 'Jeton API Cloudflare',
  'fileViewer.cloudflareApiTokenGetLink': 'Obtenir un jeton API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Collez votre jeton API Cloudflare',
  'fileViewer.cloudflareApiTokenReuseHint': 'Le jeton API Cloudflare enregistré sera utilisé. Saisissez un nouveau jeton pour le remplacer.',
  'fileViewer.cloudflareApiTokenRequired': 'Saisissez et enregistrez d’abord un jeton API Cloudflare.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Sélectionnez Pages Edit lors de la création du jeton API ; les domaines personnalisés nécessitent Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'ID d’équipe',
  'fileViewer.vercelTeamSlug': 'Slug d’équipe',
  'fileViewer.cloudflareAccountId': 'ID de compte',
  'fileViewer.cloudflareAccountIdHint': 'Trouvez l’ID du compte dans le tableau de bord Cloudflare.',
  'fileViewer.cloudflareAccountIdRequired': 'Saisissez et enregistrez d’abord un ID de compte Cloudflare.',
  'fileViewer.cloudflareZoneLabel': 'Domaine',
  'fileViewer.cloudflareZonePlaceholder': 'Enregistrez les réglages Cloudflare pour charger les domaines',
  'fileViewer.cloudflareZoneRequired': 'Sélectionnez d’abord un domaine Cloudflare.',
  'fileViewer.cloudflareZonesLoading': 'Chargement des domaines Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'Actualiser les domaines',
  'fileViewer.cloudflareZonesLoadFailed': 'Impossible de charger les domaines Cloudflare.',
  'fileViewer.cloudflareZonesEmpty': 'Aucun domaine Cloudflare complet et actif n’a été trouvé pour ce compte.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Préfixe de sous-domaine',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Utilisez un seul libellé DNS : lettres minuscules, chiffres et traits d’union.',
  'fileViewer.cloudflareHostnamePreview': 'Aperçu du domaine personnalisé : {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Facultatif : associez un domaine personnalisé. Si ce champ reste vide, un lien pages.dev sera quand même créé.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'URL pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Domaine personnalisé',
  'fileViewer.optional': 'Facultatif',
  'fileViewer.vercelPreviewOnly': 'Les déploiements sont en mode prévisualisation pour le moment.',
  'fileViewer.cloudflarePagesPreviewHint': 'Les déploiements Cloudflare Pages utilisent le téléversement direct (Direct Upload).',
  'fileViewer.savingConfig': 'Enregistrement…',
  'fileViewer.deployConfigSaveFailed': 'Impossible d’enregistrer les réglages Vercel.',
  'fileViewer.deployFailed': 'Échec du déploiement. Vérifiez les réglages Vercel et réessayez.',
  'fileViewer.deployProviderConfigSaveFailed': 'Impossible d’enregistrer les réglages {provider}.',
  'fileViewer.deployProviderFailed': 'Échec du déploiement {provider}. Vérifiez les réglages et réessayez.',
  'fileViewer.deployResultLabel': 'URL déployée',
  'fileViewer.deployLinkReady': 'Prêt',
  'fileViewer.deploySuccessToast': 'Déploiement téléversé avec succès',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Lien public en attente',
  'fileViewer.deployLinkDelayed': 'Le site est déployé. Le fournisseur prépare encore le lien public.',
  'fileViewer.deployLinkFailed': 'Le domaine personnalisé a échoué',
  'fileViewer.deployLinkProtectedLabel': 'Protection du déploiement activée',
  'fileViewer.deployLinkProtected': 'Le site est déployé, mais ce lien de prévisualisation exige une authentification. Désactivez la protection du déploiement (Deployment Protection) ou utilisez un domaine personnalisé.',
  'fileViewer.retryLink': 'Réessayer maintenant',
  'questionForm.submit': 'Envoyer',
  'questionForm.skip': 'Passer',
  'questionForm.locked': 'Répondu',
  'conv.switch': 'Changer de conversation',
  'conv.label': 'Conversation',
  'conv.heading': 'Conversations',
  'conv.new': '+ Nouvelle',
  'conv.empty': 'Aucune conversation pour l\'instant.',
  'conv.untitled': 'Conversation sans titre',
  'conv.renameTooltip': 'Double-cliquez pour renommer',
  'conv.delete': 'Supprimer la conversation',
  'conv.deleteConfirm': 'Supprimer « {title} » ? Cela supprime ses messages.',
  'agentPicker.label': 'Agent',
  'agentPicker.modeChoose': 'Choisir le mode d\'exécution',
  'agentPicker.localCli': 'CLI local',
  'agentPicker.daemonOff': 'daemon arrêté',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Sélectionner un agent CLI détecté',
  'agentPicker.noAgents': 'aucun agent dans le PATH',
  'agentPicker.notInstalled': 'non installé',
  'agentPicker.rescan': 'Réanalyser le PATH local pour les agents',
  'tool.openInTab': 'Ouvrir {name} dans un onglet',
  'tool.open': 'ouvrir',
  'tool.todos': 'Tâches',
  'tool.todosExpand': 'Afficher les tâches',
  'tool.todosCollapse': 'Masquer les tâches',
  'tool.todosDone': 'Terminé',
  'tool.todosDismiss': 'Fermer la liste des tâches',
  'tool.write': 'Écrire',
  'tool.edit': 'Modifier',
  'tool.read': 'Lire',
  'tool.delete': 'Supprimer',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Rechercher',
  'tool.lines': '{n} lignes',
  'tool.changeSingular': 'modification',
  'tool.changePlural': 'modifications',
  'tool.in': 'dans {path}',
  'tool.hide': 'masquer',
  'tool.output': 'sortie',
  'tool.running': 'en cours…',
  'tool.error': 'erreur',
  'tool.done': 'terminé',
  'assistant.role': 'Assistant',
  'assistant.workingLabel': 'En cours',
  'assistant.doneLabel': 'Terminé',
  'assistant.copyMarkdown': 'Copier le Markdown de la réponse',
  'assistant.forkConversation': 'Créer un fork à partir d’ici',
  'assistant.forkingConversation': 'Création du fork…',
  'assistant.shareToOpenDesign': 'Partager avec Open Design',
  'assistant.shareToOpenDesignBusy': 'Préparation du partage…',
  'assistant.feedbackPrompt': 'Avis',
  'assistant.feedbackPositive': 'Utile',
  'assistant.feedbackNegative': 'Pas utile',
  'assistant.feedbackReasonTitle': 'Dites-nous pourquoi',
  'assistant.feedbackReasonPositiveMatched': 'A compris ma demande',
  'assistant.feedbackReasonPositiveVisual': 'Rendu visuel réussi',
  'assistant.feedbackReasonPositiveUseful': 'Structure utile',
  'assistant.feedbackReasonPositiveEasy': 'Facile à continuer à modifier',
  'assistant.feedbackReasonPositiveDesignSystem': 'A respecté le système de design',
  'assistant.feedbackReasonNegativeMissed': 'N’a pas compris ma demande',
  'assistant.feedbackReasonNegativeVisual': 'La qualité visuelle doit être améliorée',
  'assistant.feedbackReasonNegativeIncomplete': 'Sortie incomplète',
  'assistant.feedbackReasonNegativeHard': 'Difficile à utiliser',
  'assistant.feedbackReasonNegativeDesignSystem': 'N’a pas respecté le système de design',
  'assistant.feedbackReasonOther': 'Autre',
  'assistant.feedbackReasonPlaceholder': 'Ajoutez une courte note...',
  'assistant.feedbackReasonSubmit': 'Envoyer',
  'assistant.emptyResponseLabel': 'Aucune sortie',
  'assistant.emptyResponseMessage': 'Le fournisseur a terminé la requête sans renvoyer de texte ni d’artefact. Essayez un autre modèle ou fournisseur, vérifiez le quota, ou réessayez.',
  'assistant.unfinishedLabel': 'Arrêté avec du travail non terminé',
  'assistant.unfinishedSummary': '{n} tâche(s) restante(s)',
  'assistant.unfinishedMore': '+{n} de plus',
  'assistant.continueRemaining': 'Continuer les tâches restantes',
  'chat.resumeRunCta': 'Reprendre l’exécution',
  'assistant.outTokens': '{n} sortie',
  'assistant.producedFiles': 'Fichiers de ce tour',
  'assistant.openFile': 'Ouvrir',
  'assistant.downloadFile': 'Télécharger',
  'nextStep.title': 'Étape suivante',
  'nextStep.more': 'Plus',
  'nextStep.share': 'Partager',
  'nextStep.download': 'Télécharger',
  'nextStep.createDesignSystemTitle': 'Créer un design system',
  'nextStep.createDesignSystemBody': 'Dupliquez ce projet dans un espace de travail design-system et lancez une passe agent à partir de tous les fichiers et références actuels.',
  'nextStep.createDesignSystemBusy': 'Création du design system...',
  'nextStep.contribute': 'Contribuer',
  'nextStep.brandAiOptimizeTitle': 'Affiner le système de design extrait',
  'nextStep.brandAiOptimizeBody': 'Lance une exécution d’agent qui consomme des tokens de modèle, réextrait la source et met à jour ce système de design sur place.',
  'nextStep.brandCreateDesignTitle': 'Créer avec ce système de design',
  'nextStep.brandCreateDesignBody': 'Commencez un nouveau design avec les couleurs, la typographie, les assets et les consignes système extraits.',
  'nextStep.createDesignBusy': 'Création du design…',
  'nextStep.planGenerateTitle': "Générer depuis le document",
  'nextStep.planGenerateBody': "Utilisez le plan Markdown approuvé comme source de vérité pour la prochaine exécution de design.",
  'nextStep.planImproveTitle': "Améliorer le document",
  'nextStep.planImproveBody': "Renforcez le document de plan actuel avant de générer l’artefact final.",
  'nextStep.planGeneratePrompt': "Utilisez `{file}` comme source de vérité. Lisez d’abord le document, préservez ses décisions, puis générez l’artefact de design final correspondant. S’il s’agit d’un plan de diapositives, générez le deck ; s’il s’agit d’un PRD ou d’un plan de prototype, générez le prototype ou les maquettes filaires ; s’il s’agit d’un storyboard ou d’un brief créatif, générez l’artefact visuel ou média correspondant. Avant de générer, signalez tout TODO bloquant ou toute contradiction que vous ne pouvez pas résoudre.",
  'nextStep.planImprovePrompt': "Lisez `{file}` et améliorez-le sur place comme document de plan modifiable. Resserrez le périmètre, renforcez les sections faibles, ajoutez les contrôles d’acceptation manquants, et conservez les TODO/questions ouvertes lorsqu’une intervention utilisateur reste nécessaire. Ne générez pas encore l’artefact final.",
  'nextStep.planImproveArtifactTitle': "Améliorer l’artefact",
  'nextStep.planImproveArtifactBody': "Continuez à itérer sur l’artefact généré au lieu de revenir à la planification.",
  'nextStep.planImproveArtifactPrompt': "Améliorez `{artifact}` sur place. Conservez l’artefact fonctionnel existant et apportez les améliorations produit, visuelles, d’interaction et de contenu ayant le plus d’impact. Préservez le comportement qui fonctionne déjà, puis résumez les fichiers modifiés et les risques restants.",
  'nextStep.planMergeTitle': "Aligner document et artefact",
  'nextStep.planMergeBody': "Réconciliez le plan et l’artefact généré afin qu’ils avancent ensemble.",
  'nextStep.planMergePrompt': "Lisez `{document}` et `{artifact}` ensemble. Traitez le document comme l’intention et l’artefact comme l’implémentation actuelle. Réconciliez-les : mettez à jour l’artefact pour refléter les décisions confirmées, ne mettez à jour le document que lorsqu’il est obsolète, et conservez des TODO/questions ouvertes explicites pour tout ce qui reste non résolu. Préservez le comportement existant qui fonctionne et résumez ce qui a changé dans les deux fichiers.",

  'nextStep.projectContinueTitle': 'Continuer le travail',
  'nextStep.projectGenerateArtifactTitle': 'Générer l’artefact',
  'nextStep.designSystemAiRefineTitle': 'Affiner le système de design avec l’IA',
  'nextStep.designSystemAuditKitTitle': 'Auditer les tokens et le kit',

  'nextStep.brandCreateDesignPrompt': 'Créez un nouveau design avec le système de design {designSystem}.',

  'nextStep.brandContinueExtractionTitle': 'Continuer l’extraction',
  'nextStep.brandContinueExtractionBody': 'Une fois l’onglet Browser passé au-delà de toute vérification, lisez-le et continuez à remplir le kit enregistré.',
  'nextStep.brandContinueExtractionBusy': 'Poursuite de l’extraction…',
  'nextStep.brandContinueAiExtractionTitle': 'Continuer avec l’agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Utilisez l’agent sélectionné pour extraire depuis le brouillon enregistré si la passe programmatique ne peut toujours pas terminer.',
  'nextStep.brandContinueAiExtractionAiBody': 'Reprenez l’agent sélectionné depuis le scaffold de marque actuel et finalisez le même système de design.',
  'nextStep.brandContinueAiExtractionBusy': 'Poursuite avec l’agent…',
  'assistant.thinking': 'Réflexion',
  'assistant.thought': 'A réfléchi',
  'assistant.thoughtFor': 'Réflexion {s}s',
  'assistant.systemReminder': 'Rappel système',
  'assistant.possiblePromptInjection': 'Injection de prompt possible',
  'assistant.waitingFirstOutput': 'En attente de la première sortie',
  'assistant.statusBootingAgent': 'Démarrage de l\'agent',
  'assistant.statusPreparing': 'Préparation…',
  'assistant.statusStarting': 'Démarrage',
  'assistant.statusRequesting': 'Envoi de la requête',
  'assistant.statusThinking': 'Réflexion',
  'assistant.statusStreaming': 'Réponse en cours',
  'assistant.slowHint': 'Plus long que d\'habitude. Le formulaire s\'affiche généralement en 5–10s — vous pouvez Arrêter et reformuler.',
  'assistant.verbEditing': 'Modification',
  'assistant.verbWriting': 'Écriture',
  'assistant.verbReading': 'Lecture',
  'assistant.verbSearching': 'Recherche',
  'assistant.verbRunning': 'Exécution',
  'assistant.verbTodos': 'Tâches',
  'assistant.verbFetching': 'Récupération',
  'assistant.verbCalling': 'Appel',
  'qf.answered': 'répondu',
  'qf.choose': 'Choisir…',
  'qf.customLabel': 'Réponse personnalisée',
  'qf.customPlaceholder': 'Saisissez votre propre réponse...',
  'qf.otherOption': 'Autre',
  'qf.required': 'requis',
  'qf.lockedSubmitted': 'Réponses envoyées — l\'agent les utilise pour le reste de la session.',
  'qf.lockedPrev': 'Ce formulaire provient d\'un tour précédent.',
  'qf.hint': 'Choisissez ce qui convient. Ignorez les champs optionnels qui ne vous intéressent pas — l\'agent utilisera des valeurs par défaut raisonnables.',
  'qf.submitDefault': 'Envoyer les réponses',
  'qf.submitDisabledTitle': 'Remplissez d\'abord les champs requis',
  'qf.submitTitle': 'Envoyer les réponses',
  'qf.cardSelected': 'sélectionné',
  'qf.cardRefs': 'Réfs :',
  'qf.cardSampleText': 'Portez ce vieux whisky au juge blond qui fume · 0123',
  'questions.tabLabel': 'Questions',
  'questions.banner': 'Puis-je vous poser deux ou trois questions rapides ?',
  'questions.bannerAnswered': 'Questions traitées',
  'questions.continue': 'Continuer',
  'questions.generating': 'Génération des questions…',
  'questions.skipAll': 'Tout ignorer',
  'questions.autoSkipHint': 'Continue automatiquement quand le minuteur se termine',
  'questions.submitting': 'Envoi en cours…',
  'sketch.toolSelect': 'Sélection (sans effet)',
  'sketch.toolPen': 'Stylo',
  'sketch.toolText': 'Texte',
  'sketch.toolRect': 'Rectangle',
  'sketch.toolArrow': 'Flèche',
  'sketch.toolEraser': 'Gomme',
  'sketch.color': 'Couleur',
  'sketch.strokeSize': 'Taille du trait',
  'sketch.undo': 'Annuler',
  'sketch.clear': 'Effacer',
  'sketch.close': 'Fermer',
  'sketch.closeConfirm': 'Fermer le croquis et abandonner vos modifications non enregistrées ?',
  'sketch.textPrompt': 'Texte :',
  'sketch.textModalTitle': 'Ajouter du texte',
  'critiqueTheater.userFacingName': 'Jury de design',
  'critiqueTheater.roleDesigner': 'Concepteur',
  'critiqueTheater.roleCritic': 'Critique',
  'critiqueTheater.roleBrand': 'Marque',
  'critiqueTheater.roleA11y': 'Accessibilité',
  'critiqueTheater.roleCopy': 'Rédaction',
  'critiqueTheater.roundLabel': 'Tour {n} sur {m}',
  'critiqueTheater.mustFix': '{n} à corriger',
  'critiqueTheater.composite': 'Score composite',
  'critiqueTheater.threshold': 'Seuil',
  'critiqueTheater.consensus': 'Consensus',
  'critiqueTheater.interrupt': 'Interrompre',
  'critiqueTheater.interrupting': 'Interruption…',
  'critiqueTheater.interrupted': 'Interrompu',
  'critiqueTheater.degradedHeading': 'Panel hors ligne pour cette exécution',
  'critiqueTheater.degradedReasonMalformed': 'Sortie de panel mal formée (bloc rejeté par le parseur).',
  'critiqueTheater.degradedReasonOversize': 'La sortie du panel a dépassé le budget d’octets sécurisé.',
  'critiqueTheater.degradedReasonAdapter': 'L’adaptateur {adapter} ne prend pas en charge le protocole Critique.',
  'critiqueTheater.degradedReasonProtocol': 'L’adaptateur {adapter} a envoyé une version de protocole non prise en charge.',
  'critiqueTheater.degradedReasonMissingArtifact': 'L’exécution s’est terminée sans artefact final.',
  'critiqueTheater.replay': 'Rejouer',
  'critiqueTheater.replaySpeed': 'Vitesse de relecture',
  'critiqueTheater.readOnly': 'Lecture seule',
  'critiqueTheater.shippedSummary': 'Livré au tour {round} · score composite {composite}',
  'critiqueTheater.interruptedSummary': 'Interrompu au tour {round} · meilleur score composite {composite}',
  'critiqueTheater.shippedBadge': 'Livré',
  'critiqueTheater.belowThresholdBadge': 'Sous le seuil',
  'critiqueTheater.timedOutBadge': 'Délai dépassé',
  'critiqueTheater.failedHeading': 'Échec de l’exécution',
  'critiqueTheater.failedReasonCliExit': 'La CLI de l’agent s’est arrêtée avec un code non nul avant la fin du panel.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Un tour a dépassé son budget de temps.',
  'critiqueTheater.failedReasonTotalTimeout': 'L’exécution complète a dépassé son budget de temps.',
  'critiqueTheater.failedReasonOrchestrator': 'Erreur interne de l’orchestrateur.',
  'critiqueTheater.transcriptEmpty': 'Aucune transcription à rejouer pour l’instant. Lancez une critique pour en enregistrer une.',
  'critiqueTheater.transcriptLoading': 'Chargement de la transcription…',
  'critiqueTheater.transcriptError': 'Impossible de charger la transcription : {error}',
  'critiqueTheater.replaySpeedPaused': 'En pause',
  'critiqueTheater.replaySpeedInstant': 'Instantané',
  'critiqueTheater.replaySpeedLive': 'Temps réel',
  'critiqueTheater.replaySpeedFast': 'Rapide',
  'critiqueTheater.settingsNav': 'Jury de design',
  'critiqueTheater.settingsNavHint': 'Revue de design à cinq panels pour vos exécutions',
  'critiqueTheater.settingsEnabledLabel': 'Afficher le Jury de design pendant les exécutions de l’agent',
  'critiqueTheater.settingsEnabledDescription': 'Lorsque cette option est activée, une revue à cinq panels apparaît à côté des générations de l’agent et note le résultat avant l’expédition. Vous pouvez l’interrompre à tout moment.',
  'critiqueTheater.settingsEnabledProjectHint': 'Enregistré pour ce projet. Les nouvelles exécutions de ce projet passeront côté serveur par le Jury de design.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Ouvrez un projet pour enregistrer ce réglage côté serveur. D’ici là, seule la préférence dans ce navigateur change.',
  'pet.title': 'Compagnons',
  'pet.subtitle': 'Adoptez un petit compagnon qui flotte au-dessus de votre espace de travail.',
  'pet.navTitle': 'Compagnons',
  'pet.navHint': 'Adopter ou personnaliser',
  'pet.tabBuiltIn': 'Intégrés',
  'pet.tabBuiltInHint': 'Compagnons fournis avec Open Design — choisissez-en un et adoptez-le.',
  'pet.builtInEmpty': 'Les compagnons intégrés sont indisponibles pour l\'instant. Essayez d\'actualiser l\'onglet Communauté une fois le daemon en ligne.',
  'pet.tabCustom': 'Personnalisé',
  'pet.tabCustomHint': 'Créez le vôtre avec un nom, un glyphe, une couleur ou un sprite.',
  'pet.tabCommunity': 'Communauté',
  'pet.tabCommunityHint': 'Compagnons éclos de Codex — adoptez-en un ou générez-en un nouveau.',
  'pet.tabsAria': 'Source du compagnon',
  'pet.adopt': 'Adopter',
  'pet.adoptedBadge': 'Adopté',
  'pet.adoptCallout': 'Adopter un compagnon',
  'pet.changePet': 'Changer de compagnon',
  'pet.wake': 'Réveiller',
  'pet.tuck': 'Cacher',
  'pet.wakeTitle': 'Réveiller le compagnon — afficher l\'overlay flottant.',
  'pet.tuckTitle': 'Cacher le compagnon — masquer l\'overlay flottant.',
  'pet.settingsTitle': 'Ouvrir les paramètres du compagnon',
  'pet.useCustom': 'Utiliser mon compagnon',
  'pet.customTitle': 'Créez le vôtre',
  'pet.customHint': 'Choisissez un nom, un glyphe et une couleur d\'accent — l\'overlay se met à jour en direct.',
  'pet.customGreetingPlaceholder': 'Faites dire bonjour à votre compagnon…',
  'pet.fieldName': 'Nom',
  'pet.fieldGlyph': 'Glyphe',
  'pet.fieldGlyphHint': 'Un seul emoji fonctionne le mieux (ex. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Salutation',
  'pet.fieldAccent': 'Couleur d\'accent',
  'pet.fieldAccentCustom': 'Couleur personnalisée',
  'pet.fieldAccentDefault': 'Couleur d\'accent par défaut',
  'pet.overlayAria': 'Compagnon',
  'pet.spriteAria': '{name} — glisser pour déplacer, cliquer pour chatter',
  'pet.spriteTitle': 'Salut de {name} ! Cliquez pour chatter.',
  'pet.taskSummarySingle': '{count} tâche agent est en cours.',
  'pet.taskSummaryMultiple': '{count} tâches agent sont en cours sur {projects} projets.',
  'pet.taskSummaryRecentSingle': '{count} tâche agent s’est terminée récemment.',
  'pet.taskSummaryRecentMultiple': '{count} tâches agent se sont terminées récemment.',
  'pet.taskListAria': 'Tâches agent actives',
  'pet.taskOpenProject': 'Ouvrir {project}',
  'pet.taskGroup.running': 'En cours',
  'pet.taskGroup.queued': 'En attente',
  'pet.taskGroup.recent': 'Terminées récemment',
  'pet.idleQuote.leonardo.text': 'Apprendre ne fatigue jamais l’esprit.',
  'pet.idleQuote.leonardo.author': 'Léonard de Vinci',
  'pet.idleQuote.michelangelo.text': 'J’ai vu l’ange dans le marbre et j’ai taillé jusqu’à le libérer.',
  'pet.idleQuote.michelangelo.author': 'Michel-Ange',
  'pet.idleQuote.bernini.text': 'Deux choses peuvent aider le sculpteur : la lumière et l’ombre.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Quand on peint, on ne pense pas.',
  'pet.idleQuote.raphael.author': 'Raphaël',
  'pet.idleQuote.caravaggio.text': 'Toutes les œuvres, peu importe quoi ou par qui elles sont peintes, ne sont que bagatelles et enfantillages si elles ne sont pas faites et peintes d’après nature.',
  'pet.idleQuote.caravaggio.author': 'Le Caravage',
  'pet.idleQuote.rodin.text': 'L’essentiel est d’être ému, d’aimer, d’espérer, de trembler, de vivre.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Compagnons — réveiller, cacher ou choisir',
  'pet.composerMenuTitle': 'Compagnons',
  'pet.composerMenuHint': 'astuce : tapez /pet pour basculer',
  'pet.composerOpenSettings': 'Gérer les animaux',
  'pet.welcomeTeaserTitle': 'Adoptez un compagnon',
  'pet.welcomeTeaserBody': 'Un petit compagnon flottant qui traîne avec vous.',
  'pet.welcomeTeaserCta': 'En choisir un',
  'pet.imageUpload': 'Téléverser un sprite',
  'pet.imageReplace': 'Remplacer le sprite',
  'pet.imageRemove': 'Utiliser un emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF ou SVG. Téléversement de planche ? Déposez une bande horizontale et indiquez le nombre d’images.',
  'pet.imageHintActive': 'Affichage de votre sprite. Indiquez plus d’une image pour animer une planche de sprites horizontale.',
  'pet.fieldFrames': 'Images',
  'pet.fieldFramesHint': '1 = statique. Plus de 1 = planche de sprites horizontale.',
  'pet.fieldFps': 'Vitesse (fps)',
  'pet.fieldFpsHint': 'Vitesse de défilement des images.',
  'pet.atlasImport': 'Importer un sprite Codex',
  'pet.atlasImportTitle': 'Importer un atlas de pet 8×9 / 192×208 (PNG ou WebP).',
  'pet.atlasPickerTitle': 'Choisir une rangée d\'animation',
  'pet.atlasPickerHint': 'Les pets Codex sont livrés avec 9 rangées d\'animation. Par défaut, nous gardons l\'atlas complet pour que le pet change de rangée au survol, au glisser et à l\'inactivité. Vous pouvez aussi le figer sur une seule boucle.',
  'pet.atlasCancel': 'Abandonner l\'atlas',
  'pet.atlasAdopt': 'Figer sur cette rangée',
  'pet.atlasAdoptFull': 'Utiliser l\'atlas complet (animé)',
  'pet.atlasAdoptFullTitle': 'Garder chaque rangée pour que le pet réagisse au survol, à la direction du glisser et aux longues inactivités.',
  'pet.atlasAdoptRowTitle': 'Découper uniquement la rangée sélectionnée en une seule bande en boucle.',
  'pet.atlasActiveHint': 'Atlas animé actif — le pet choisit une rangée selon votre interaction (survol, glisser, inactivité).',
  'pet.atlasRow.idle': 'Inactif',
  'pet.atlasRow.running-right': 'Court à droite',
  'pet.atlasRow.running-left': 'Court à gauche',
  'pet.atlasRow.waving': 'Salut',
  'pet.atlasRow.jumping': 'Saut',
  'pet.atlasRow.failed': 'Échec',
  'pet.atlasRow.waiting': 'Attente',
  'pet.atlasRow.running': 'Course',
  'pet.atlasRow.review': 'Révision',
  'pet.hatchTitle': 'Faire éclore un nouveau compagnon avec l\'IA',
  'pet.hatchHint': 'Utilisez le Skill hatch-pet intégré dans le chat pour générer une planche de sprites style Codex, puis importez-la ici.',
  'pet.hatchConcept': 'Concept du compagnon (optionnel)',
  'pet.hatchConceptPlaceholder': 'ex. un petit shiba pixel art dans un pull douillet',
  'pet.hatchCopy': 'Copier le prompt',
  'pet.hatchCopied': 'Copié !',
  'pet.hatchFoot': 'Une fois que le Skill a enregistré votre compagnon, revenez et choisissez « Importer un sprite Codex ».',
  'pet.slashPopoverAria': 'Commandes slash',
  'pet.slashPopoverTitle': 'Commandes',
  'pet.slashPopoverHint': '↑↓ naviguer · entrée pour choisir · échap pour fermer',
  'pet.slashPet': 'Basculer, adopter ou aller aux paramètres du compagnon.',
  'pet.slashPetWake': 'Réveiller l\'overlay flottant du compagnon.',
  'pet.slashPetTuck': 'Cacher le compagnon pour l\'instant.',
  'pet.slashHatch': 'Générer un pet Codex via le Skill hatch-pet.',
  'pet.slashHatchArg': '<concept>',
  'pet.slashSearch': 'Rechercher sur le web via la commande OD research.',
  'pet.slashSearchArg': '<requête>',
  'pet.codexTitle': 'Éclos récemment',
  'pet.codexSubtitle': 'Les pets empaquetés par le Skill hatch-pet apparaissent ici pour une adoption en un clic.',
  'pet.codexSubtitleWithDir': 'Analyse de {dir} pour les pets empaquetés par le Skill hatch-pet.',
  'pet.codexEmpty': 'Aucun pet éclos pour l\'instant. Tapez /hatch dans le chat pour en générer un.',
  'pet.codexLoading': 'Recherche de pets éclos…',
  'pet.codexRefresh': 'Actualiser',
  'pet.codexAdopt': 'Adopter',
  'pet.codexAdopting': 'Adoption…',
  'pet.communitySync': 'Télécharger les pets de la communauté',
  'pet.communitySyncing': 'Téléchargement…',
  'pet.communitySyncTitle': 'Synchroniser les derniers pets de Codex Pet Share + j20 Hatchery dans ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} nouveaux pets synchronisés ({total} au total).',
  'pet.communitySyncFailed': 'Échec de la synchronisation : {error}',
  'pet.codexBundled': 'Fourni',
  'pet.codexBundledTitle': 'Livré avec Open Design — aucun téléchargement nécessaire.',
  'settings.systemPrefsTitle': 'Préférences système',
  'settings.systemPrefsHint': 'Son de fin, notifications du navigateur et alertes d’état des tâches.',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Son et notification bureau à la fin d\'une tâche',
  'settings.notifyCompletionSound': 'Son de fin',
  'settings.notifyCompletionSoundHint': 'Joué quand un tour se termine. Désactivé par défaut.',
  'settings.notifySuccessSound': 'Son de succès',
  'settings.notifyFailureSound': 'Son d\'échec',
  'settings.notifyDesktop': 'Notification bureau',
  'settings.notifyDesktopHint': 'Envoyée lorsque la fenêtre n\'est pas active.',
  'settings.notifyDesktopBlocked': 'Notifications bloquées par le navigateur. Autorisez-les dans les paramètres du site.',
  'settings.notifyDesktopUnsupported': 'Notifications bureau indisponibles dans cet environnement.',
  'settings.notifyTest': 'Envoyer un test',
  'settings.notifyTestSent': 'Notification de test envoyée. Si aucune bannière n\'apparaît, vérifiez les paramètres de notification du navigateur et du système.',
  'settings.notifyTestFailed': 'L\'appel de notification a échoué. Vérifiez les paramètres de notification du navigateur et du système.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Carillon',
  'settings.notifySoundTwoToneUp': 'Bitonale montante',
  'settings.notifySoundPluck': 'Pizzicato',
  'settings.notifySoundBuzz': 'Buzzer',
  'settings.notifySoundTwoToneDown': 'Bitonale descendante',
  'settings.notifySoundThud': 'Sourd',
  'settings.skills': 'Skills',
  'settings.skillsHint': 'Skills que l’agent peut invoquer en cours de tâche',
  'settings.skillsNew': 'Nouveau Skill',
  'settings.skillsEmpty': 'Sélectionnez un Skill à gauche, ou créez-en un.',
  'settings.skillsEdit': 'Modifier',
  'settings.skillsDelete': 'Supprimer',
  'settings.skillsDeleteConfirm': 'Confirmer la suppression',
  'settings.skillsName': 'Nom',
  'settings.skillsTriggers': 'Déclencheurs (séparés par virgules ou retours à la ligne)',
  'settings.skillsDescription': 'Description',
  'settings.skillsBody': 'Corps SKILL.md',
  'settings.skillsCreate': 'Créer',
  'settings.skillsSave': 'Enregistrer',
  'settings.skillsSaving': 'Enregistrement…',
  'settings.skillsOverrideCreate': 'Créer une surcharge utilisateur',
  'settings.skillsOverrideSave': 'Enregistrer comme surcharge utilisateur',
  'settings.skillsBuiltInOverrideWarning': 'Modifier cette compétence intégrée crée une surcharge utilisateur. L\'entrée intégrée sera masquée de la liste jusqu\'à ce que vous supprimiez la surcharge. Continuer ?',
  'settings.skillsFiles': 'Fichiers',
  'settings.skillsNoFiles': 'Aucun fichier dans ce dossier de Skill.',
  'settings.skillsNameRequired': 'Le nom du Skill est requis.',
  'settings.skillsBodyRequired': 'Le contenu du Skill est requis.',
  'settings.designSystems': 'Systèmes de design',
  'settings.designSystemsHint': 'Gérez les systèmes de design affichés dans la galerie d’accueil',
  'settings.designSystemsInstalled': 'Installés',
  'settings.designSystemsAdd': 'Ajouter un système de design',
  'settings.designSystemsHiddenCount': '{count} masqués dans la galerie d’accueil',
  'settings.designSystemsShowAll': 'Tout afficher',
  'settings.designSystemsShowHidden': 'Afficher les masqués',
  'settings.designSystemsSource': 'Origine',
  'settings.designSystemsSourceLocal': 'Locale',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'Référence du registre shadcn',
  'settings.designSystemsImportShadcn': 'Importer depuis shadcn',
  'settings.designSystemsStructure': 'Organisation',
  'settings.designSystemsModeHybrid': 'Hybride',
  'settings.designSystemsModeNormalized': 'Normalisé',
  'settings.designSystemsModeVerbatim': 'Tel quel',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Couleur',
  'settings.designSystemsCraftAccessibility': 'Accessibilité',
  'settings.designSystemsGithubUrl': 'URL GitHub',
  'settings.designSystemsProjectPath': 'Chemin du projet',
  'settings.designSystemsImportGithub': 'Importer depuis GitHub',
  'settings.designSystemsImportProject': 'Importer depuis le projet',
  'settings.designSystemsImportedStatus': '{title} importé',
  'settings.designSystemsViewImported': 'Voir le système de design importé',
  'settings.designSystemsCategory': 'Catégorie',
  'settings.designSystemsAllCategories': 'Toutes les catégories',
  'settings.designSystemsShowInHomeGallery': 'Afficher dans la galerie d’accueil',
  'settings.projectLocations': 'Emplacements de projets',
  'settings.projectLocationsHint': 'Racines de stockage des workspaces',
  'settings.projectLocationsDescription': 'Ajoutez des bases de travail pouvant contenir plusieurs dossiers de projets Open Design. Les nouveaux projets sont enregistrés comme un dossier dans la base sélectionnée.',
  'settings.projectLocationsSaveError': 'Impossible d’enregistrer les emplacements de projets. Vérifiez que chaque chemin est un dossier accessible.',
  'settings.projectLocationsSaved': 'Emplacements de projets enregistrés.',
  'settings.projectLocationsScanError': 'Impossible d’analyser les emplacements de projets.',
  'settings.projectLocationsScanComplete': 'Analyse terminée : {imported} importé(s), {existing} déjà enregistré(s).',
  'settings.projectLocationsNoFolderSelected': 'Aucun dossier sélectionné.',
  'settings.projectLocationsDuplicate': 'Cette base de travail est déjà ajoutée.',
  'settings.projectLocationsWorkBaseMeta': 'Base de travail · les projets sont créés ici comme sous-dossiers',
  'settings.projectLocationsAddFolder': 'Ajouter un dossier…',
  'settings.projectLocationsDefaultBadge': 'Emplacement par défaut',
  'settings.projectLocationsMakeDefault': 'Définir par défaut',
  'settings.projectLocationsDefaultSaved': 'Emplacement de projet par défaut mis à jour.',
  'settings.librarySkills': 'Skills',
  'settings.libraryDesignSystems': 'Systèmes de design',
  'settings.librarySearch': 'Rechercher...',
  'settings.libraryAll': 'Tout',
  'settings.libraryPreview': 'Aperçu',
  'settings.libraryPreviewClose': 'Fermer',
  'settings.libraryLoading': 'Chargement...',
  'settings.libraryNoResults': 'Aucun élément ne correspond à votre recherche.',
  'settings.libraryEnabled': 'Activé',
  'settings.libraryDisabled': 'Désactivé',
  'settings.connectorsNavHint': 'Connexions aux systèmes externes',
  'settings.connectorsHint': 'Gérez les paramètres des connecteurs et fournisseurs d’outils pour cet appareil.',
  'settings.connectorsComposioApiKey': 'Clé API Composio',
  'settings.connectorsSavedTitle': 'Enregistrée dans le daemon local',
  'settings.connectorsSavedWithTail': 'Enregistrée · ••••{tail}',
  'settings.connectorsSaved': 'Enregistrée',
  'settings.connectorsGetApiKey': 'Obtenir une clé API',
  'settings.connectorsReplaceKeyPlaceholder': 'Collez une nouvelle clé pour remplacer celle enregistrée',
  'settings.connectorsApiKeyPlaceholder': 'Collez la clé API Composio',
  'settings.connectorsClear': 'Effacer',
  'settings.connectorsClearConfirmTitle': 'Effacer la clé API Composio enregistrée ?',
  'settings.connectorsClearConfirmBody': 'Supprimer la clé déconnecte tous les connecteurs Composio liés à ce workspace. Les comptes connectés, les autorisations OAuth et les accès aux outils seront tous supprimés.',
  'settings.connectorsClearConfirmContinue': 'Continuer',
  'settings.connectorsClearFinalTitle': 'Cette action déconnectera tous les connecteurs',
  'settings.connectorsClearFinalBody': 'Action irréversible. Vous devrez reconnecter chaque intégration depuis le début après avoir collé une nouvelle clé.',
  'settings.connectorsClearFinalConfirm': 'Supprimer la clé et déconnecter',
  'settings.connectorsClearArming': 'Un instant…',
  'settings.connectorsClearCancel': 'Annuler',
  'settings.connectorsSaveKey': 'Enregistrer la clé',
  'settings.connectorsSaveKeyTitle': 'Envoyer cette clé au daemon local',
  'settings.connectorsKeySaving': 'Enregistrement…',
  'settings.connectorsKeySaved': 'Enregistré ✓',
  'settings.connectorsKeyError': 'Impossible d’enregistrer la clé. Vérifiez que le daemon local est lancé, puis réessayez.',
  'settings.connectorsHelpSaved': 'Votre clé déverrouille le catalogue ci-dessous et reste dans le daemon local. Collez une nouvelle clé pour la remplacer ou effacez-la.',
  'settings.connectorsHelpUnsaved': 'Modifications non enregistrées — cliquez sur Enregistrer la clé pour stocker cette information dans le daemon local et débloquer le catalogue ci-dessous.',
  'settings.connectorsHelpEmpty': 'Les clés sont stockées localement et ne sont jamais partagées.',
  'settings.connectorsLoadingSavedKey': 'Recherche d’une clé enregistrée dans le daemon local…',
  'settings.autosaveSaving': 'Enregistrement…',
  'settings.autosaveSaved': 'Toutes les modifications enregistrées',
  'settings.autosaveError': 'Impossible d’enregistrer les modifications. Le daemon local est peut-être hors ligne.',
  'settings.libraryToggleLabel': 'Activer ou désactiver',
  'settings.memory': 'Mémoire',
  'settings.memoryHint': 'Faits personnels extraits automatiquement des conversations',
  'settings.customInstructionsTitle': 'Instructions personnalisées',
  'settings.customInstructionsHint': 'Instructions persistantes appliquées à chaque projet. Utilisez-les pour définir les préférences que le modèle doit toujours suivre.',
  'settings.customInstructionsPlaceholder': 'ex. "Utilise toujours TypeScript. Préfère les composants fonctionnels. Réponds de façon concise."',
  'settings.memoryDescription': 'Faits sur vos préférences extraits automatiquement, sauvegardés en Markdown et réinjectés dans chaque chat.',
  'settings.memoryEnabled': 'Activée',
  'settings.memoryDisabled': 'Désactivée',
  'settings.memoryEnableLabel': 'Activer l\'injection de mémoire',
  'settings.memoryDisabledBanner': 'La mémoire est actuellement désactivée. Les faits existants restent sur le disque, mais ne seront pas injectés dans les nouveaux chats, et les nouveaux tours n’extrairont rien de nouveau.',
  'settings.memoryNew': 'Nouvelle mémoire',
  'settings.memoryEdit': 'Modifier',
  'settings.memoryDelete': 'Supprimer',
  'settings.memoryPreview': 'Aperçu',
  'settings.memoryEmpty': 'Aucune mémoire pour l\'instant.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Je préfère le mode sombre',
  'settings.memoryName': 'Nom',
  'settings.memoryDesc': 'Description en une ligne',
  'settings.memoryBody': 'Corps (Markdown pris en charge)',
  'settings.memoryBodyHint': 'Listez d’abord les règles avec des puces, puis ajoutez éventuellement des lignes « Pourquoi » et « Quand l’appliquer ». Markdown pris en charge. Vous pouvez aussi cliquer sur un exemple ci-dessus pour le charger.',
  'settings.memoryStartersLabel': 'Besoin d’un point de départ ? Cliquez pour remplir le formulaire :',
  'settings.memoryStarterUserName': 'Mon rôle',
  'settings.memoryStarterUserDesc': 'Je suis ingénieur frontend sur un outil de design SaaS',
  'settings.memoryStarterUserBody': '- Rôle : ingénieur frontend senior\n- Stack : React, TypeScript, Vite\n- Domaine : design / outils collaboratifs\n- Fuseau horaire : GMT+8 (Asie/Shanghai)\n\nQuand l’appliquer : tout chat — cadrer les exemples autour du frontend web.',
  'settings.memoryStarterFeedbackName': 'Préférences UI',
  'settings.memoryStarterFeedbackDesc': 'Mode sombre, grand corps de texte, faible densité d’information',
  'settings.memoryStarterFeedbackBody': '- Thème : sombre par défaut\n- Corps de texte : ≥ 18 px\n- Densité d’information : privilégier l’espace, moins d’éléments par écran\n\nPourquoi : moins de fatigue visuelle pendant les longues sessions.\nQuand l’appliquer : lorsque vous générez des UI, pages web ou slides.',
  'settings.memoryStarterProjectName': 'Projet actuel',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — éditeur de design piloté par chat',
  'settings.memoryStarterProjectBody': '- Objectif : livrer l’éditeur piloté par chat ce trimestre\n- Priorités : rendu en streaming, multimodal local, offline-first\n- Stack : Next.js 16, daemon Express, SQLite\n\nQuand l’appliquer : dans toute conversation à propos de ce projet.',
  'settings.memorySaveHint': 'Non enregistré automatiquement — cliquez sur Créer / Enregistrer pour appliquer.',
  'settings.memoryIndexSaveHint': 'Les modifications de l’index ne sont pas enregistrées automatiquement — cliquez sur Enregistrer l’index pour appliquer.',
  'settings.memoryIndexUnsaved': 'Modifications non enregistrées',
  'settings.memoryFlashCreated': '✓ Mémoire créée',
  'settings.memoryFlashSaved': '✓ Mémoire enregistrée',
  'settings.memoryFlashDeleted': '✓ Mémoire supprimée',
  'settings.memoryFlashIndexSaved': '✓ Index enregistré',
  'settings.memoryFlashPathCopied': '✓ Chemin copié',
  'settings.memoryNameLabel': 'Titre',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Contenu',
  'settings.memoryTypeUser': 'Utilisateur',
  'settings.memoryTypeFeedback': 'Retour',
  'settings.memoryTypeProject': 'Projet',
  'settings.memoryTypeReference': 'Référence',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Règle',
  'settings.memoryTabMemories': 'Souvenirs',
  'settings.memoryTabMemoriesCaption': 'Consulter et gérer la mémoire enregistrée',
  'settings.memoryTabHow': 'Comment ça marche',
  'settings.memoryTabHowCaption': 'Les deux boucles et leurs commandes',
  'settings.memoryAddDisclosure': 'Ajouter ou importer des souvenirs',
  'settings.memoryAddDisclosureHint': 'Profil, saisie manuelle ou apps connectées',
  'settings.memoryProfileTab': 'Profil de travail',
  'settings.memoryProfileTabCaption': 'Qui vous êtes et vos préférences par défaut',
  'settings.memoryProfileTitle': 'Votre profil de travail',
  'settings.memoryProfileHint':
    'Quelques informations sur vous et vos préférences par défaut. La mémoire les injecte avant chaque tâche pour que l’agent comprenne ce que vous voulez à partir d’une demande courte.',
  'settings.memoryProfileName': 'Profil de travail',
  'settings.memoryProfileDescription':
    'Rôle, entreprise, domaine, audience, goûts et préférences par défaut que l’assistant doit réutiliser.',
  'settings.memoryProfileSave': 'Enregistrer le profil',
  'settings.memoryProfileSaving': 'Enregistrement…',
  'settings.memoryProfileSaved': 'Profil enregistré',
  'settings.memoryProfileRole': 'Rôle',
  'settings.memoryProfileRolePlaceholder': 'p. ex. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Entreprise / Équipe',
  'settings.memoryProfileCompanyPlaceholder': 'p. ex. Acme, growth team',
  'settings.memoryProfileDomain': 'Domaine',
  'settings.memoryProfileDomainPlaceholder': 'p. ex. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Audience principale',
  'settings.memoryProfileAudiencePlaceholder': 'p. ex. dirigeants, ingénieurs, utilisateurs finaux',
  'settings.memoryProfileAesthetic': 'Esthétique / goûts',
  'settings.memoryProfileAestheticPlaceholder':
    'p. ex. épuré et éditorial, fonds clairs, espaces blancs généreux',
  'settings.memoryProfileDeliverables': 'Livrables par défaut',
  'settings.memoryProfileDeliverablesPlaceholder': 'p. ex. landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Région / Langue',
  'settings.memoryProfileLocalePlaceholder': 'p. ex. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Objectifs actuels',
  'settings.memoryProfileGoalsPlaceholder':
    'p. ex. publier la nouvelle page de tarifs, augmenter la conversion du parcours d’essai',
  'settings.memoryHooksTitle': 'Hooks de mémoire',
  'settings.memoryHooksHint':
    'Choisissez quelles parties de la mémoire s’exécutent automatiquement. L’interrupteur principal ci-dessus les désactive toutes.',
  'settings.memoryHooksProfileLabel': 'Utiliser mon profil',
  'settings.memoryHooksProfileDesc': 'Injecter votre profil de travail dans chaque tâche.',
  'settings.memoryHooksRewriteLabel': 'Reformuler les demandes courtes',
  'settings.memoryHooksRewriteDesc': 'PRE : transformer une demande courte en un brief de tâche complet.',
  'settings.memoryHooksVerifyLabel': 'Auto-vérifier le résultat',
  'settings.memoryHooksVerifyDesc': 'POST : vérifier le résultat par rapport à vos règles, puis afficher un tableau de bord.',
  'settings.memoryHooksExtractionLabel': 'Apprendre des conversations',
  'settings.memoryHooksExtractionDesc': 'Capturer les faits et préférences utiles à partir des tours de chat.',
  'artifact.odCardTaskBriefChip': 'Mémoire appliquée · voir le brief',
  'artifact.odCardScorecardTitle': 'Auto-vérification',
  'artifact.odCardScorecardStatusPass': 'Réussi',
  'artifact.odCardScorecardStatusPartial': 'Partiel',
  'artifact.odCardScorecardStatusFail': 'À retravailler',
  'artifact.odCardRuleKicker': 'Règle proposée',
  'artifact.odCardRuleNameLabel': 'Nom',
  'artifact.odCardRuleDescriptionLabel': 'Description',
  'artifact.odCardRuleAssertionLabel': 'Doit être vrai',
  'artifact.odCardRuleCheckLabel': 'Comment vérifier',
  'artifact.odCardRuleRationaleLabel': 'Pourquoi',
  'artifact.odCardRuleKeep': 'Conserver',
  'artifact.odCardRuleEdit': 'Modifier',
  'artifact.odCardRuleDone': 'Terminé',
  'artifact.odCardRuleDiscard': 'Abandonner',
  'artifact.odCardRuleSaving': 'Enregistrement…',
  'artifact.odCardRuleSaved': 'Règle « {name} » enregistrée',
  'artifact.odCardRuleError': 'Impossible d’enregistrer la règle. Réessayez.',
  'artifact.odCardBrandAssistDone': 'Browser ouvert',
  'artifact.odCardBrandAssistKicker': 'Assistance navigateur requise : {reason}',
  'artifact.odCardBrandAssistBody': 'Ouvrez Browser et passez toute vérification humaine. Cliquez ensuite sur Plus, choisissez Télécharger la page, attendez le message de réussite de l’instantané enregistré, puis utilisez la carte Étape suivante à gauche pour continuer l’extraction. Si cette carte n’est pas visible, ouvrez manuellement l’onglet Browser à droite et suivez Plus > Télécharger la page > Continuer l’extraction.',
  'artifact.odCardBrandAssistError': 'Impossible de démarrer l’assistance navigateur. Réessayez.',
  'artifact.odCardBrandAssistWorking': 'Démarrage…',
  'artifact.odCardBrandAssistConfirm': 'Ouvrir l’assistance navigateur',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Enregistrer l\'index',
  'settings.memoryIndexReset': 'Réinitialiser',
  'settings.memoryToastChanged': 'Mémoire mise à jour',
  'settings.memoryToastClickHint': 'Afficher',
  'settings.memoryAll': 'Tout',
  'settings.memoryExtractions': 'Historique d’extraction',
  'settings.memoryExtractionsHint': 'Tentatives récentes d’extraction avec LLM. L’extraction heuristique par regex s’exécute toujours d’abord ; l’extraction LLM tourne en arrière-plan après chaque tour.',
  'settings.memoryExtractionsEmpty': 'Aucune extraction pour l’instant. Le prochain tour de chat alimentera cette liste.',
  'settings.memoryExtractionsRefresh': 'Actualiser',
  'settings.memoryExtractionsRefreshing': 'Actualisation…',
  'settings.memoryExtractionPhaseRunning': 'En cours…',
  'settings.memoryExtractionPhaseSuccess': 'Réussite',
  'settings.memoryExtractionPhaseSkipped': 'Ignorée',
  'settings.memoryExtractionPhaseFailed': 'Échec',
  'settings.memoryExtractionSkipNoProvider': 'Aucune clé API configurée pour l’extraction de mémoire LLM.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'La mémoire est désactivée.',
  'settings.memoryExtractionSkipEmpty': 'Message utilisateur vide — rien à extraire.',
  'settings.memoryExtractionSkipNoMatch': 'Aucun motif regex ne correspond à ce tour.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'réglages médias',
  'settings.memoryExtractionProviderOverride': 'réglages mémoire',
  'settings.memoryExtractionProposed': 'proposée',
  'settings.memoryExtractionWritten': 'écrite',
  'settings.memoryExtractionDuration': 'en',
  'settings.memoryExtractionDelete': 'Supprimer',
  'settings.memoryExtractionsClear': 'Effacer',
  'settings.memoryExtractionsClearTitle': 'Effacer tout l’historique d’extraction',
  'settings.memoryExtractionsClearConfirm': 'Effacer tout l’historique des extractions ? Cette action est irréversible.',
  'settings.memoryNoProviderBannerTitle': 'L’extraction de mémoire LLM ne fonctionne pas',
  'settings.memoryNoProviderBannerBody': 'Aucune clé API trouvée pour l’extracteur de mémoire. Ajoutez une clé OpenAI dans les fournisseurs de médias, ou définissez ANTHROPIC_API_KEY / OPENAI_API_KEY dans l’environnement pour activer l’extraction par LLM. L’extraction heuristique par regex reste active.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Installer',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Chemin local',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Installer',
  'settings.libraryUninstall': 'Désinstaller',
  'settings.libraryBuiltIn': 'Intégré',
  'settings.libraryInstalled': 'Installé',
  'settings.orbit.eyebrow': 'Automatisation',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Résumé quotidien des connecteurs',
  'settings.orbit.lede': 'Collecte l’activité des connecteurs selon un calendrier et publie le résultat sous forme d’artefact dynamique actualisable.',
  'settings.orbit.statusOnTitle': 'Les exécutions quotidiennes planifiées sont activées',
  'settings.orbit.statusOffTitle': 'Les exécutions quotidiennes planifiées sont désactivées',
  'settings.orbit.statusActive': 'Actif',
  'settings.orbit.statusOff': 'Désactivé',
  'settings.orbit.runTitle': 'Démarrer une exécution Orbit et ouvrir la conversation en direct',
  'settings.orbit.running': 'Exécution…',
  'settings.orbit.runOpen': 'Exécuter maintenant',
  'settings.orbit.dailySummaryTitle': 'Résumé quotidien',
  'settings.orbit.dailySummarySub': 'S’exécute une fois par jour à l’heure locale planifiée.',
  'settings.orbit.on': 'Activé',
  'settings.orbit.off': 'Désactivé',
  'settings.orbit.runTimeTitle': 'Heure d’exécution',
  'settings.orbit.runTimeSub': 'Par défaut 08:00. Enregistrez pour appliquer au planning du daemon.',
  'settings.orbit.runTimeAria': 'Heure d’exécution quotidienne de Orbit',
  'settings.orbit.nextRun': 'Prochaine exécution',
  'settings.orbit.nextRunScheduledAfterSave': 'Planifiée après enregistrement',
  'settings.orbit.schedule': 'Planning',
  'settings.orbit.pausedManualOnly': 'En pause — exécutions manuelles uniquement',
  'settings.orbit.templateTitle': 'Modèle de prompt',
  'settings.orbit.templateMissing': 'Le modèle {id} n’est pas installé.',
  'settings.orbit.templateMissingOption': '{id} (manquant)',
  'settings.orbit.templateMissingInstall': 'Installez un Skill Orbit pour guider le prompt.',
  'settings.orbit.templateMissingPickAnother': 'Choisissez un autre modèle dans la liste.',
  'settings.orbit.templateResetTitle': 'Réinitialiser sur {id}',
  'settings.orbit.templateReset': 'Réinitialiser',
  'settings.orbit.templateHelp': 'Guidez Orbit avec un Skill — le prompt d’exemple du modèle sélectionné est injecté dans chaque exécution Orbit afin que les résumés suivent cette forme.',
  'settings.orbit.templateAria': 'Modèle de prompt Orbit',
  'settings.orbit.templatesLoading': 'Chargement des modèles…',
  'settings.orbit.templatesOptgroup': 'Modèles de Skills Orbit',
  'settings.orbit.lastRun': 'Dernière exécution',
  'settings.orbit.triggerManual': 'Manuelle',
  'settings.orbit.triggerScheduled': 'Planifiée',
  'settings.orbit.meterAria': '{succeeded} réussis, {skipped} ignorés, {failed} échoués sur {checked} vérifiés',
  'settings.orbit.countChecked': 'Vérifiés',
  'settings.orbit.countSucceeded': 'Réussis',
  'settings.orbit.countSkipped': 'Ignorés',
  'settings.orbit.countFailed': 'Échoués',
  'settings.orbit.runError': 'Impossible d’exécuter Orbit. Vérifiez que le daemon local fonctionne et que les connecteurs sont configurés.',
  'settings.orbit.gateAriaLabel': 'Des connecteurs sont requis pour utiliser Orbit',
  'settings.orbit.gateEyebrow': 'Configuration requise',
  'settings.orbit.gateTitle': 'Connectez un outil pour alimenter Orbit',
  'settings.orbit.gateBody': 'Orbit résume l’activité de vos connecteurs. Vous n’avez encore rien connecté — ajoutez au moins une intégration pour qu’Orbit ait de quoi rapporter.',
  'settings.orbit.gateBodyNoKey': 'Orbit résume l’activité de vos connecteurs, et les connecteurs passent par Composio. Ajoutez une clé d’API Composio dans Connecteurs pour débloquer le catalogue et choisir votre première intégration.',
  'settings.orbit.gateAction': 'Ouvrir Connecteurs',
  'settings.orbit.gateActionNoKey': 'Configurer Composio',
  'settings.orbit.gateLoading': 'Vérification de vos connecteurs…',
  'settings.orbit.controlsLockedBadge': 'Verrouillé',
  'settings.orbit.controlsLockedHint': 'Connectez un outil pour déverrouiller la planification et le modèle d\'Orbit.',
  'settings.orbit.artifactKickerLive': 'artefact dynamique',
  'settings.orbit.artifactKickerLegacy': 'Résumé hérité',
  'settings.orbit.artifactTitle': 'Résumé quotidien de l’activité Orbit',
  'settings.orbit.artifactMetaLive': 'Artefact HTML actualisable généré à partir de l’activité des connecteurs.',
  'settings.orbit.artifactMetaLegacy': 'Généré avant l’activation de la prise en charge des artefacts dynamiques — relancez Orbit pour en publier un.',
  'settings.orbit.copyMarkdownTitle': 'Copier le résumé Markdown dans le presse-papiers',
  'settings.orbit.copied': 'Copié',
  'settings.orbit.copy': 'Copier',
  'settings.orbit.openArtifact': 'Ouvrir l’artefact',
  'settings.orbit.sourceMarkdown': 'Source Markdown',
  'notify.successTitle': 'Tâche terminée',
  'notify.failureTitle': 'Tâche échouée',
  'notify.successBody': 'Un tour est terminé.',
  'notify.failureBody': 'La tâche s\'est terminée avec une erreur.',
  'updater.available': 'Mise à jour disponible',
  'updater.activeRunsTitle': 'Open Design travaille encore',
  'updater.activeRunsBody': '{count} tâches actives sont toujours en cours. Redémarrer maintenant les interrompra.',
  'updater.activeRunsUnknownBody': 'Open Design n’a pas pu vérifier si des tâches sont en cours. Redémarrer maintenant pourrait interrompre un travail actif.',
  'updater.availableBody': 'Open Design {version} est disponible. Elle sera téléchargée avant l’ouverture du programme d’installation.',
  'updater.checking': 'Recherche de mises à jour',
  'updater.download': 'Télécharger la mise à jour',
  'updater.downloading': 'Téléchargement de la mise à jour',
  'updater.downloadingPercent': 'Téléchargement de la mise à jour {percent}%',
  'updater.done': 'Terminé',
  'updater.failed': 'Échec de la mise à jour',
  'updater.installerOpenBody': 'Le programme d’installation est ouvert. Open Design est en train de quitter pour vous permettre de terminer la mise à jour.',
  'updater.installerOpened': 'Programme d’installation ouvert',
  'updater.later': 'Plus tard',
  "updater.allowSilentUpdates": "Autoriser l’installation auto des futures mises à jour in-app",
  'updater.openFailedFallback': 'Impossible d’ouvrir le programme d’installation.',
  'updater.installRestart': 'Installer et redémarrer',
  'updater.installingRestart': 'Installation et redémarrage...',
  'updater.openInstaller': 'Installer la mise à jour',
  'updater.opening': 'Ouverture du programme d’installation...',
  'updater.dialogAvailableGeneric': 'Une nouvelle version est disponible.\nTéléchargez-la pour installer la mise à jour.',
  'updater.dialogAvailableVersion': 'La v{version} est disponible.\nTéléchargez-la pour installer la mise à jour.',
  'updater.dialogCheckFailed': 'Impossible de rechercher les mises à jour.\nRéessayez dans quelques instants.',
  'updater.dialogReadyGeneric': 'Une nouvelle version est prête.\nMeilleure expérience, design plus intelligent.',
  'updater.dialogReadyVersion': 'v{version} est prête.\nMeilleure expérience, design plus intelligent.',
  'updater.dialogUnsupported': 'Mise à jour intégrée indisponible.\nTéléchargez la dernière version manuellement.',
  'updater.payloadReadyGeneric': 'Une nouvelle mise à jour d’Open Design est prête. Open Design va se fermer puis redémarrer automatiquement.',
  'updater.payloadReadyVersion': 'Open Design {version} est prêt. Open Design va se fermer puis redémarrer automatiquement.',
  'updater.quitButton': 'Quitter Open Design',
  'updater.quitFailedBody': 'Le programme d’installation est ouvert, mais Open Design n’a pas pu quitter. Quittez Open Design avant de remplacer l’application.',
  'updater.quitFailedTitle': 'Impossible de quitter',
  'updater.quitting': 'Fermeture...',
  'updater.ready': 'Mise à jour prête',
  'updater.readyGeneric': 'Une nouvelle version est prête. Open Design va se fermer et ouvrir le programme d’installation.',
  'updater.readyVersion': 'Open Design {version} est prêt. Open Design va se fermer et ouvrir le programme d’installation.',
  'updater.reinstallLearnMore': 'En savoir plus',
  'updater.reinstallReadyGeneric': 'Cette mise à jour nécessite une réinstallation complète. Open Design va se fermer et ouvrir l\'installateur.',
  'updater.reinstallReadyVersion': 'Open Design {version} nécessite une réinstallation complète. Open Design va se fermer et ouvrir l\'installateur.',
  'updater.restartAnyway': 'Redémarrer quand même',
  'updater.upToDate': 'Vous utilisez déjà la dernière version.',
  'updater.viewVersionFeatures': 'Découvrir les nouveautés',
  'updater.manualDownload': 'Télécharger manuellement',
  'whatsNew.updatedTitle': 'Open Design {version} est arrivé',
  'whatsNew.cta': 'Voir les notes de version',
  'newsletter.label': 'Newsletter (facultatif)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Modèle de mémoire',
  'settings.memoryModelInlineSameAsChat': 'Identique au chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Identique au chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Identique au chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Facultatif. Utilise la CLI locale sélectionnée quand elle est prise en charge ; choisissez un modèle seulement pour remplacer la valeur par défaut.',
  'settings.memoryModelInlineHintCliConstrained': 'Facultatif. Utilise la CLI locale sélectionnée quand elle est prise en charge ; {provider} n’est que la famille de fournisseur de secours.',
  'settings.memoryModelInlineHintByok': 'Facultatif. Réutilise votre clé API de chat sur le même fournisseur — choisir un autre modèle (souvent moins cher) ne change que le corps de la requête.',
  'settings.memoryModelInlineHintByokNeutral': 'La mémoire utilise un modèle séparé du chat. Par défaut, elle reprend votre modèle de chat.',
  'settings.memoryModelInlineFlashSaved': 'Enregistré',
  'settings.memoryModelInlineFlashCleared': 'Effacé',
  'diagnostics.exportTitle': 'Exporter le diagnostic',
  'diagnostics.exportButton': 'Exporter le diagnostic',
  'diagnostics.exportHint': 'Compresse les journaux récents et les informations machine dans un zip à partager avec l\'équipe.',
  'diagnostics.exporting': 'Exportation…',
  'diagnostics.exportSuccess': 'Diagnostic enregistré dans {path}',
  'diagnostics.exportFailed': 'Impossible d\'exporter le diagnostic: {message}',
  'automations.eyebrow': 'Sessions d\'agent planifiées',
  'automations.title': 'Automatisations',
  'automations.lede': 'Planifiez des conversations récurrentes pour le travail de projet, les digests Orbit et les artefacts en direct.',
  'automations.summaryAria': 'Résumé des automatisations',
  'automations.metricActive': 'Actives',
  'automations.metricPaused': 'En pause',
  'automations.metricTemplates': 'Modèles',
  'automations.newAutomation': 'Nouvelle automatisation',
  'automations.yourAutomations': 'Vos automatisations',
  'automations.loading': 'Chargement',
  'automations.emptyTitle': 'Aucune automatisation pour l\'instant',
  'automations.emptyBody': 'Créez-en une à partir d\'un modèle ou commencez avec une planification vierge.',
  'automations.targetNewEachRun': 'Nouveau projet à chaque exécution',
  'automations.targetCreateEachRun': 'Nouveau projet à chaque exécution',
  'automations.lastRun': 'Dernière exécution {time}',
  'automations.openResult': 'Ouvrir le résultat',
  'automations.run': 'Exécuter',
  'automations.runNowTitle': 'Exécuter maintenant et ouvrir la conversation',
  'automations.history': 'Historique',
  'automations.hideHistory': 'Masquer l\'historique',
  'automations.edit': 'Modifier',
  'automations.pause': 'Mettre en pause',
  'automations.resume': 'Reprendre',
  'automations.deleteAria': 'Supprimer l\'automatisation',
  'automations.deleteTitle': 'Supprimer cette automatisation',
  'automations.deleteConfirm': 'Supprimer cette automatisation ? Les exécutions passées et leurs projets sont conservés.',
  'automations.proposalsTitle': 'Propositions d\'évolution',
  'automations.proposalsSub': 'Examinez la sortie de l\'automatisation avant qu\'elle ne modifie la mémoire, les Skills ou les systèmes de design.',
  'automations.proposalsPending': '{n} en attente',
  'automations.apply': 'Appliquer',
  'automations.reject': 'Rejeter',
  'automations.proposalsDismissReason': 'Ignorée dans Automatisations',
  'automations.templatesTitle': 'Modèles',
  'automations.templatesSub': 'Orbit et les artefacts en direct sont des modèles au sein du même flux d\'automatisation.',
  'automations.templatesCount': '{filtered} sur {total}',
  'automations.templateFiltersAria': 'Filtres de modèles',
  'automations.templatesEmptyTitle': 'Aucun modèle dans cette catégorie pour l\'instant.',
  'automations.templatesEmptyBody': 'Essayez un autre filtre, ou partez d\'une automatisation vierge.',
  'automations.useTemplate': 'Utiliser le modèle',
  'automations.runHistoryLoading': 'Chargement de l\'historique d\'exécution...',
  'automations.runHistoryEmpty': 'Aucune exécution pour l\'instant.',
  'automations.runHistoryTitle': 'Historique d\'exécution',
  'automations.runHistoryLatest': '10 dernières',
  'automations.crystallize': 'Cristalliser',
  'automations.crystallizing': 'Cristallisation',
  'automations.crystallizeTitle': 'Rédiger des propositions de Skills et de mémoire à partir de cette exécution',
  'automations.crystallizeFailed': 'Échec de la cristallisation : {error}',
  'automations.crystallizePartialSuccess': 'La cristallisation a créé des propositions, mais Automatisations n’a pas pu actualiser la liste. Consultez les propositions visibles ou essayez d’actualiser.',
  'automations.crystallizeRefreshFailed': 'La cristallisation est terminée, mais Automatisations n’a pas pu actualiser les propositions. Essayez d’actualiser avant de la relancer.',
  'automations.crystallizeNoProposals': 'La cristallisation est terminée, mais aucune proposition n’a été renvoyée. Essayez d’actualiser ou consultez les détails de l’exécution.',
  'automations.openConversation': 'Ouvrir la conversation',
  'automations.runHistoryAria': 'Historique d\'exécution de l\'automatisation',
  'automations.proposalsAria': 'Propositions d\'évolution de l\'automatisation',
  'automations.templatesAria': 'Modèles d\'automatisation',
  'automations.runInProgress': 'En cours',
  'automations.promptPlaceholder': 'Récupère l’activité GitHub + Linear d’hier et résume ce qui a changé.',
  'automations.scheduleStatusPaused': 'En pause',
  'automations.nextRunManualOnly': 'Manuel uniquement',
  'automations.nextRunScheduled': 'Planifiée',
  'automations.nextRunAt': 'Prochaine {time}',
  'automations.statusSucceeded': 'Réussie',
  'automations.statusFailed': 'Échouée',
  'automations.statusRunning': 'En cours',
  'automations.statusQueued': 'En file d\'attente',
  'automations.statusCanceled': 'Annulée',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Artefact en direct',
  'automations.kindAutomation': 'Automatisation',
  'automations.proposalTargetMemory': 'Mémoire',
  'automations.proposalTargetDesignSystem': 'Système de design',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Modèle d\'automatisation',
  'automations.proposalActionCreate': 'Créer',
  'automations.proposalActionUpdate': 'Mettre à jour',
  'automations.proposalActionMerge': 'Fusionner',
  'automations.proposalActionMove': 'Déplacer',
  'automations.proposalActionDelete': 'Supprimer',
  'automations.proposalActionPromote': 'Promouvoir',
  'automations.filterAll': 'Tous',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Artefacts en direct',
  'automations.filterMemory': 'Mémoire',
  'automations.filterDesignSystems': 'Systèmes de design',
  'automations.filterSkills': 'Skills',
  'automations.filterConnectors': 'Connecteurs',
  'automations.filterCompression': 'Compression',
  'automations.filterRelease': 'Version',
  'automations.filterQuality': 'Qualité',
  'automations.tpl.memoryRefresh.title': 'Actualiser la mémoire du projet à partir des travaux récents.',
  'automations.tpl.memoryRefresh.desc': 'Transforme les décisions, préférences et retours répétés en mises à jour de mémoire réutilisables.',
  'automations.tpl.designSystemRefresh.title': 'Mettre à jour les systèmes de design à partir des artefacts livrés.',
  'automations.tpl.designSystemRefresh.desc': 'Trouve les tokens, composants et règles réutilisables dans les travaux de design récents.',
  'automations.tpl.liveArtifactRegistry.title': 'Auditer les artefacts en direct et actualiser les versions obsolètes.',
  'automations.tpl.liveArtifactRegistry.desc': 'Maintient à jour les tableaux de bord, rapports et aperçus persistants au lieu de les dupliquer.',
  'automations.tpl.orbitDashboard.title': 'Créer un tableau de bord d\'activité des connecteurs.',
  'automations.tpl.orbitDashboard.desc': 'Agrège les connecteurs sélectionnés dans un tableau de bord en direct de style Orbit.',
  'automations.tpl.releaseNotes.title': 'Rédiger des notes de version à partir des travaux de design livrés.',
  'automations.tpl.releaseNotes.desc': 'Relie les PR fusionnées, les artefacts et les changements visibles par le produit dans des notes de version.',
  'automations.tpl.qualityRegressionWatch.title': 'Surveiller les régressions de design et d\'implémentation.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compare les changements récents aux benchmarks, traces et références acceptées.',
  'automations.tpl.orbitDaily.title': 'Digest quotidien des connecteurs.',
  'automations.tpl.orbitDaily.desc': 'Actualise un digest d\'activité des connecteurs selon une planification.',
  'automations.tpl.liveStatusBoard.title': 'Garder un artefact de statut en direct à jour.',
  'automations.tpl.liveStatusBoard.desc': 'Met à jour un artefact persistant unique au lieu de créer un nouveau rapport à chaque exécution.',
  'dsManager.areaAria': 'Zone des systèmes de design',
  'dsManager.tabDesignSystem': 'Système de design',
  'dsManager.tabTemplate': 'Modèle',
  'dsManager.sourceAria': 'Source du système de design',
  'dsManager.templateSourceAria': 'Source du modèle',
  'dsManager.yourSystems': 'Vos systèmes',
  'dsManager.officialPresets': 'Préréglages officiels',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Synchroniser avec l\'équipe',
  'dsManager.syncToTeamFailed': 'Impossible de synchroniser avec l\'équipe',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Entreprise',
  'dsManager.yourTemplates': 'Vos modèles',
  'dsManager.yourSystemsAria': 'Vos systèmes de design',
  'dsManager.eyebrowDesignSystems': 'Systèmes de design',
  'dsManager.yourSystemsHeading': 'Vos systèmes',
  'dsManager.filterAria': 'Filtrer les systèmes de design',
  'dsManager.filterAll': 'Tous',
  'dsManager.filterPublished': 'Publiés',
  'dsManager.filterDraft': 'Brouillon',
  'dsManager.createTitle': 'Créer un nouveau système de design',
  'dsManager.createBody': 'Apprenez à Open Design votre marque, votre produit, votre code, vos ressources et vos références de design.',
  'dsManager.createAction': 'Créer',
  'dsManager.emptyMine': 'Aucun système de design pour l\'instant. Créez-en un à partir d\'un contexte produit réel, examinez le brouillon, puis publiez-le pour vos futurs projets.',
  'dsManager.badgeDefault': 'Par défaut',
  'dsManager.rowMetaUpdated': 'Vous · mis à jour le {date}',
  'dsManager.edit': 'Modifier',
  'dsManager.openSystem': 'Ouvrir',
  'dsManager.editWithAgent': 'Modifier avec Agent',
  'dsManager.downloadTitle': 'Télécharger le système de design (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Télécharger {title} en .zip',
  'dsManager.downloadFailed': 'Impossible de télécharger le système de design. Veuillez réessayer.',
  'dsManager.deleteConfirm': 'Supprimer « {title} » ? Cela supprime le brouillon du système de design de cet appareil.',
  'dsManager.makeDefault': 'Définir par défaut',
  'dsManager.statusPublished': 'Publié',
  'dsManager.statusDraft': 'Brouillon',
  'dsManager.openSystemAria': 'Ouvrir {title}',
  'dsManager.deleteSystemAria': 'Supprimer {title}',
  'dsManager.deletePermissionDenied': 'Vous n’avez pas l’autorisation de supprimer ce système de design.',
  'dsManager.presetsAria': 'Préréglages officiels de systèmes de design',
  'dsManager.eyebrowLibrary': 'Bibliothèque',
  'dsManager.eyebrowTemplates': 'Modèles',
  'dsManager.yourTemplatesAria': 'Vos modèles',
  'dsManager.emptyTemplates': 'Aucun modèle pour l\'instant. Créez-en un à partir de n\'importe quel projet généré via Partager une fois la publication de modèles activée.',
  'dsManager.templateDescFallback': 'Créé à partir d\'un projet',
  'dsManager.comingSoonBadge': 'Bientôt disponible',
  'dsManager.enterpriseDsTitle': 'Systèmes de design d\'entreprise',
  'dsManager.enterpriseDsBody': 'Les systèmes de design partagés par les équipes et les bibliothèques de marque gouvernées arrivent bientôt.',
  'dsManager.enterpriseTplTitle': 'Modèles d\'entreprise',
  'dsManager.enterpriseTplBody': 'Les modèles approuvés par l\'équipe et la publication à l\'échelle de l\'organisation arrivent bientôt.',
  'settings.instructionsTitle': 'Instructions et règles',
  'settings.instructionsSubtitle': 'Comportement fixe que l\'assistant doit suivre',
  'settings.instructionsNavSub': 'Comportement fixe de l\'assistant',
  'settings.customInstructionsDesc': 'Instructions fixes qu\'Open Design suit dans chaque conversation. Ce ne sont pas des mémoires enregistrées ; utilisez Mémoire pour les faits, les préférences et le contexte de projet.',
  'mcpClient.forwardedToLabel': 'Transféré vers :',
  'mcpClient.notForwardedToLabel': 'Non transféré vers :',
  'mcpClient.forwardedAcpNote': 'Les adaptateurs ACP marqués stdio ne reçoivent que les serveurs MCP stdio de cette liste ; les entrées HTTP et SSE sont abandonnées au lancement.',
  'mcpClient.notForwardedNote': 'Pour ces agents, configurez les serveurs MCP dans le fichier de configuration propre à l\'agent (par ex. ~/.codex/config.toml, ~/.gemini/settings.json) ; les serveurs ci-dessous y sont inutilisés sans avertissement.',

  // Brands library + extraction
  'brand.libraryTitle': 'Système de design',
  'brand.librarySubtitle': 'Ajoutez vos systèmes de design à Open Design : extrayez-en un depuis un site web, puis appliquez-le dans n’importe quel chat.',
  'brand.newBrand': 'Nouveau système de design',
  'brand.searchPlaceholder': 'Rechercher dans vos systèmes de design…',
  'brand.empty': 'Aucun système de design pour le moment. Extrayez-en un depuis un site web pour commencer.',
  'brand.colorsCount': '{count} couleurs',
  'brand.extracting': 'Extraction…',
  'brand.failed': 'Échec de l’extraction',
  'brand.needsInput': 'Action requise',
  'brand.needsInputHint': 'Extraction en pause — ouvrez le projet pour terminer la vérification ou répondre à la question.',
  'brand.appliedToChat': 'Utilisation de {name}',
  'brand.previewEmpty': 'Sélectionnez un système de design à prévisualiser',
  'brand.viewDetails': 'Voir les détails',
  'newBrand.title': 'Nouveau système de design',
  'newBrand.subtitle': 'Collez un site web, ou choisissez une marque ci-dessous, et nous en extrairons les couleurs, polices et le logo.',
  'newBrand.urlLabel': 'Site web de la marque',
  'newBrand.urlPlaceholder': 'votreentreprise.com',
  'newBrand.extract': 'Extraire le système de design',
  'newBrand.cancel': 'Annuler',
  'newBrand.close': 'Fermer',
  'newBrand.stage1': 'Récupération du site et analyse de son design',
  'newBrand.stage2': 'Création d’un aperçu du système de design',
  'newBrand.stage3': 'Génération et enregistrement du système de design',
  'newBrand.measured': '{colors} couleurs · {fonts} polices · {logos} logos',
  'newBrand.done': 'Système de design prêt',
  'brandDetail.identity': 'Identité',
  'brandDetail.designLanguage': 'Langage de design',
  'brandDetail.colors': 'Couleurs',
  'brandDetail.fonts': 'Polices',
  'brandDetail.tone': 'Ton',
  'brandDetail.aesthetic': 'Esthétique',
  'brandDetail.tagline': 'Slogan',
  'brandDetail.voice': 'Voix',
  'brandDetail.useInChat': 'Utiliser dans un nouveau chat',
  'brandDetail.delete': 'Supprimer le système de design',
  'brandDetail.back': 'Système de design',
  'brandDetail.refining': 'Affinage de ce système de design…',
  'brandDetail.notFound': 'Système de design introuvable.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typographie',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voix et ton',
  'brandDetail.imageryLayout': 'Images et mise en page',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Système de design',
  'brandDetail.brandAssets': 'Ressources du système de design',
  'brandDetail.openProject': 'Ouvrir le projet',
  'brandDetail.themeLight': 'Clair',
  'brandDetail.themeDark': 'Sombre',
  'brandDetail.subjects': 'Sujets',
  'brandDetail.treatment': 'Traitement',
  'brandDetail.useLabel': 'Utiliser',
  'brandDetail.avoidLabel': 'Éviter',
  'brandDetail.layoutPosture': 'Approche de mise en page',
  'brandDetail.deleteConfirm': 'Supprimer « {name} » ? Cela supprimera le système de design.',
  'brandDetail.viewMore': 'Tout afficher ({count})',
  'brandDetail.viewLess': 'Afficher moins',
  'settings.resetOnboarding': 'Réinitialiser la configuration initiale',
  'settings.resetOnboardingDesc': 'Relancez la configuration initiale, y compris l’extraction de marque.',
  'settings.resetOnboardingButton': 'Réinitialiser',
  'settings.clearUpdaterCacheTitle': 'Vider le cache de mise à jour',
  'settings.clearUpdaterCacheHint': 'Supprime les mises à jour téléchargées et les caches obsolètes, puis réinitialise l\'état de mise à jour. À utiliser lorsque les mises à jour semblent bloquées.',
  'settings.clearUpdaterCacheButton': 'Vider le cache',
  'settings.clearUpdaterCacheConfirmButton': 'Confirmer le vidage',
  'settings.clearUpdaterCacheSuccess': 'Cache de mise à jour vidé.',
  'settings.clearUpdaterCacheFailed': 'Impossible de vider le cache de mise à jour.',
  'onboarding.brandTitle': 'Extraire votre système de design',
  'onboarding.brandSubtitle': 'Collez un site web et nous transformerons ses signaux de marque en système de design réutilisable pour vos prochains travaux.',
  'onboarding.brandSkip': 'Ignorer',
  'onboarding.brandDone': 'Système de design extrait',
  'onboarding.buildTitle': 'Créez une fois, construisez partout',
  'onboarding.buildBody': 'Open Design transforme votre marque en un système de design réutilisable, puis garde tout ce que vous créez cohérent et fidèle à la marque.',
  'onboarding.buildBenefitMemoryTitle': 'Une mémoire de marque unique',
  'onboarding.buildBenefitMemoryBody': 'Les couleurs, la typographie, l’espacement, les composants et la voix deviennent un DESIGN.md réutilisable par vos agents.',
  'onboarding.buildBenefitAlignedTitle': 'Chaque sortie reste alignée',
  'onboarding.buildBenefitAlignedBody': 'Prototypes, diapositives, PDF, tableaux de bord et contenus marketing s’appuient tous sur les mêmes règles.',
  'onboarding.buildBenefitSourcesTitle': 'Partez de ce que vous avez déjà',
  'onboarding.buildBenefitSourcesBody': 'Utilisez un dépôt GitHub, un site web, un DESIGN.md existant, des captures d’écran, des polices ou des fichiers Figma.',
  'onboarding.buildPreviewLabel': 'Système de marque',
  'onboarding.buildStart': 'Créer un système de design',
  'onboarding.buildHome': 'Aller à l’accueil',
  'dsCreate.referenceLabel': 'Copier depuis un système de design existant',
  'dsCreate.referenceLoading': 'Chargement du DESIGN.md…',
  'dsCreate.referenceLoadFailed': 'Impossible de charger ce système de design.',
  'dsCreate.heroShowGuideAria': 'Afficher le guide du système de design',
  'dsCreate.heroHideGuideAria': 'Masquer le guide du système de design',
  'dsCreate.heroShowGuideTitle': 'Afficher le guide',
  'dsCreate.heroHideGuideTitle': 'Masquer le guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Ajoutez un site web, un DESIGN.md, une description, un fichier, une source Figma ou des notes pour créer un système de design.',
  'dsCreate.continueToGeneration': 'Continuer vers la génération',
  'dsCreate.embeddedTitle': 'Générer depuis vos sources',
  'dsCreate.embeddedBody': 'Commencez avec un site web ou une référence de marque, puis ajoutez les fichiers source que vous avez déjà.',
  'dsCreate.sourceSectionTitle': 'Extraire depuis GitHub, des sites web ou des sources',
  'dsCreate.sourceSectionBody': 'Commencez avec un dépôt GitHub, un site web, un DESIGN.md ou des fichiers qui montrent votre style. Open Design crée d’abord rapidement un système utilisable, puis l’IA peut l’affiner dans le projet.',
  'dsCreate.githubWebsiteLabel': 'GitHub ou site web',
  'dsCreate.add': 'Ajouter',
  'dsCreate.startFromBrand': 'Commencer depuis une marque',
  'dsCreate.brandPickerSubtitle': 'Recherchez parmi des centaines de marques — choisissez-en une et nous ajouterons son site comme référence de style.',
  'dsCreate.brandPickerQuickPicks': 'Marques populaires — cliquez pour ajouter',
  'dsCreate.addedSourceLinks': 'Liens source ajoutés',
  'dsCreate.openSourceLabel': 'Ouvrir {label}',
  'dsCreate.removeSourceLabel': 'Retirer {label}',
  'dsCreate.addFiles': 'Ajouter des fichiers',
  'dsCreate.describeBrand': 'Décrire la marque',
  'dsCreate.optional': 'facultatif',
  'dsCreate.describeBrandHelp': 'Voix de marque, introduction et contexte produit. Utilisés dans la passe rapide et l’affinage IA.',
  'dsCreate.companyPlaceholder': 'ex. Mission Impastabowl : restaurant de pâtes fast-casual avec borne, app mobile et site web',
  'dsCreate.pasteDesignMd': 'Coller DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Collez un DESIGN.md pour créer directement depuis les tokens, la logique et les consignes de composants.',
  'dsCreate.reference': 'Référence',
  'dsCreate.designMdViewMode': 'Mode d’affichage DESIGN.md',
  'dsCreate.advancedToggle': 'Avancé — dépôt, code local, Figma',
  'dsCreate.githubRepo': 'Dépôt GitHub',
  'dsCreate.localCodeLabel': 'Lier du code local',
  'dsCreate.localCodeHelper': 'Utilisez un dossier ou des fichiers sélectionnés depuis cet ordinateur.',
  'dsCreate.localCodePrompt': 'Déposez un dossier ici ou parcourez',
  'dsCreate.uploadFigLabel': 'Importer un .fig',
  'dsCreate.uploadFigHelper': 'Décodé sur votre machine en vrais tokens, composants et assets — sans compte Figma.',
  'dsCreate.uploadFigPrompt': 'Déposez un .fig ici ou parcourez',
  'dsCreate.figmaUrl': 'URL Figma',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'URLs Figma ajoutées',
  'dsCreate.savedFigmaHelp': 'Source de design Figma enregistrée. L’agent l’utilise comme référence canonique ; exportez un .fig ci-dessus pour un décodage hors ligne complet.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'ex. Nous utilisons une palette chaude et terreuse avec des coins arrondis. Notre voix de marque est ludique mais professionnelle…',
  'dsCreate.back': 'Retour',
  'dsCreate.generate': 'Générer',
  'dsCreate.libraryPickerTitle': 'Sélectionner depuis la bibliothèque',
  'dsCreate.libraryPickerConfirm': 'Ajouter aux assets',
  'dsCreate.designMdPreviewKicker': 'SYSTÈME DE DESIGN',
  'dsCreate.designMdPreviewTitle': 'Aperçu DESIGN.md',
  'dsCreate.componentKit': 'kit de composants',
  'dsCreate.defaultTheme': 'thème par défaut',
  'dsCreate.componentKitTitle': '{name} — kit de composants',
  'dsCreate.designMdGeneratedDescription': 'Généré depuis les tokens DESIGN.md collés, la logique et les consignes de composants.',
  'dsCreate.previewButtons': 'Boutons',
  'dsCreate.previewButtonsHelp': 'Cinq types en trois tailles.',
  'dsCreate.buttonPrimary': 'Principal',
  'dsCreate.buttonDashed': 'Pointillé',
  'dsCreate.buttonText': 'Texte',
  'dsCreate.buttonLink': 'Lien',
  'dsCreate.sizeSmall': 'Petit',
  'dsCreate.sizeMedium': 'Moyen',
  'dsCreate.sizeLarge': 'Grand',
  'dsCreate.previewTypeScale': 'Échelle typographique',
  'dsCreate.extractedTokens': 'Tokens DESIGN.md extraits',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Partez d\'une marque que vous aimez',
  'brandPicker.subtext': 'Cliquez sur une marque pour extraire son kit directement depuis son site web.',
  'brandPicker.quickPicksLabel': 'Marques populaires – cliquez pour extraire',
  'brandPicker.searchPlaceholder': 'Rechercher des marques…',
  'brandPicker.allCategories': 'Toutes',
  'brandPicker.extractAction': 'Extraire',
  'brandPicker.showMore': 'Afficher plus',
  'brandPicker.opening': 'Démarrage de l\'extraction — ouverture de {brand}…',
  'ds.kitVisualize': 'Visualiser',
  'ds.kitEdit': 'Éditer',
  'ds.kitSource': 'Source',
  'ds.saveDesignMd': 'Enregistrer DESIGN.md',
  'ds.saving': 'Enregistrement…',
  'ds.copyDesignMd': 'Copier DESIGN.md',
  'ds.editDesignMd': 'Modifier DESIGN.md',
  'ds.openDesignMd': 'Ouvrir DESIGN.md',
  'ds.copyDesignMdModule': 'Copier la section {module}',
  'ds.editDesignMdModule': 'Modifier la section {module}',
  'ds.openDesignMdModule': 'Ouvrir la section {module}',
  'ds.uploadMd': 'Importer MD',
  'ds.uploadFont': 'Ajouter un fichier de police',
  'ds.pasteImage': 'Coller une image',
  'ds.refresh': 'Actualiser',
  'ds.download': 'Télécharger',
  'ds.importFolder': 'Importer un dossier',
  'ds.reset': 'Réinitialiser',
  'ds.editingDesignMdHint': 'Modifier ce Markdown met à jour les modules du kit rendu.',
  'ds.editingModuleHint': 'Seul le module {module} est modifié.',
  'ds.manualEditModuleHint': 'Modifiez {module} ici. Survolez cette section pour afficher les contrôles.',
  'ds.saveModule': 'Enregistrer le module',
  'ds.uploadLogo': 'Importer un logo',
  'ds.uploadImage': 'Importer une image',
  'ds.uploading': 'Import…',
  'ds.moduleEmptyLogo': 'Aucun logo pour le moment',
  'ds.moduleEmptyFonts': 'Aucune police capturée.',
  'ds.actionDone': 'Terminé',
  'ds.actionFailed': 'Une erreur est survenue. Veuillez réessayer.',
  'ds.uploadDone': 'Importé',
  'ds.uploadFailed': 'Échec de l’import. Veuillez réessayer.',
  'ds.deleteLogo': 'Supprimer le logo',
  'ds.deleteImage': 'Supprimer {caption}',
  'ds.deleteProjectConfirm': 'Supprimer « {title} » ? Cela supprime définitivement ce système de design et son projet de cet appareil.',
  'ds.deleteProjectAction': 'Supprimer {title}',
  'ds.editColor': 'Modifier {name}',
  'ds.colorLabel': 'Couleur',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Valeur Hex',
  'ds.saveColor': 'Enregistrer la couleur',
  'ds.invalidHexColor': 'Saisissez une couleur Hex valide, par exemple #FF6A3D.',
  'ds.colorSaveFailed': 'Impossible d’enregistrer cette couleur.',
  'ds.colorResetFailed': 'Impossible de réinitialiser cette couleur.',
  'ds.designMdSectionLabel': 'Section {module} de DESIGN.md',
  'ds.kitErrorTitle': 'Cette vue a rencontré un problème.',
  'ds.kitErrorRetry': 'Recharger',
  'ds.shortcutsLabel': 'Raccourcis clavier',
  'ds.shortcutsHint': 'Raccourcis : E modifier · C copier · U téléverser · R actualiser · ⌫ supprimer le logo',
  'ds.moduleEmptyImages': 'Aucune image pour le moment',
  'ds.noOriginalColor': 'Aucune couleur d’origine n’est disponible pour cet échantillon.',
  'ds.manifestReadFailed': 'Impossible de lire _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Réduire {title}',
  'ds.reviewExpandSection': 'Développer {title}',
  'ds.reviewNeedsReview': 'À vérifier',
  'ds.reviewLooksGood': 'Ça semble correct',
  'ds.reviewActionsLabel': 'Revue de {title}',
  'ds.reviewNeedsWorkEllipsis': 'À retravailler…',
  'ds.reviewEditFile': 'Modifier {file}',
  'ds.reviewFeedbackLabel': 'Dites à l’agent quoi changer',
  'ds.reviewFeedbackPlaceholder': 'ex. resserrer l’espacement dans {title}, régénérer cet aperçu…',
  'ds.reviewChangedAfterFeedback': 'Cette section a changé après votre feedback. Vérifiez-la à nouveau avant de publier.',
  'ds.reviewChangedDuringRun': 'Cette section a changé pendant la dernière exécution. Vérifiez-la avant de publier.',
  'ds.reviewLastFeedback': 'Dernier feedback',
  'ds.previewGenerating': 'Génération de l’aperçu…',
  'ds.creatingProjectTitle': 'Création de votre système de design…',
  'ds.creatingProjectSubtitle': 'Gardez cet onglet ouvert. Vous pourrez revenir dans quelques minutes.',
  'ds.generationProgressLabel': 'Progression de la génération du système de design : {progress} %',
  'ds.publishRepoRequiredTitle': 'Terminez l’import de votre dépôt GitHub avant de pouvoir publier.',
  'ds.publishDesignSystem': 'Publier le système de design',
  'ds.unpublishDesignSystem': 'Dépublier le système de design',
  'ds.published': 'Publié',
  'ds.publish': 'Publier',
  'ds.extractionRunningTitle': 'Extraction du système de design',
  'ds.extractionCompleteTitle': 'Extraction terminée',
  'ds.extractionRunningBody': 'Open Design met à jour ce système sur place.',
  'ds.extractionCompleteBody': 'Tous les modules extraits sont affichés ci-dessous ; les sections vides sont intentionnellement laissées vides.',
  'ds.publishCardPublished': 'Les nouveaux projets de votre équipe peuvent utiliser ce système de design comme contexte par défaut.',
  'ds.publishCardDraft': 'Votre système de design est prêt, mais votre feedback l’améliorera. Publiez-le lorsqu’il est prêt à être utilisé dans de futurs projets.',
  'ds.useSystemTitle': 'Utiliser ce système',
  'ds.useSystemBody': 'Commencez un nouveau design qui hérite des couleurs, de la typographie et des composants de ce système — automatiquement fidèle à la marque.',
  'ds.createNewDesign': 'Créer un nouveau design',
  'ds.openSourceContext': 'Ouvrir le contexte source',
  'ds.manifestNeedsAttention': 'Le manifeste de design demande votre attention',
  'ds.openManifest': 'Ouvrir le manifeste',
  'ds.workspacePreparing': 'Préparation de l’espace de travail du système de design.',
  'ds.workspaceLoadingLabel': 'Chargement de l’espace de travail du système de design',
  'ds.sectionQueued': 'En file d’attente',
  'ds.sectionReviewUpdatedFiles': 'Fichiers mis à jour à vérifier',
  'ds.reviewNeedsWork': 'À retravailler',
  'ds.sectionRequiredFileMissing': 'Fichier requis manquant : {file}',
  'ds.sectionNoFilesYet': 'Aucun fichier pour le moment',
  'ds.generationSourceTitle': 'Contexte source',
  'ds.generationSourceDetail': 'Lecture du contexte source lié et des preuves du dépôt.',
  'ds.generationGuidanceTitle': 'Consignes de marque',
  'ds.generationGuidanceDetail': 'Rédaction des consignes DESIGN.md et de la voix.',
  'ds.generationTokensTitle': 'Tokens de design',
  'ds.generationTokensDetail': 'Extraction des tokens de couleur, typographie et espacement.',
  'ds.generationPreviewsTitle': 'Cartes d’aperçu',
  'ds.generationPreviewsDetail': 'Rendu de cartes d’aperçu vérifiables.',
  'ds.generationUiKitTitle': 'Kit UI',
  'ds.generationUiKitDetail': 'Création de composants et motifs réutilisables.',
  'ds.generationAssetsTitle': 'Assets de marque',
  'ds.generationAssetsDetail': 'Collecte des logos, polices, images et icônes.',
  'ds.phaseQueuedTypography': 'Typographie en file d’attente',
  'ds.phaseQueuedTokens': 'Tokens en file d’attente',
  'ds.phaseQueuedSpacing': 'Espacement en file d’attente',
  'ds.phaseQueuedUiKit': 'Kit UI en file d’attente',
  'ds.phaseQueuedAssets': 'Assets en file d’attente',
  'ds.phaseReadingTypography': 'Lecture de la typographie',
  'ds.phaseReadingTokens': 'Lecture des tokens',
  'ds.phaseReadingSpacing': 'Lecture de l’espacement',
  'ds.phaseReadingUiKit': 'Lecture du kit UI',
  'ds.phaseReadingAssets': 'Lecture des assets',
  'ds.phaseWritingTypography': 'Écriture de la typographie',
  'ds.phaseWritingTokens': 'Écriture des tokens',
  'ds.phaseWritingSpacing': 'Écriture de l’espacement',
  'ds.phaseBuildingUiKit': 'Construction du kit UI',
  'ds.phaseUpdatingAssets': 'Mise à jour des assets',
  'ds.phaseNeedsAttention': 'Attention requise',
  'ds.phaseUpdated': 'Mis à jour',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Lecture de {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Lecture du contexte pour {title}.',
  'ds.sectionRunningNow': '{phase} en cours.',
  'ds.reviewLastReviewed': 'Dernière vérification : {time}',
  'ds.agentFeedbackQueued': 'Feedback pour l’agent en file d’attente.',
  'ds.agentFeedbackSent': 'Feedback envoyé à l’agent.',
  'ds.agentFeedbackSentAt': 'Feedback envoyé à l’agent à {time}.',
  'ds.agentFeedbackFailedWithError': 'Échec de l’envoi du feedback à l’agent : {error}',
  'ds.agentFeedbackFailed': 'Échec de l’envoi du feedback à l’agent',
  'ds.agentFeedbackUnknown': 'Statut de l’envoi du feedback inconnu',
  'ds.repoConnectBannerTitle': 'Connectez votre dépôt pour extraire des éléments de votre système de design',
  'ds.repoConnectCardTitle': 'Connecter votre dépôt',
  'ds.repoConnectPendingBody': 'Vérification de votre connexion GitHub…',
  'ds.repoConnectPendingButton': 'Vérification de GitHub…',
  'ds.repoConnectedTitle': 'GitHub est connecté',
  'ds.repoConnectedBody': 'Réimportez ce dépôt pour intégrer ses fichiers à votre système de design.',
  'ds.repoImportButton': 'Importer le dépôt',
  'ds.repoConnectBannerBody': 'Connectez GitHub pour qu’Open Design puisse lire votre dépôt et extraire couleurs, typographie et composants dans ce système de design.',
  'ds.repoConnectCardBody': 'Extrayez couleurs, typographie et composants de votre dépôt dans ce système de design.',
  'ds.repoConnectButton': 'Connecter GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Point de départ',
  'newproj.startBlank': 'Vierge',
  'newproj.startBlankHint': 'Partir de zéro',
  'workspace.pages': 'Pages',
  'workspace.allProjectFiles': 'Tous les fichiers du projet',
  'workspace.newBlankPage': 'Nouvelle page vierge',
  'workspace.noPagesYet': 'Aucune page pour le moment',
  'workspace.pageCreateFailed': 'Impossible de créer la page.',
  'workspace.pageCreatorTitle': 'Créer une page',
  'workspace.pageCreatorSearch': 'Rechercher des modèles',
  'workspace.pageCreatorCategoryAll': 'Tous les scénarios',
  'workspace.pageCreatorEmpty': 'Aucun type de page ne correspond à votre recherche.',
  'workspace.pageCreatorPreview': 'Aperçu',
  'workspace.pageCreatorUse': 'Utiliser',
  'fileViewer.presentInTabDeckHint': 'Notes de présentation dans une fenêtre popup',
  'fileViewer.presentEscHint': 'Appuyez sur Échap pour quitter',
  'fileViewer.presenterPause': 'Pause',
  'fileViewer.presenterResume': 'Reprendre',
  'fileViewer.presenterPrevious': 'Précédente',
  'fileViewer.presenterNext': 'Suivante',
  'questions.uploadingFiles': 'Envoi des fichiers…',
  'questions.uploadNeedsProject': 'L’envoi de fichiers nécessite un projet actif.',
  'questions.uploadPartialFailed': '{uploaded} fichier(s) envoyé(s), mais {failed} en échec.',
  'questions.uploadFailed': 'Échec de l’envoi de {failed} fichier(s).',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.usePrompt': 'Utiliser le prompt',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the Open Design Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the Open Design Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and Open Design will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'Open Design will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant Open Design access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions / Rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'Open Design will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'Open Design account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by Open Design; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'Open Design is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'Open Design is rebuilding tokens',
  'dsFlow.jobRevising': 'Open Design is revising',
  'dsFlow.jobStillWorking': 'Open Design is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask Open Design to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'Open Design is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'Open Design is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'Open Design is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'Open Design is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'Open Design official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
};
